// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27rgba%280, 0, 0, 0.55%29%27%3E%3Cpath d=%27m9 14 3 3 3-3m-6-4 3-3 3 3%27 fill=%27none%27 fill-rule=%27evenodd%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke=%27currentcolor%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2724%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27rgba%280, 0, 0, 0.55%29%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27 stroke-width=%271.5%27 stroke=%27currentcolor%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%275.25%27/%3E%3Cpath d=%27M18.25 18.25 15 15%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 color=%27%23212123%27 fill=%27rgba%280, 0, 0, 0.15%29%27%3E%3Cpath fill=%27currentColor%27 fill-rule=%27evenodd%27 d=%27M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM9.53 8.47a.75.75 0 0 0-1.06 1.06L10.939 12l-2.47 2.47a.75.75 0 0 0 1.061 1.06L12 13.061l2.47 2.47a.75.75 0 0 0 1.06-1.061L13.061 12l2.47-2.47a.75.75 0 0 0-1.061-1.06L12 10.939Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23FFF%27%3E%3Cpath stroke=%27currentcolor%27 stroke-width=%271.5%27 d=%27M4 8.8 6.4 12 12 4%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27rgba%280, 0, 0, 0.3%29%27%3E%3Cpath stroke=%27currentcolor%27 stroke-width=%271.5%27 d=%27M4 8.8 6.4 12 12 4%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27%3E%3Ccircle cx=%278%27 cy=%278%27 fill-rule=%27evenodd%27 r=%273%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27rgba%280, 0, 0, 0.3%29%27%3E%3Ccircle cx=%278%27 cy=%278%27 fill-rule=%27evenodd%27 r=%273%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cdefs%3E%3CradialGradient id=%27a%27 cx=%2797.483%25%27 cy=%2728.573%25%27 r=%27168.336%25%27 fx=%2797.483%25%27 fy=%2728.573%25%27 gradientTransform=%27matrix%28.9983 -.05822 .02352 .40335 -.005 .227%29%27%3E%3Cstop stop-color=%27%23FFF%27 offset=%270%25%27/%3E%3Cstop stop-color=%27%23FFF%27 stop-opacity=%27.816%27 offset=%2718.426%25%27/%3E%3Cstop stop-color=%27%23FFF%27 stop-opacity=%270%27 offset=%27100%25%27/%3E%3C/radialGradient%3E%3C/defs%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cpath d=%27M0 0h24v24H0z%27/%3E%3Cpath stroke=%27url%28%23a%29%27 stroke-width=%272%27 d=%27M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11z%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-dasharray=%2748.33 69.117%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23FFF%27%3E%3Cpath d=%27M12.5 11.086 6.457 5.043a1 1 0 0 0-1.414 1.414l6.043 6.043-6.043 6.043a1 1 0 0 0 1.414 1.414l6.043-6.043 6.043 6.043a1 1 0 0 0 1.414-1.414L13.914 12.5l6.043-6.043a1 1 0 0 0-1.414-1.414L12.5 11.086z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23FFF%27%3E%3Cpath d=%27M3.707 11.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l12-12a1 1 0 0 0-1.414-1.414L9 16.586l-5.293-5.293z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2732%27 height=%2732%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cpath d=%27m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a.8.8 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272z%27 fill=%27currentcolor%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2732%27 height=%2732%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23EBEBEB%27%3E%3Cpath d=%27m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a.8.8 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272z%27 fill=%27currentcolor%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cpath d=%27m.304 9.113 5.05-6.427a.6.6 0 0 1 .38-.222l6.175-.95a.6.6 0 0 1 .182 0l6.175.95a.6.6 0 0 1 .38.222l5.05 6.427a.6.6 0 0 1-.017.76L12.342 23.102a.45.45 0 0 1-.684 0L.321 9.874a.6.6 0 0 1-.017-.761zm13.272-5.158 4.334 4a.3.3 0 0 0 .501-.254l-.304-2.74a.15.15 0 0 1 .286-.077l1.464 3.294a.8.8 0 0 0 .478.434l1.788.596a.15.15 0 0 1-.047.292h-1.638a.8.8 0 0 0-.674.369l-6.438 10.059a.15.15 0 0 1-.261-.146l4.591-9.566a.5.5 0 0 0-.45-.716H6.794a.5.5 0 0 0-.451.716l4.591 9.566a.15.15 0 0 1-.261.146L4.236 9.868a.8.8 0 0 0-.674-.368H1.924a.15.15 0 0 1-.047-.292l1.788-.596a.8.8 0 0 0 .478-.434l1.464-3.294a.15.15 0 0 1 .286.078l-.304 2.74a.3.3 0 0 0 .501.253l4.334-4a.15.15 0 0 1 .218.205L7.9 7.51a.3.3 0 0 0 .232.49h7.734a.3.3 0 0 0 .232-.49l-2.74-3.35a.15.15 0 0 1 .217-.205z%27 fill=%27currentcolor%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 fill-rule=%27evenodd%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 color=%27%23FFF%27%3E%3Cg stroke=%27currentColor%27%3E%3Cpath d=%27m6 6 12 12M18 6 6 18%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27rgba%280, 0, 0, 0.48%29%27%3E%3Cg stroke=%27currentColor%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m9 8-4 4 4 4M6.5 12h9%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27%23212123%27%3E%3Cpath fill=%27currentColor%27 fill-rule=%27evenodd%27 d=%27M2.025 9.429 6.32 3.674a.129.129 0 0 1 .088-.05L11.986 3a.129.129 0 0 1 .028 0l5.577.622a.129.129 0 0 1 .088.051l4.296 5.755a.129.129 0 0 1-.006.161l-9.872 11.365a.129.129 0 0 1-.194 0L2.03 9.59a.129.129 0 0 1-.006-.161Zm11.108-5.193 3.943 3.78a.129.129 0 0 0 .217-.092V4.826a.088.088 0 0 1 .174-.023l.984 3.644a.129.129 0 0 0 .088.09l2.289.677a.088.088 0 0 1-.025.173h-2.188a.257.257 0 0 0-.22.124l-5.542 9.2a.088.088 0 0 1-.156-.083l4.132-8.875a.257.257 0 0 0-.233-.366H7.402a.257.257 0 0 0-.233.366l4.132 8.875a.088.088 0 0 1-.156.083l-5.542-9.2a.257.257 0 0 0-.22-.124H3.195a.088.088 0 0 1-.025-.173l2.29-.678a.129.129 0 0 0 .087-.09l.984-3.643a.088.088 0 0 1 .174.023v3.098a.129.129 0 0 0 .217.093l3.944-3.78a.088.088 0 0 1 .13.118L8.05 8.016a.129.129 0 0 0 .1.21h7.698a.129.129 0 0 0 .1-.21l-2.944-3.66a.088.088 0 0 1 .13-.12Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2712%27 width=%2712%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23ff7843%27%3E%3Ccircle cx=%276%27 cy=%276%27 fill=%27none%27 r=%272.5%27 stroke=%27currentColor%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2716%27 width=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23FFF%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27 stroke=%27currentColor%27 stroke-linecap=%27round%27 stroke-width=%271.5%27%3E%3Cpath d=%27M2.5 8.169c0 1.208.22 2.127.634 2.901a4.316 4.316 0 0 0 1.796 1.796c.774.414 1.693.634 2.901.634h.338c1.208 0 2.127-.22 2.901-.634a4.316 4.316 0 0 0 1.796-1.796c.414-.774.634-1.693.634-2.901V7.83c0-1.208-.22-2.127-.634-2.901a4.316 4.316 0 0 0-1.796-1.796C10.296 2.72 9.377 2.5 8.169 2.5H7.83c-1.208 0-2.127.22-2.901.634A4.316 4.316 0 0 0 3.134 4.93%27/%3E%3Cpath d=%27M6.5 5.25H3v-3.5%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2724%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cpath d=%27m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z%27 fill-opacity=%27.15%27 fill-rule=%27evenodd%27 fill=%27currentColor%27 stroke=%27currentColor%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2732%27 width=%2732%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cpath d=%27m10.223 24.208 13.638-7.327a1 1 0 0 0 0-1.762L10.223 7.792a1 1 0 0 0-1.473.88v14.655a1 1 0 0 0 1.473.881z%27 fill-opacity=%27.15%27 stroke=%27%23000%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2724%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23FFF%27%3E%3Cpath d=%27m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z%27 fill-opacity=%27.15%27 fill-rule=%27evenodd%27 fill=%27currentColor%27 stroke=%27currentColor%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2724%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23FFF%27%3E%3Cpath d=%27m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z%27 fill-rule=%27evenodd%27 fill=%27currentColor%27 stroke=%27currentColor%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 stroke=%27rgba%2833, 33, 35, 0.7%29%27%3E%3Cpath fill=%27none%27 stroke=%27currentColor%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-opacity=%27.32%27 stroke-width=%271.5%27 d=%27m6.5 12 4-4-4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2724%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27 stroke-width=%271.5%27 stroke=%27currentcolor%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%275.25%27/%3E%3Cpath d=%27M18.25 18.25 15 15%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2716%27 width=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23212123%27%3E%3Cg stroke=%27currentcolor%27 stroke-width=%271.5%27 fill=%27none%27 fill-rule=%27evenodd%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m4 4 8 8M12 4l-8 8%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg height=%2716%27 width=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23FFF%27%3E%3Cg stroke=%27currentcolor%27 stroke-width=%271.5%27 fill=%27none%27 fill-rule=%27evenodd%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m4 4 8 8M12 4l-8 8%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23000%27%3E%3Cpath d=%27m13 8 4 4-4 4m2.5-4h-9%27 stroke=%27currentcolor%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23f26725%27 fill=%27none%27%3E%3Cmask id=%27a%27 fill=%27%23fff%27%3E%3Cpath d=%27m7.677 1.646-4.963 6.09a.417.417 0 0 0 0 .527l4.963 6.09a.417.417 0 0 0 .646 0l4.963-6.09a.417.417 0 0 0 0-.526l-4.963-6.09a.417.417 0 0 0-.646 0Z%27/%3E%3C/mask%3E%3Cpath stroke=%27currentColor%27 stroke-width=%271.5%27 stroke-linejoin=%27round%27 d=%27m7.677 1.646-4.963 6.09a.417.417 0 0 0 0 .527l4.963 6.09a.417.417 0 0 0 .646 0l4.963-6.09a.417.417 0 0 0 0-.526l-4.963-6.09a.417.417 0 0 0-.646 0Z%27/%3E%3Cpath fill-opacity=%27.15%27 fill=%27currentColor%27 mask=%27url%28%23a%29%27 d=%27M8 1.333h5.833v13.333H8z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.pricing-box {
    background-color: #fff;
    border-radius: 30px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    padding: 0px 120px 20px;
    margin: 50px 150px 0px;
}

.flex {
    display: flex
}

.inline-flex {
    display: inline-flex
}

.flex-row {
    flex-direction: row
}

.flex-col {
    flex-direction: column
}

.items-start {
    align-items: flex-start
}

.items-end {
    align-items: flex-end
}

.items-center {
    align-items: center
}

.items-baseline {
    align-items: baseline
}

.items-stretch {
    align-items: stretch
}

.justify-between {
    justify-content: space-between
}

.justify-around {
    justify-content: space-around
}

.justify-center {
    justify-content: center
}

.justify-start {
    justify-content: flex-start
}

.justify-end {
    justify-content: flex-end
}

.flex-1 {
    flex: 1 1
}

.flex-auto {
    flex: 1 1 auto
}

.flex-none {
    flex: none
}

.text-center {
    text-align: center
}

.text-right {
    text-align: right
}

.text-left {
    text-align: left
}

.uppercase {
    text-transform: uppercase
}

.hyphenate {
    word-wrap: break-word;
    hyphens: auto;
    overflow-wrap: break-word
}

.no-wrap {
    white-space: nowrap
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
main,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
    border: 0;
    font-size: 100%;
    font: inherit;
    margin: 0;
    padding: 0;
    vertical-align: initial
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
    display: block
}

body {
    line-height: 1
}

menu,
ol,
ul {
    list-style: none
}

blockquote,
q {
    quotes: none
}

blockquote:after,
blockquote:before,
q:after,
q:before {
    content: "";
    content: none
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
html {
    -webkit-text-size-adjust: 100%;
    line-height: 1.15
}

body {
    margin: 0
}

main {
    display: block
}

h1 {
    font-size: 2em;
    margin: .67em 0
}

hr {
    box-sizing: initial;
    height: 0;
    overflow: visible
}

pre {
    font-family: monospace, monospace;
    font-size: 1em
}

a {
    background-color: initial
}

abbr[title] {
    border-bottom: none;
    text-decoration: none;
    -webkit-text-decoration: none dotted;
    text-decoration: none dotted
}

b,
strong {
    font-weight: bolder
}

code,
kbd,
samp {
    font-family: monospace, monospace;
    font-size: 1em
}

small {
    font-size: 80%
}

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: initial
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

img {
    border-style: none
}

button,
input,
optgroup,
select,
textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0
}

button,
input {
    overflow: visible
}

button,
select {
    text-transform: none
}

[type=button],
[type=reset],
[type=submit],

[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner,
button::-moz-focus-inner {
    border-style: none;
    padding: 0
}

[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring,
button:-moz-focusring {
    outline: 1px dotted ButtonText
}

fieldset {
    padding: .35em .75em .625em
}

legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal
}

progress {
    vertical-align: initial
}

textarea {
    overflow: auto
}

[type=checkbox],
[type=radio] {
    box-sizing: border-box;
    padding: 0
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    -webkit-appearance: textfield;
    outline-offset: -2px
}

[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit
}

details {
    display: block
}

summary {
    display: list-item
}

[hidden],
template {
    display: none
}

@keyframes spin {
    0% {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(1turn)
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes visibilityIn {
    0% {
        visibility: hidden
    }

    to {
        visibility: visible
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

@keyframes fadeInDown {
    0% {
        opacity: 0;
        transform: translateY(-2rem)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(2rem)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

@keyframes blink {

    0%,
    to {
        opacity: 0
    }

    50% {
        opacity: 1
    }
}

@keyframes flash {

    0%,
    50%,
    to {
        opacity: 1
    }

    25%,
    75% {
        opacity: 0
    }
}

@keyframes layIn {
    0% {
        opacity: 0;
        transform: rotateX(-30deg) translateZ(50px);
        transform-origin: 50% 100%
    }

    to {
        opacity: 1;
        transform: rotateX(0deg) translateZ(0)
    }
}

@keyframes shake {

    41%,
    8% {
        transform: translateX(-4px)
    }

    25%,
    58% {
        transform: translateX(4px)
    }

    75% {
        transform: translateX(-2px)
    }

    92% {
        transform: translateX(2px)
    }

    0%,
    to {
        transform: translateX(0)
    }
}

@keyframes scaleInDown {
    0% {
        opacity: 0;
        transform: translateY(-.75rem) scale(.95)
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
        visibility: visible
    }
}

@keyframes scaleOutUp {
    0% {
        opacity: 1;
        transform: translateY(0) scale(1)
    }

    to {
        opacity: 0;
        transform: translateY(-.75rem) scale(.95);
        visibility: hidden
    }
}

@keyframes dropIn {
    0% {
        opacity: 0;
        transform: scale(1.333)
    }

    to {
        opacity: 1;
        transform: scale(1)
    }
}

@keyframes zoomIn {
    0% {
        opacity: 0;
        transform: scale(.9)
    }

    to {
        opacity: 1;
        transform: scale(1)
    }
}

*,
:after,
:before {
    box-sizing: border-box
}

h1 {
    font-size: 100%;
    margin: 0
}

ol,
ul {
    list-style: none;
    margin: 0;
    padding: 0
}

b,
strong {
    font-weight: inherit
}

em,
i {
    font-style: normal
}

button,
details>summary {
    cursor: pointer
}

a {
    text-decoration: none
}

html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 100%;
    line-height: 1.5;
    min-height: 100%;
    text-rendering: optimizeLegibility
}

body {
    align-content: flex-start;
    background-color: #fff;
    color: #212123;
    display: flex;
    flex-direction: column;
    font-family: Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;
    min-height: 100vh
}

#content {
    margin-bottom: auto
}

.wrapper {
    margin-left: auto;
    margin-right: auto;
    max-width: 75rem
}

.pad-viewport {
    padding-left: 1rem;
    padding-right: 1rem
}

@media (max-width: 768px) {
    .pricing-box {
        max-width: 100%;
        overflow: hidden;
        /* padding: 20px; */
        /* Add padding to prevent content from touching the edges */
    }

    .pricing-plans {
        display: flex;
        flex-wrap: wrap;
        /* Allow plans to wrap on smaller screens */
        justify-content: center;
    }

    .pricing-plan {
        flex: 1 1 100%;
        /* Make each plan take full width on small screens */
        max-width: 100%;
        margin: 16px 0;
        /* Add margin to separate plans */
    }

    .pricing-plan__features {
        list-style: none;
        padding: 0;
    }

    .button {
        display: block;
        width: 100%;
        /* Make buttons take full width on mobile */
        /* text-align: center; */
    }
}


@media screen and (min-width:640px) {
    .pad-viewport {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
}

@media screen and (min-width:1220px) {
    .pad-viewport {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

.pad-viewport-2x {
    padding-left: 2rem;
    padding-right: 2rem
}

@media screen and (min-width:640px) {
    .pad-viewport-2x {
        padding-left: 3rem;
        padding-right: 3rem
    }
}

@media screen and (min-width:1220px) {
    .pad-viewport-2x {
        padding-left: 4rem;
        padding-right: 4rem
    }
}

.form-input,
.form-select {
    appearance: none;
    border: 0;
    border-radius: 6px;
    line-height: 1.5;
    min-height: 3rem;
    padding: .75rem .875rem
}

.form-input:enabled,
.form-select:enabled {
    background-color: #f9f9f9;
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .0625rem #0000001a;
    color: #000
}

.form-input:focus,
.form-select:focus {
    appearance: none;
    background-color: #fff;
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #ff7843;
    outline: none
}

.form-input.is-invalid,
.form-select.is-invalid,
.is-invalid .form-input,
.is-invalid .form-select {
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00
}

.form-input.is-invalid::selection,
.form-select.is-invalid::selection,
.is-invalid .form-input::selection,
.is-invalid .form-select::selection {
    background-color: #cc000059
}

.form-input.is-successful,
.form-select.is-successful,
.is-successful .form-input,
.is-successful .form-select {
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #13bf3e
}

.form-input.is-successful::selection,
.form-select.is-successful::selection,
.is-successful .form-input::selection,
.is-successful .form-select::selection {
    background-color: #13bf3e59
}

.form-input:disabled,
.form-select:disabled {
    background-color: #f9f9f9;
    box-shadow: 0 0 0 .0625rem #0000001a;
    color: #0000008c;
    cursor: not-allowed
}

.form-input--file__label.is-invalid .form-input--file {
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00
}

.form-input--file__label.is-disabled {
    outline: none;
    pointer-events: none
}

.form-input--file__label.is-disabled .form-input--file {
    background-color: #f9f9f9;
    box-shadow: 0 0 0 .0625rem #0000001a;
    color: #0000008c;
    cursor: not-allowed;
    pointer-events: none
}

.form-input--file__label:focus:not(.is-disabled) {
    outline: none
}

.form-input--file__label:focus:not(.is-disabled) .form-input--file {
    appearance: none;
    background-color: #fff;
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #ff7843;
    outline: none
}

.form-input--file {
    align-items: center;
    appearance: none;
    background-color: #fff;
    border: 1px solid #0000001a;
    border-radius: 6px;
    color: #000000d9;
    cursor: pointer;
    display: inline-flex;
    font-size: .875rem;
    min-height: auto;
    outline: none;
    width: auto
}

.form-input--file:hover {
    background-color: #f9f9f9;
    color: #000
}

.form-input--file:focus {
    border-color: #0000;
    box-shadow: 0 0 0 .125rem #0000001a;
    outline: none
}

.form-input--file:active {
    background-color: #e6e6e6;
    border-color: #0000001a;
    box-shadow: 0 1px 2px #0000001a
}

.form-input::placeholder {
    color: #0000007a;
    opacity: 1
}

.form-select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right .75rem top 50%;
    background-repeat: no-repeat;
    background-size: 1.5rem 1.5rem;
    cursor: pointer;
    padding-right: 3.125rem
}

.form-input--wide,
.form-select--wide {
    width: 100%
}

.form-input--compact,
.form-select--compact {
    font-weight: 400;
    min-height: 2.5rem;
    padding: .375rem .875rem
}

.form-input--in-group,
.form-select--in-group {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    min-width: 0
}

.form-input--textarea {
    resize: vertical
}

.form-input--search {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: .5rem;
    background-repeat: no-repeat;
    background-size: 1.5rem 1.5rem;
    padding-left: 2.25rem
}

.form-input--search::-webkit-search-cancel-button {
    -webkit-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-size: contain;
    cursor: default;
    height: 1.5rem;
    width: 1.5rem
}

.form-input--search:placeholder-shown::-webkit-search-cancel-button {
    display: none
}

.form-checkbox {
    appearance: none;
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid #0000001a;
    border-radius: .1875rem;
    box-shadow: 0 .0625rem .125rem 0 #0000001a;
    cursor: pointer;
    flex: none;
    height: 1rem;
    margin: 0;
    outline: none;
    padding: 0;
    width: 1rem
}

.form-checkbox:active {
    background-color: #e6e6e6
}

.form-checkbox:checked {
    background-color: #ff7843;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-position: 50%;
    background-size: 1rem;
    border-color: #ff7843
}

.form-checkbox:checked:active {
    background-color: #0000008c;
    border-color: #0000008c
}

.form-checkbox.is-invalid,
.is-invalid .form-checkbox {
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00
}

.form-checkbox:disabled {
    cursor: not-allowed
}

.form-checkbox:disabled,
.form-checkbox:disabled:active {
    background-color: #f9f9f9;
    border-color: #000
}

.form-checkbox:disabled:checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: 50%;
    background-size: 1rem
}

.form-radio {
    appearance: none;
    background-clip: padding-box;
    border: 1px solid #0000001a;
    border-radius: 9999px;
    box-shadow: 0 .0625rem .125rem 0 #0000001a;
    cursor: pointer;
    flex: none;
    height: 1rem;
    margin: 0;
    outline: none;
    padding: 0;
    width: 1rem
}

.form-radio,
.form-radio:active {
    background-color: #fff
}

.form-radio:checked {
    background-color: #ff7843;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: 50%;
    background-size: 1rem;
    border-color: #ff7843
}

.form-radio:checked:before {
    content: none
}

.form-radio:checked:active {
    background-color: #0000008c;
    border-color: #0000008c
}

.form-radio.is-invalid,
.is-invalid .form-radio {
    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00
}

.form-radio:disabled {
    cursor: not-allowed
}

.form-radio:disabled,
.form-radio:disabled:active {
    background-color: #f9f9f9;
    border-color: #0000001a
}

.form-radio:disabled:checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-position: 50%;
    background-size: 1rem
}

.form-field {
    margin-bottom: 1.5rem
}

.form-label,
.form-option-label {
    color: #212123;
    display: block;
    font-size: .875rem;
    font-weight: 300;
    font-weight: 500;
    line-height: 1.3125rem;
    line-height: 1.25
}

@media screen and (min-width:640px) {

    .form-label,
    .form-option-label {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5rem
    }
}

.form-option-label {
    margin-left: .5rem
}

.form-option-label--small {
    font-size: .875rem;
    font-weight: 300;
    line-height: 1.3125rem
}

.form-label {
    margin-bottom: .5rem
}

.form-label__small {
    color: #0000008c;
    font-weight: 300;
    font-weight: 400
}

.form-label__small,
.form-note {
    font-size: .875rem;
    line-height: 1.3125rem
}

.form-note {
    color: #212123;
    display: block;
    font-weight: 300
}

.form-note:not(:empty) {
    margin-top: .375rem
}

.form-option-label+.form-note {
    margin-top: .125rem
}

.form-note--constraint.is-invalid,
.is-invalid .form-note--constraint,
.is-invalid+.form-note--constraint {
    color: #c00
}

.form-note--constraint.is-successful,
.is-successful .form-note--constraint {
    color: #13bf3e
}

.form-option {
    align-items: flex-start;
    display: flex
}

.form-option .form-checkbox,
.form-option .form-radio {
    margin-top: .125rem
}

.button {
    align-items: center;
    background-color: initial;
    border: 1px solid #0000;
    border-radius: 6px;
    box-shadow: 0 1px 2px #0000001a;
    display: inline-flex;
    font-weight: 600;
    justify-content: center;
    line-height: 1.5;
    min-height: 3rem;
    padding: .6875rem .9375rem;
    position: relative;
    transition: all 125ms ease;
    width: auto
}

.button[disabled] {
    opacity: .4;
    pointer-events: none
}

.button__icon {
    flex: none;
    margin-left: .5rem
}

.button__icon:not(.button__icon--has-colors) [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.button__icon:not(.button__icon--has-colors)[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: currentColor
}

.button__icon:not(.button__icon--has-colors) [fill]:not([fill=none]):not([fill=currentcolor]),
.button__icon:not(.button__icon--has-colors)[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: currentColor
}

.button__icon:not(.button__icon--has-colors) [color],
.button__icon:not(.button__icon--has-colors)[color] {
    color: currentColor
}

.button__icon--pre {
    margin-left: 0;
    margin-right: .25rem
}

.button--primary {
    background-color: #000;
    color: #fff
}

.button--primary:hover {
    background-color: #000000d9
}

.button--primary:focus {
    background-color: #000000b3;
    box-shadow: 0 0 0 .125rem #0000001a;
    outline: none
}

.button--primary:active {
    background-color: #000;
    box-shadow: 0 1px 2px #0000001a;
    color: #ffffffb3
}

.page--inverted .button--primary {
    background-color: #fff;
    color: #000
}

.page--inverted .button--primary:hover {
    background-color: #fffc
}

.page--inverted .button--primary:focus {
    background-color: #ffffffa3
}

.page--inverted .button--primary:active {
    color: #000c
}

.button--secondary {
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid #00000014;
    color: #000000d9
}

.button--secondary:hover {
    background-color: #f9f9f9;
    color: #000
}

.button--secondary:focus {
    border-color: #0000;
    box-shadow: 0 0 0 .125rem #0000001a;
    outline: none
}

.button--secondary:active {
    background-color: #e6e6e6;
    border-color: #0000001a;
    box-shadow: 0 1px 2px #0000001a
}

.page--inverted .button--secondary {
    background-color: #000c;
    border-color: #fff3;
    color: #fff
}

.page--inverted .button--secondary:hover {
    background-color: #00000014
}

.button--tertiary {
    background-color: #0000000a;
    box-shadow: none;
    color: #000
}

@supports (backdrop-filter:blur(1px)) {
    .button--tertiary {
        backdrop-filter: blur(10px)
    }
}

.button--tertiary:hover {
    background-color: #0000001a
}

.button--tertiary:focus {
    box-shadow: 0 0 0 .125rem #0000001a;
    outline: none
}

.button--tertiary:active {
    background-color: #0000004d
}

.page--inverted .button--tertiary {
    background-color: #ffffff1f;
    color: #fff
}

.page--inverted .button--tertiary:hover {
    background-color: #fff3
}

.page--inverted .button--tertiary:active {
    background-color: #ffffff52
}

.button--download {
    align-items: center;
    display: flex;
    padding: .75rem 1rem .75rem .75rem
}

.button--download img {
    height: auto;
    margin-right: .5rem;
    max-width: 1.5rem
}

.button--download.button--primary img {
    border: 1.5px solid #ffffff52;
    border-radius: 6px
}

.button--plain {
    background-color: initial;
    border-bottom: 1.5px solid #0003;
    border-radius: 0;
    box-shadow: none;
    color: #000;
    color: #212123;
    font-size: 1rem;
    line-height: 1.5rem;
    min-height: auto;
    padding: 0;
    text-decoration: none;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .button--plain {
        transition-duration: 1ms
    }
}

.button--plain:active,
.button--plain:hover {
    color: #0000007a
}

.button--negative {
    background-color: #c00;
    color: #fff
}

.button--compact {
    line-height: 1.25rem
}

.button--compact,
.button--medium {
    font-size: .875rem;
    min-height: 2.5rem;
    padding: .5625rem .6875rem
}

.button--medium,
.button--small {
    font-weight: 600;
    line-height: 1.25
}

.button--small {
    font-size: .8125rem;
    min-height: 2rem;
    padding: .3125rem .6875rem
}

.button--large {
    border-radius: .34375rem;
    font-size: 1.25rem;
    line-height: 1.625rem;
    padding: 1.125rem 1.8125rem
}

.button--wide {
    display: flex;
    width: 100%
}

.button--no-shadow,
.button--no-shadow:active,
.button--no-shadow:focus,
.button--no-shadow:hover {
    box-shadow: none
}

.button--no-transforms:active,
.button--no-transforms:hover {
    transform: none
}

.button--label-left {
    justify-content: flex-start
}

.button--space-between {
    justify-content: space-between
}

.button--icon-only {
    width: 0
}

.button--icon-only .button__icon {
    margin: 0
}

.button--in-group {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.button:before {
    background-position: 50%;
    content: "";
    height: 1.5rem;
    left: calc(50% - .75rem);
    opacity: 0;
    position: absolute;
    top: calc(50% - .75rem);
    transition: opacity .25s ease;
    width: 1.5rem
}

@media (prefers-reduced-motion:reduce) {
    .button:before {
        transition-duration: 1ms
    }
}

.button.is-waiting {
    background-color: #000;
    border-color: #0000;
    color: #0000;
    opacity: 1;
    pointer-events: none
}

.button.is-waiting:before {
    animation: spin .5s linear infinite;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    opacity: 1
}

.button.is-invalid,
.is-invalid .button {
    animation: shake .5s linear;
    background-color: #c00;
    border-color: #0000;
    color: #0000;
    opacity: 1;
    pointer-events: none
}

@media percy,
screen and (prefers-reduced-motion:reduce) {

    .button.is-invalid,
    .is-invalid .button {
        animation: none
    }
}

.button.is-invalid:before,
.is-invalid .button:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    opacity: 1
}

.button.is-successful,
.is-successful .button {
    background-color: #13bf3e;
    border-color: #0000;
    color: #0000;
    opacity: 1;
    pointer-events: none
}

.button.is-successful:focus,
.is-successful .button:focus {
    box-shadow: 0 0 0 .125rem #13bf3e80
}

.button.is-successful:before,
.is-successful .button:before {
    animation: flash 1s linear;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    opacity: 1
}

@media percy,
screen and (prefers-reduced-motion:reduce) {

    .button.is-successful:before,
    .is-successful .button:before {
        animation: none
    }
}

.pill {
    background-color: #00000014;
    border-radius: 6px;
    color: #000000b3;
    display: inline-block;
    font-size: .6875rem;
    font-weight: 600;
    line-height: 0;
    padding: .75rem .5rem;
    text-transform: uppercase
}

.pill.pill--yellow {
    background-color: #f5a925;
    color: #000c
}

.pill.pill--feature {
    margin-left: .25rem;
    position: relative;
    top: -.1875rem
}

.pill.pill--orange {
    background-color: #f26725;
    color: #fff
}

.pill--secondary {
    background-color: #ebebeb;
    color: #000000a3
}

.pill--rainbow {
    background: linear-gradient(90deg, #e8b8fc, #e7db8f 35%, #a6f1e8 69%, #88fccf);
    color: #212123;
    text-transform: uppercase
}

.pill--round {
    background-color: #00000014;
    border-radius: 6px;
    border-radius: 9999px;
    color: #000000b3;
    font-size: .6875rem;
    font-weight: 600;
    line-height: 0;
    min-width: 1.25rem;
    padding: .625rem .375rem;
    text-transform: uppercase
}

.pill--round,
.pill-link {
    display: inline-block
}

.pill-link:hover .pill {
    color: #212123
}

.main-nav__subnav__mega-menu {
    background-repeat: no-repeat;
    background-size: 2.5rem 100%;
    min-height: 12rem;
    transition: background-image 80ms linear
}

.main-nav__subnav__column__title {
    color: #0000007a;
    font-size: .6875rem;
    font-weight: 600;
    line-height: 1rem;
    margin-top: 0;
    padding: .625rem .875rem .5rem .75rem;
    text-transform: uppercase
}

.main-nav__subnav__column {
    display: flex;
    flex-direction: column;
    padding: .5rem;
    position: relative
}

.main-nav__subnav__column+.main-nav__subnav__column {
    border-left: 1px solid #00000014
}

.main-nav__subnav__column--color:before {
    background: #00000014;
    content: "";
    display: block;
    height: 100%;
    left: -1px;
    position: absolute;
    top: 0;
    width: .0625rem
}

.main-nav__subnav__column--color:first-of-type {
    margin-left: 2.5rem
}

.main-nav__subnav__column--updates {
    padding: 0
}

.main-nav__subnav__mega-menu__updates-wrapper {
    background-color: #fafafa;
    padding: .5rem .5rem 1.5rem
}

.main-nav__subnav__mega-menu--content {
    max-width: 19.75rem;
    min-width: 19.75rem;
    padding: .4375rem .75rem;
    width: 100%
}

@media screen and (min-width:1024px) {

    .main-nav__subnav__mega-menu--content:active,
    .main-nav__subnav__mega-menu--content:hover {
        background-color: #f5f5f5;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 125ms linear
    }

    .main-nav__subnav__mega-menu--content:active .main-nav__subnav__mega-menu--whats-new-date,
    .main-nav__subnav__mega-menu--content:hover .main-nav__subnav__mega-menu--whats-new-date {
        display: block
    }

    .main-nav__subnav__mega-menu--content:active .main-nav__subnav__mega-menu--whats-new-item:before,
    .main-nav__subnav__mega-menu--content:hover .main-nav__subnav__mega-menu--whats-new-item:before {
        box-shadow: 0 0 0 4px #f5f5f5;
        transition: all 125ms ease
    }
}

.main-nav__subnav__mega-menu__updates {
    position: relative
}

.main-nav__subnav__mega-menu__updates:before {
    background-color: #00000014;
    content: "";
    display: block;
    height: 100%;
    left: 1.3125rem;
    position: absolute;
    top: 1.5rem;
    width: 1px
}

.main-nav__subnav__mega-menu--whats-new-item {
    color: #212123;
    display: flex;
    font-size: .9375rem;
    font-weight: 400;
    line-height: 1.5rem;
    margin-bottom: .125rem;
    margin-left: 1.875rem;
    margin-top: .125rem;
    position: relative
}

.main-nav__subnav__mega-menu--whats-new-item:before {
    background-color: #f26725;
    border: 4px solid #ffe8db;
    border-radius: 9999px;
    box-shadow: 0 0 0 4px #fafafa;
    content: "";
    height: .9375rem;
    left: -1.75rem;
    position: absolute;
    top: .25rem;
    width: .9375rem;
    z-index: 10
}

@media screen and (max-width:767px) {
    .main-nav__subnav__mega-menu--whats-new-item {
        flex-direction: column
    }
}

@media screen and (min-width:1024px) {
    .main-nav__subnav__mega-menu--whats-new-item {
        align-items: center
    }
}

.main-nav__subnav__mega-menu--whats-new-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    word-break: break-all
}

@media screen and (max-width:767px) {
    .main-nav__subnav__mega-menu--whats-new-title {
        margin-bottom: .25rem
    }
}

@media screen and (min-width:768px) {
    .main-nav__subnav__mega-menu--whats-new-title {
        width: 16.25rem
    }
}

.main-nav__subnav__mega-menu--whats-new-date {
    text-wrap: nowrap;
    color: #0000007a;
    font-size: .6875rem;
    font-weight: 600;
    line-height: 1rem;
    padding-left: .25rem;
    text-transform: uppercase;
    white-space: nowrap
}

@media screen and (min-width:768px) {
    .main-nav__subnav__mega-menu--whats-new-date {
        margin-left: auto
    }
}

@media screen and (min-width:1024px) {
    .main-nav__subnav__mega-menu--whats-new-date {
        display: none
    }
}

.main-nav__subnav__mega-menu--link-wrapper {
    background-color: #fff;
    padding: .5rem;
    position: relative;
    text-align: center;
    z-index: 1
}

.main-nav__subnav__mega-menu--link-wrapper:before {
    background-color: #ebebeb;
    content: "";
    height: .0625rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.main-nav__subnav__mega-menu--link {
    color: #212123;
    display: block;
    font-size: .9375rem;
    font-weight: 400;
    line-height: 1.5rem;
    padding: .5rem .625rem;
    width: 100%
}

.main-nav__subnav__mega-menu--link:hover {
    background-color: #0000000a;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 125ms linear
}


.mobile-nav {
    background-clip: padding-box;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 1rem;
    border-right: .0625rem solid #00000014;
    height: calc(100% + 1px);
    left: 0;
    overflow-y: scroll;
    overscroll-behavior: contain;
    pointer-events: none;
    position: fixed;
    top: -1px;
    transform: translateX(-100%);
    transition: transform .25s cubic-bezier(.19, 1, .22, 1), visibility 0s linear .25s;
    visibility: hidden;
    width: 83vw
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .mobile-nav {
        transition-duration: 1ms
    }
}

body.is-loading .mobile-nav {
    transition-duration: 0s
}

.main-nav.is-safari .mobile-nav {
    bottom: 0;
    height: 100dvh
}

@media screen and (min-width:768px) {
    .mobile-nav {
        width: 57vw
    }
}

.main-nav.is-active .mobile-nav {
    pointer-events: auto;
    transform: translateX(0);
    transition: transform .4s cubic-bezier(.19, 1, .22, 1), visibility 0s linear;
    visibility: visible
}

.mobile-nav__wrapper {
    padding: 0 1rem env(safe-area-inset-bottom) 2rem
}

@media screen and (max-width:1023px) {
    .main-nav__heading {
        color: #0000007a;
        font-size: .6875rem;
        font-weight: 600;
        line-height: 1rem;
        margin-top: 0;
        text-transform: uppercase
    }

    .main-nav__heading.main-nav__heading--icon {
        align-items: center;
        display: flex
    }

    .main-nav__heading.main-nav__heading--icon .icon {
        color: #000;
        margin-left: .125rem
    }
}

.mobile-nav__links .main-nav__item-group {
    border-bottom: 1px solid #00000014;
    padding: 1.5rem .5rem
}

.mobile-nav__links .main-nav__item-group:last-child {
    border-bottom: none
}

.mobile-nav__links .main-nav__menu__pages,
.mobile-nav__links .main-nav__menu__pages>li>ul {
    list-style: none;
    padding-left: 0
}

.mobile-nav__links .main-nav__menu__pages>.main-nav__item-group:first-child {
    padding-top: 0
}

.mobile-nav__links .main-nav__menu__pages>.main-nav__item-group:last-child {
    padding-bottom: 2.5rem
}

.mobile-nav__links .main-nav__subnav__mega-menu--link-wrapper:before {
    display: none
}

.mobile-nav__links .main-nav__subnav__item {
    height: auto;
    margin-top: .75rem;
    padding: 0
}

.mobile-nav__links .main-nav__subnav__link {
    line-height: 1.5rem;
    padding: 0
}

.mobile-nav__links .main-nav__subnav__mega-menu--link {
    background-color: #f5f5f5;
    border-radius: 6px;
    font-size: .875rem;
    font-weight: 500;
    line-height: 1.5rem
}

.mobile-nav__actions {
    align-items: center;
    background-image: linear-gradient(180deg, #fff 65%, #fff0);
    display: flex;
    height: 4rem;
    justify-content: space-between;
    padding-right: .5rem;
    position: sticky;
    top: 0;
    z-index: 100
}

.mobile-nav__close {
    background-color: initial;
    border: none;
    display: block;
    padding: .5rem
}

.mobile-nav__close-icon {
    color: #0000007a;
    display: block;
    height: auto;
    width: inherit
}

.mobile-nav__link {
    color: #000;
    font-size: .9375rem;
    font-weight: 500
}

.mobile-nav__dev-actions {
    display: flex;
    justify-content: center;
    margin-bottom: .5rem;
    padding-right: 1rem
}

.mobile-nav__toggle-layout {
    align-self: center;
    border: 0;
    color: #858585;
    font-weight: 500;
    min-height: auto;
    padding: 0;
    transition: color 125ms ease-out
}

.mobile-nav__toggle-layout:hover {
    color: #212123
}

.mobile-nav__get-started {
    background-image: linear-gradient(180deg, #fff0, #fff 33%);
    bottom: 0;
    padding: 1.5rem .5rem;
    position: sticky;
    z-index: 1000
}

.mobile-nav__links+.mobile-nav__get-started.is-hidden {
    padding-bottom: 0;
    padding-top: 1.5rem
}

.mobile-nav__get-started.is-hidden {
    display: block;
    padding-bottom: 0;
    padding-top: 3.5rem
}

.mobile-nav__get-started.is-hidden .main-nav__items {
    display: none
}

.mobile-nav__get-started .button {
    width: 100%
}

.mobile-nav .mobile-nav__get-started .main-nav__item--cta {
    display: block
}

.add-top-margin {
    margin-top: 2.5rem
}

.button--dark-icon .button__icon--pre,
.button--light-icon .button__icon--pre {
    display: block
}

.button--dark-icon {
    display: none
}

@media screen and (prefers-color-scheme:dark) and (max-width:1023px) {
    .mobile-nav {
        background-color: #212123
    }

    .mobile-nav .main-nav__heading {
        color: #ffffff7a
    }

    .mobile-nav__links .main-nav__subnav__link {
        color: #ccc
    }

    .mobile-nav__links .main-nav__subnav__link:active,
    .mobile-nav__links .main-nav__subnav__link:hover {
        color: #858585
    }

    .mobile-nav__actions {
        background-image: linear-gradient(180deg, #212123 65%, #21212300)
    }

    .mobile-nav__link {
        color: #ebebeb
    }

    .mobile-nav__get-started {
        background-image: linear-gradient(180deg, #21212300, #212123 33%)
    }

    .mobile-nav__toggle-layout:active,
    .mobile-nav__toggle-layout:hover {
        color: #ccc
    }

    .mobile-nav__close-icon {
        color: #858585
    }

    .mobile-nav__links .main-nav__item-group {
        border-color: #ffffff14
    }

    .mobile-nav__get-started .button {
        background-color: #fff;
        color: #000
    }

    .mobile-nav .main-nav__item__badge:after {
        background-color: #ffffff14;
        color: #ffffff7a
    }

    .button--dark-icon {
        display: block
    }

    .button--light-icon {
        display: none
    }
}

@media screen and (max-width:1023px) {
    .page--inverted .mobile-nav {
        background-color: #212123
    }

    .page--inverted .mobile-nav .main-nav__heading {
        color: #ffffff7a
    }

    .page--inverted .mobile-nav__links .main-nav__subnav__link {
        color: #ccc
    }

    .page--inverted .mobile-nav__links .main-nav__subnav__link:active,
    .page--inverted .mobile-nav__links .main-nav__subnav__link:hover {
        color: #858585
    }

    .page--inverted .mobile-nav__actions {
        background-image: linear-gradient(180deg, #212123 65%, #21212300)
    }

    .page--inverted .mobile-nav__link {
        color: #ebebeb
    }

    .page--inverted .mobile-nav__get-started {
        background-image: linear-gradient(180deg, #21212300, #212123 33%)
    }

    .page--inverted .mobile-nav__toggle-layout:active,
    .page--inverted .mobile-nav__toggle-layout:hover {
        color: #ccc
    }

    .page--inverted .mobile-nav__close-icon {
        color: #858585
    }

    .page--inverted .mobile-nav__links .main-nav__item-group {
        border-color: #ffffff14
    }

    .page--inverted .mobile-nav__get-started .button {
        background-color: #fff;
        color: #000
    }

    .page--inverted .mobile-nav .main-nav__item__badge:after {
        background-color: #ffffff14;
        color: #ffffff7a
    }

    .page--inverted .button--dark-icon {
        display: block
    }

    .page--inverted .button--light-icon {
        display: none
    }
}

.extra-surprises .open-homepage-switcher-link,
.extra-surprises .toggle-grid-layout-link {
    align-items: center;
    display: flex;
    justify-content: space-between
}

.extra-surprises .open-homepage-switcher-link__icon {
    color: #adadad
}

.extra-surprises .toggle-grid-layout-link .switch {
    display: inline-block;
    height: 1.25rem;
    pointer-events: none;
    position: relative;
    width: 2.25rem
}

.extra-surprises .toggle-grid-layout-link .switch input {
    height: 0;
    opacity: 0;
    width: 0
}

.extra-surprises .toggle-grid-layout-link .slider {
    background-color: #adadad;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: background-color .4s ease-in-out
}

.extra-surprises .toggle-grid-layout-link .slider:before {
    background-color: #fff;
    bottom: .125rem;
    content: "";
    height: 1rem;
    left: .125rem;
    position: absolute;
    transition: transform .4s ease-in-out;
    width: 1rem
}

.extra-surprises .toggle-grid-layout-link input:checked+.slider {
    background-color: #f26725
}

.extra-surprises .toggle-grid-layout-link input:focus+.slider {
    box-shadow: 0 0 1px #f26725
}

.extra-surprises .toggle-grid-layout-link input:checked+.slider:before {
    transform: translateX(16px)
}

.extra-surprises .toggle-grid-layout-link .slider.round,
.extra-surprises .toggle-grid-layout-link .slider.round:before {
    border-radius: 9999px
}

.tooltip {
    position: relative
}

abbr.tooltip {
    border-bottom: 1px dotted;
    cursor: help;
    text-decoration: none
}

.tooltip:after,
.tooltip:before {
    bottom: 100%;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, -.5rem);
    transition-duration: .15s;
    transition-property: transform, opacity;
    transition-timing-function: cubic-bezier(.215, .61, .355, 1);
    z-index: 10
}

@media (prefers-reduced-motion:reduce) {

    .tooltip:after,
    .tooltip:before {
        transition-duration: 1ms
    }
}

.tooltip:hover:after,
.tooltip:hover:before {
    opacity: 1;
    transform: translate(-50%)
}

.tooltip--left:before {
    left: -.5em;
    transform: translateY(-.5rem)
}

.tooltip--left:focus:before,
.tooltip--left:hover:before {
    transform: translate(0)
}

.tooltip--right:before {
    left: auto;
    right: -.5em;
    transform: translateY(-.5rem)
}

.tooltip--right:focus:before,
.tooltip--right:hover:before {
    transform: translate(0)
}

.tooltip:before {
    background-color: #000;
    border-radius: 8px;
    color: #fff;
    content: attr(aria-label);
    font-size: .875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;
    margin-bottom: calc(.25rem + 6px);
    padding: .75rem 1rem;
    text-align: left;
    text-transform: none;
    white-space: nowrap
}

.tooltip:after {
    border-left: 6px solid #0000;
    border-right: 6px solid #0000;
    border-top: 6px solid #000;
    content: "";
    height: 0;
    margin-bottom: .25rem;
    width: 0
}

.tooltip.tooltip--wide:before {
    min-width: 14rem;
    white-space: normal
}

.tooltip.tooltip--new:before {
    background: #000000a3;
    font-size: .875rem;
    line-height: 1.25rem;
    margin-bottom: .25rem;
    padding: .625rem .75rem;
    transform: translate(-50%, .5rem);
    transition: transform 125ms cubic-bezier(.455, .03, .515, .955), opacity 60ms cubic-bezier(.455, .03, .515, .955);
    transition-delay: 0s
}

@media screen and (min-width:1440px) {
    .tooltip.tooltip--new:before {
        transform: translate(-50%, -.125rem)
    }
}

.tooltip.tooltip--new:hover:before {
    transform: translate(-50%, -.125rem);
    transition-delay: 125ms
}

@media screen and (min-width:1440px) {
    .tooltip.tooltip--new:hover:before {
        transform: translate(-50%, -.125rem)
    }
}

.tooltip.tooltip--new:after {
    content: none
}

@keyframes slide-down {
    0% {
        opacity: 0;
        transform: translateY(-5px)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

body {
    --main-nav-height: 4rem
}

@media screen and (min-width:1024px) {
    body {
        --main-nav-height: 5rem
    }
}

.main-nav__inner {
    margin-left: auto;
    margin-right: auto;
    max-width: 75rem
}

.main-nav__bar {
    display: flex;
    flex-direction: row;
    height: 4rem
}

@media screen and (min-width:1024px) {
    .main-nav__bar {
        height: 5rem
    }
}

.main-nav__controls {
    display: flex
}

.main-nav__toggle {
    appearance: none;
    background-color: initial;
    border: 0;
    border-radius: 0;
    display: block;
    line-height: normal;
    margin: 0;
    padding: 0
}

.main-nav__logo {
    height: 100%
}

.main-nav__logo__link {
    align-items: center;
    display: flex;
    height: 100%;
    position: relative
}

.main-nav__logo__link:before {
    background-color: initial;
    bottom: 0;
    content: "";
    display: block;
    left: -1rem;
    position: absolute;
    right: -1rem;
    top: 0
}

.main-nav__logo__link:active {
    opacity: .64
}

.main-nav__logo__link:hover .main-nav__logo__shape {
    opacity: .48;
    transition: opacity 125ms ease-out
}

.main-nav__logo__shape {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    height: 2rem;
    width: 2rem
}

@media screen and (min-width:1024px) {
    .page--inverted .main-nav__logo__shape {
        filter: invert(100%)
    }
}

@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {

    .main-nav.is-sticky .main-nav__logo__shape,
    .main-nav:not(.main-nav--blurred) .main-nav__logo__shape {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    }
}

@media screen and (max-width:1023px) {

    .page--inverted .main-nav.is-sticky .main-nav__logo__shape,
    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__logo__shape {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    }
}

.main-nav__logo__name {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute !important;
    white-space: nowrap;
    width: 1px
}

.main-nav__item {
    display: flex;
    position: relative
}

.main-nav__item--cta {
    align-items: center
}

@media screen and (max-width:1439px) {
    .main-nav__item--cta .button--primary {
        font-size: .875rem;
        line-height: 1.25rem;
        min-height: auto;
        padding: .5625rem .6875rem
    }
}

.main-nav__download-wrapper {
    display: none
}

@media screen and (min-width:1024px) {
    .main-nav__download-wrapper.operation-system-is-mac {
        align-items: center;
        display: flex;
        justify-content: flex-end
    }
}

.main-nav__download-wrapper .download {
    height: 2.5rem;
    padding: .5625rem .6875rem .5625rem .5625rem
}

.main-nav__download-wrapper .download.tooltip.tooltip--new:before {
    display: none;
    height: auto;
    top: unset;
    transform: translate(-50%, 5.3125rem);
    width: auto
}

@media screen and (min-width:1024px) and (max-width:1139px) {
    .main-nav__download-wrapper .download.tooltip.tooltip--new:before {
        display: block
    }
}

.main-nav__download-wrapper .download.tooltip.tooltip--new:hover:before {
    transform: translate(-50%, 5.625rem)
}

@media screen and (min-width:1024px) and (max-width:1139px) {
    .main-nav__download-wrapper .download {
        background: #0000;
        border: none;
        box-shadow: none;
        padding: 0
    }
}

.main-nav__download-wrapper .download .download__icon {
    height: 1.5rem;
    margin-right: .5rem;
    width: 1.5rem
}

@media screen and (min-width:1024px) and (max-width:1139px) {
    .main-nav__download-wrapper .download .download__icon {
        height: 2rem;
        margin-right: 0;
        width: 2rem
    }

    .main-nav__download-wrapper .download .download__label {
        display: none
    }
}

.main-nav--inverted .main-nav__download-wrapper .download {
    background-color: #000c;
    border-color: #fff3;
    color: #fff
}

.main-nav--inverted .main-nav__download-wrapper .download:hover {
    background-color: #00000014
}

@media screen and (min-width:1024px) and (max-width:1139px) {
    .main-nav--inverted .main-nav__download-wrapper .download {
        background-color: initial;
        border-color: #0000
    }

    .main-nav--inverted .main-nav__download-wrapper .download:hover {
        background-color: initial
    }

    .main-nav__download-wrapper .main-nav__menu__divider {
        margin-left: 1.5rem
    }
}

.main-nav--inverted .main-nav__download-wrapper .main-nav__menu__divider {
    border-right-color: #fff3
}

.main-nav__subnav__toggle:hover {
    cursor: pointer
}

.main-nav__item__action--icon {
    margin-top: -.1rem;
    opacity: .32;
    vertical-align: inherit
}

@media screen and (min-width:1024px) {
    .main-nav__item__action--icon {
        position: absolute
    }
}

.main-nav__item__badge:after {
    background-color: #ebebeb;
    border-radius: 9999px;
    color: #000000a3;
    content: attr(data-badge-label);
    display: inline-block;
    font-size: .6875rem;
    font-weight: weight-medium;
    line-height: .75rem;
    margin-left: .5rem;
    min-width: 1.25rem;
    padding: .1875rem .375rem;
    text-align: center;
    text-transform: uppercase
}

@media screen and (max-width:1023px) {
    .main-nav__logo__shape {
        height: 1.625rem;
        width: 1.75rem
    }

    .main-nav {
        max-height: 100vh;
        position: sticky;
        top: -.03125rem
    }

    .main-nav__menu__auth {
        background-color: #fff;
        position: sticky;
        z-index: 10
    }

    .main-nav__bar {
        flex: 1 1;
        justify-content: space-between
    }

    .main-nav__controls,
    .main-nav__persistent {
        flex: 1 0
    }

    .main-nav__persistent,
    .main-nav__persistent__actions {
        display: flex;
        justify-content: flex-end
    }

    .main-nav__persistent__profile {
        align-items: center;
        display: flex;
        max-width: 1.75rem
    }

    .main-nav__persistent .main-nav__link {
        font-size: .9375rem;
        padding-left: 1rem;
        padding-right: 1rem
    }

    .main-nav__persistent .main-nav__item:not(.main-nav__item--cta):last-child {
        margin-right: -1rem
    }

    .main-nav__menu {
        display: none
    }

    .main-nav.is-active {
        backdrop-filter: none;
        background: #0000;
        box-shadow: none;
        z-index: 10000
    }

    .main-nav.is-active nav.main-nav__inner {
        transform: translateY(-100%);
        transition: transform .25s cubic-bezier(.19, 1, .22, 1)
    }
}

@media screen and (max-width:1023px) and (prefers-reduced-motion:reduce) {
    .main-nav.is-active nav.main-nav__inner {
        transition-duration: 1ms
    }
}

@media screen and (max-width:1023px) {

    .main-nav__menu .main-nav__item--persistent,
    .main-nav__menu__auth__profile {
        display: none
    }

    .main-nav__item.main-nav__subnav {
        flex-flow: column
    }

    .main-nav__subnav.is-active {
        opacity: 1;
        pointer-events: auto;
        visibility: visible
    }

    .main-nav__subnav__dropdown {
        margin-bottom: .625rem
    }
}

@media screen and (min-width:1024px) {
    .main-nav {
        position: relative
    }

    .main-nav__logo {
        margin-right: 1.5rem
    }

    .main-nav__inner {
        display: flex
    }

    .main-nav__controls,
    .main-nav__persistent {
        display: none
    }

    .main-nav__bar,
    .main-nav__menu__auth {
        flex: 0 1 auto
    }

    .main-nav__menu,
    .main-nav__menu__auth__actions,
    .main-nav__menu__pages {
        display: flex;
        flex-flow: row nowrap
    }

    .main-nav__menu,
    .main-nav__menu__pages {
        flex: 1 1
    }

    .main-nav__menu__pages {
        justify-content: flex-start
    }

    .main-nav__menu__auth {
        align-items: center;
        display: flex;
        justify-content: flex-end
    }

    .main-nav__item {
        margin: .875rem 0
    }

    .main-nav__link {
        padding-left: 1rem;
        padding-right: 1rem
    }

    .main-nav__menu__divider {
        border-right: 1px solid #00000014;
        height: 1.5rem;
        margin-left: 2rem
    }

    .main-nav__link__icon {
        color: #00000052
    }

    .main-nav__link--action {
        padding: 0 2rem 0 1.5rem
    }

    .main-nav__subnav {
        position: relative
    }

    .main-nav__subnav:hover .main-nav__subnav__dropdown {
        animation: slide-down .3s cubic-bezier(.19, 1, .22, 1);
        display: flex;
        flex-direction: column;
        opacity: 1;
        pointer-events: auto;
        visibility: visible
    }

    .main-nav__subnav:hover .main-nav__subnav__mega-menu {
        flex-direction: row;
        justify-content: space-between
    }

    .main-nav__subnav__dropdown {
        background-clip: padding-box;
        background-color: #fff;
        border: 1px solid #00000014;
        border-radius: 12px;
        box-shadow: 0 4px 8px #00000014;
        display: none;
        margin-left: -.25rem;
        max-height: calc(100vh - 5rem);
        opacity: 0;
        overflow: hidden;
        position: absolute;
        top: 3.25rem;
        visibility: hidden;
        z-index: 1
    }

    .main-nav__subnav__item .main-nav__subnav__link {
        display: block;
        font-size: .9375rem;
        line-height: 1.25rem;
        min-width: 15.75rem;
        padding: .625rem .75rem;
        width: 100%
    }

    .main-nav__subnav__item .main-nav__subnav__link:hover {
        color: #212123
    }

    .main-nav__subnav__item:hover {
        background-color: #f5f5f5;
        border-radius: 6px;
        transition: background-color 125ms linear
    }

    .main-nav__subnav__link {
        display: block;
        font-size: .9375rem;
        line-height: 1.25rem;
        padding: .625rem .75rem;
        width: 100%
    }

    .main-nav__subnav__link:hover {
        color: #212123
    }

    .main-nav__divider {
        border-bottom: 1px solid #00000014;
        margin: .5rem -2rem;
        padding: 0 .25rem
    }

    .main-nav__menu__auth__profile {
        margin-left: 2rem
    }
}

.main-nav {
    background-color: #fff;
    box-shadow: 0 0 0 .0625rem #00000014;
    color: #212123;
    flex: none;
    padding-left: 1rem;
    padding-right: 1rem;
    z-index: 1000
}

@media screen and (min-width:640px) {
    .main-nav {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
}

@media screen and (min-width:1220px) {
    .main-nav {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

@media screen and (max-width:1023px) {
    .main-nav {
        background-color: #fff
    }

    @supports (backdrop-filter:blur(1px)) {
        .main-nav {
            backdrop-filter: blur(40px);
            background-color: #fffc
        }
    }
}

@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {
    .main-nav {
        background-color: #212123;
        box-shadow: 0 0 0 1px #000
    }

    @supports (backdrop-filter:blur(1px)) {
        .main-nav {
            background-color: #000c
        }
    }
}

@media screen and (max-width:1023px) {
    .page--inverted .main-nav {
        background-color: #212123;
        box-shadow: 0 0 0 1px #000
    }

    @supports (backdrop-filter:blur(1px)) {
        .page--inverted .main-nav {
            background-color: #000c
        }
    }
}

.main-nav {
    transition-duration: 125ms;
    transition-property: background-color, opacity, visibility;
    transition-timing-function: cubic-bezier(.455, .03, .515, .955)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-nav {
        transition-duration: 1ms
    }
}

@media screen and (min-width:1024px) {
    .main-nav--inverted {
        background-color: #212123;
        box-shadow: none
    }

    .main-nav--transparent {
        background-color: initial;
        box-shadow: none
    }

    .main-nav--translucent {
        backdrop-filter: blur(10px);
        background-color: #fffc;
        border-bottom: 1px solid #0000001a;
        box-shadow: none
    }
}

.main-nav.main-nav--blurred {
    background-color: initial;
    box-shadow: none
}

@media screen and (max-width:1023px) {
    .main-nav.main-nav--blurred {
        position: relative
    }
}

@media screen and (min-width:1024px) {
    .main-nav.main-nav--blurred {
        position: relative
    }

    .main-nav.main-nav--blurred.main-nav--small-blur:before {
        height: 6rem
    }

    .main-nav.main-nav--blurred.main-nav--grey-blur:before {
        background-color: #fafafacc
    }

    .main-nav.main-nav--blurred:before {
        backdrop-filter: blur(50px);
        bottom: 0;
        content: "";
        height: 8rem;
        left: 0;
        mask: linear-gradient(180deg, #000 0, #0000);
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0
    }
}

@media screen and (max-width:1023px) {
    .main-nav.main-nav--blurred.is-sticky {
        animation: slideDownNav .4s cubic-bezier(1, 0, 0, 1) forwards;
        background-color: #fff;
        box-shadow: 0 0 0 .0625rem #0000001a;
        opacity: 0;
        position: sticky;
        top: -100%
    }

    @keyframes slideDownNav {
        0% {
            opacity: 0;
            top: -100%
        }

        to {
            opacity: 1;
            top: 0
        }
    }

    @supports (backdrop-filter:blur(1px)) {
        .main-nav.main-nav--blurred.is-sticky {
            backdrop-filter: blur(10px);
            background-color: #fffc
        }
    }
}

@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {
    .main-nav.main-nav--blurred.is-sticky {
        background-color: #000c;
        box-shadow: 0 0 0 1px #000
    }
}

@media screen and (max-width:1023px) {
    .page--inverted .main-nav.main-nav--blurred.is-sticky {
        background-color: #000c;
        box-shadow: 0 0 0 1px #000
    }

    .main-nav.main-nav--blurred.was-sticky {
        animation: slideUpNav .4s cubic-bezier(1, 0, 0, 1) forwards;
        opacity: 1;
        position: sticky;
        top: 0
    }
}

@media screen and (max-width:1023px) {
    @keyframes slideUpNav {
        0% {
            top: 0
        }

        to {
            position: relative;
            top: -100%
        }
    }
}

.main-nav.main-nav--blurred.is-sticky.is-active {
    backdrop-filter: none;
    background-color: initial;
    box-shadow: none
}

.main-nav__link {
    align-items: center;
    color: #000;
    display: flex;
    font-weight: 500;
    justify-content: space-between;
    transition: color 125ms ease-out;
    width: 100%
}

@media (prefers-reduced-motion:reduce) {
    .main-nav__link {
        transition-duration: 1ms
    }
}

.main-nav__link:active,
.main-nav__link:hover {
    color: #0000007a
}

.main-nav--inverted .main-nav__link {
    color: #fff
}

.main-nav--inverted .main-nav__link:hover {
    color: #ffffffa3
}

.main-nav__subnav__link {
    align-items: center;
    color: #000;
    display: inline-flex;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .main-nav__subnav__link {
        transition-duration: 1ms
    }
}

.main-nav__subnav__link:active,
.main-nav__subnav__link:hover {
    color: #0000007a
}

@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {

    .main-nav.is-sticky .main-nav__link--action,
    .main-nav:not(.main-nav--blurred) .main-nav__link--action {
        color: #ebebeb
    }
}

@media screen and (max-width:1023px) {

    .page--inverted .main-nav.is-sticky .main-nav__link--action,
    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__link--action {
        color: #ebebeb
    }
}

.main-nav__link__icon {
    justify-self: flex-end;
    margin-left: .25rem;
    transition-duration: 125ms;
    transition-property: stroke, fill, transform;
    transition-timing-function: cubic-bezier(.455, .03, .515, .955)
}

.main-nav__link__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.main-nav__link__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: currentColor
}

.main-nav__link__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.main-nav__link__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: currentColor
}

.main-nav__link__icon [color],
.main-nav__link__icon[color] {
    color: currentColor
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-nav__link__icon {
        transition-duration: 1ms
    }
}

.main-nav--inverted .main-nav__link__icon {
    color: #ffffff52
}

.main-nav__toggle {
    color: #000;
    margin-left: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    transition: color 125ms cubic-bezier(.455, .03, .515, .955)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-nav__toggle {
        transition-duration: 1ms
    }
}

.main-nav__toggle:active {
    opacity: .64
}

.main-nav__toggle__icon {
    display: block;
    height: 1.5rem;
    position: relative;
    width: 1.5rem
}

@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {

    .main-nav.is-sticky .main-nav__toggle__icon,
    .main-nav:not(.main-nav--blurred) .main-nav__toggle__icon {
        color: #ebebeb
    }
}

@media screen and (max-width:1023px) {

    .page--inverted .main-nav.is-sticky .main-nav__toggle__icon,
    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__toggle__icon {
        color: #ebebeb
    }
}

.main-nav__toggle__icon__line {
    background-color: currentColor;
    border-radius: 9999px;
    display: block;
    height: .125rem;
    left: .125rem;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    transition: all 125ms cubic-bezier(.25, .46, .45, .94);
    width: 1.25rem
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-nav__toggle__icon__line {
        transition-duration: 1ms
    }
}

.main-nav__toggle__icon__line--top {
    top: .4375rem
}

.main-nav__toggle__icon__line--bottom {
    bottom: .4375rem
}

.main-nav-skip:not(:focus) {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute !important;
    white-space: nowrap;
    width: 1px
}

.main-nav-skip:focus {
    background-color: #fff;
    border: 2px solid;
    border-radius: 6px;
    box-shadow: 0 0 0 .1875rem #0000001a;
    color: #000;
    display: inline-block;
    font-size: 1rem;
    font-weight: 600;
    left: 1rem;
    line-height: 1.25rem;
    padding: .75rem 1rem;
    position: absolute;
    top: 1rem;
    z-index: 10001
}

.main-footer {
    color: #000000b3;
    flex: none;
    font-weight: 300;
    line-height: 1.25;
    margin-top: 5rem;
    z-index: 1
}

.main-footer--no-margin {
    margin: 0
}

.main-footer__footer {
    background-color: #f9f9f9
}

.main-footer--inverted .main-footer__footer {
    background-color: #212123
}

.main-footer--transparent .main-footer__footer {
    background-color: initial
}

.main-footer--white .main-footer__footer {
    background-color: #fff
}

.main-footer__nl {
    padding: 2rem 0
}

.main-footer--white .main-footer__nl {
    padding-top: 0
}

.main-footer__nav {
    padding-bottom: 1.9375rem;
    padding-top: 2.5rem
}

@media screen and (min-width:1024px) {
    .main-footer__nav {
        padding-bottom: .9375rem;
        padding-top: 2.5rem
    }
}

.main-footer__nl {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr
}

@media screen and (min-width:768px) {
    .main-footer__nl {
        gap: 2rem;
        grid-template-columns: repeat(2, 1fr)
    }
}

@media screen and (min-width:1024px) {
    .main-footer__nl {
        gap: 2rem;
        grid-template-columns: 2fr 1fr
    }
}

.main-footer__nl__text {
    padding-top: .25rem
}

.page--inverted .main-footer__nl__form .form-input {
    background-color: #ffffff0a;
    border: 1px solid #ffffff52;
    box-shadow: none;
    color: #fff
}

.page--inverted .main-footer__nl__form .form-input::placeholder {
    color: #ffffff52
}

.main-footer__nl__confirm {
    margin-top: .5rem;
    width: 100%
}

.page--inverted .main-footer__nl__confirm .form-option-label {
    color: #fff
}

.main-footer__nl__form__button {
    white-space: nowrap
}

.page--inverted .main-footer__nl__form__button {
    background-color: #ffffff52;
    color: #fff
}

.page--inverted .main-footer__nl__form__button:hover {
    background-color: #ffffff0a
}

.main-footer__nl__heading {
    color: #212123;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.5rem;
    margin-bottom: .25rem
}

.main-footer--inverted .main-footer__nl__heading {
    color: #fff
}

.main-footer__nl__blurb {
    line-height: 1.5rem
}

.main-footer--inverted .main-footer__nl__blurb {
    color: #ffffffa3
}

.main-footer__content {
    border-top: 1px solid #0000001a
}

.main-footer--inverted .main-footer__content {
    border-color: #ffffff14
}

.main-footer__nav {
    column-gap: .75rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));
    position: relative;
    row-gap: 2rem
}

@media screen and (min-width:694px) {
    .main-footer__nav {
        column-gap: 2rem;
        grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr))
    }
}

@media screen and (min-width:768px) {
    .main-footer__nav {
        column-gap: 1.5rem;
        grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr))
    }
}

@media screen and (min-width:1024px) {
    .main-footer__nav {
        display: flex;
        justify-content: space-between
    }
}

.main-footer__nav__heading {
    align-items: center;
    color: #212123;
    display: flex;
    flex-direction: row;
    font-weight: 600;
    justify-content: flex-start
}

.main-footer--inverted .main-footer__nav__heading {
    color: #fff
}

.main-footer__nav__heading__badge {
    margin-left: .5rem
}

.main-footer__nav__item {
    appearance: none;
    background-color: initial;
    border: 0;
    border-radius: 0;
    line-height: normal;
    margin: 0;
    padding: 0
}

.main-footer__nav__heading,
.main-footer__nav__item {
    line-height: 1.5rem;
    margin-bottom: .5rem
}

.main-footer__nav__item {
    color: #000000a3;
    display: flex;
    font-weight: 400;
    transition: color 125ms cubic-bezier(.455, .03, .515, .955)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-footer__nav__item {
        transition-duration: 1ms
    }
}

.main-footer__nav__item:not([target=_blank]) {
    align-items: center;
    display: block
}

.main-footer__nav__item:active,
.main-footer__nav__item:focus,
.main-footer__nav__item:hover {
    color: #000c
}

.main-footer__nav__item:active .main-footer__nav__item__action--icon,
.main-footer__nav__item:focus .main-footer__nav__item__action--icon,
.main-footer__nav__item:hover .main-footer__nav__item__action--icon {
    opacity: .8
}

.main-footer--inverted .main-footer__nav__item {
    color: #fffc
}

.main-footer__nav__item.main-footer__nav__item__badge {
    white-space: nowrap
}

.main-footer__nav__item__icon {
    fill: currentColor;
    height: 1.25rem;
    margin-right: .25rem;
    opacity: .8;
    -webkit-user-select: none;
    user-select: none;
    width: 1.25rem
}

.main-footer__nav__item__action {
    font-weight: 500;
    margin-left: .25rem
}

.main-footer__nav__item__action--icon {
    margin-left: 0;
    margin-right: -1.25rem;
    opacity: .32;
    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955);
    vertical-align: bottom
}

.main-footer__nav__item__action--icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.main-footer__nav__item__action--icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #000
}

.main-footer__nav__item__action--icon [fill]:not([fill=none]):not([fill=currentcolor]),
.main-footer__nav__item__action--icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #000
}

.main-footer__nav__item__action--icon [color],
.main-footer__nav__item__action--icon[color] {
    color: #000
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .main-footer__nav__item__action--icon {
        transition-duration: 1ms
    }
}

.main-footer--inverted .main-footer__nav__item__action--icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.main-footer--inverted .main-footer__nav__item__action--icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #fff
}

.main-footer--inverted .main-footer__nav__item__action--icon [fill]:not([fill=none]):not([fill=currentcolor]),
.main-footer--inverted .main-footer__nav__item__action--icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #fff
}

.main-footer--inverted .main-footer__nav__item__action--icon [color],
.main-footer--inverted .main-footer__nav__item__action--icon[color] {
    color: #fff
}

.main-footer__notice {
    color: #0000007a;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.25rem;
    text-align: center
}

.main-footer--inverted .main-footer__notice {
    color: #ffffffa3
}

.main-footer__skpabloo {
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    padding-bottom: 2.625rem;
    padding-top: 1.5625rem
}

@media screen and (min-width:768px) {
    .main-footer__skpabloo {
        flex-direction: row;
        padding-bottom: 2.5rem;
        padding-top: 2.375rem
    }
}

@media screen and (max-width:767px) {
    .main-footer__logo {
        display: none
    }
}

.main-footer__logo__link {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    height: 1.5rem;
    width: 1.5rem
}

.main-footer--inverted .main-footer__logo__link {
    filter: invert(100%)
}

.main-footer__social {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 1.375rem
}

@media screen and (min-width:768px) {
    .main-footer__social {
        margin-bottom: 0
    }
}

.main-footer__social__item:not(:last-child) {
    margin-right: 1.5rem
}

@media screen and (min-width:768px) {
    .main-footer__social__item:not(:last-child) {
        margin-right: 1rem
    }
}

.main-footer__social__icon {
    height: 1.5rem;
    width: 1.5rem
}

@media screen and (min-width:768px) {
    .main-footer__social__icon {
        height: 1.25rem;
        width: 1.25rem
    }
}

.main-footer__logo__link,
.main-footer__social__link {
    color: #000;
    opacity: .48;
    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {

    .main-footer__logo__link,
    .main-footer__social__link {
        transition-duration: 1ms
    }
}

.main-footer__logo__link:hover,
.main-footer__social__link:hover {
    opacity: .8
}

.main-footer--inverted .main-footer__logo__link,
.main-footer--inverted .main-footer__social__link {
    color: #fff !important;
    opacity: .64
}

.main-footer--inverted .main-footer__logo__link:hover,
.main-footer--inverted .main-footer__social__link:hover {
    opacity: .8
}

.main-footer__logo,
.main-footer__notice,
.main-footer__social {
    flex: 1 1
}

@media screen and (max-width:1023px) {
    .main-footer__nav__items .pill {
        display: none
    }
}

@media screen and (min-width:1024px) {
    .main-footer__nav__item__badge:after {
        background-color: #ebebeb;
        border-radius: 9999px;
        color: #000000a3;
        content: attr(data-badge-label);
        display: inline-block;
        font-size: .6875rem;
        font-weight: 500;
        line-height: .75rem;
        margin-left: .25rem;
        min-width: 1.25rem;
        padding: .1875rem .375rem;
        text-align: center;
        text-transform: uppercase;
        transform: translateY(-4%);
        -webkit-user-select: none;
        user-select: none;
        vertical-align: middle
    }
}

@media screen and (min-width:1024px) and (min-width:1024px) {
    .main-footer__nav__item__badge:after {
        margin-left: .25rem
    }
}

.overlay {
    background-color: #ffffffeb;
    bottom: 0;
    height: 100%;
    height: 100vh;
    left: 0;
    opacity: 0;
    overflow-y: scroll;
    padding: 0;
    pointer-events: none;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity .25s ease-out, visibility 0s linear .25s;
    visibility: hidden;
    width: 100%;
    will-change: opacity;
    z-index: 100
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .overlay {
        transition-duration: 1ms
    }
}

@supports (backdrop-filter:blur(1px)) {
    .overlay {
        backdrop-filter: blur(24px);
        background-color: #ffffffa3
    }
}

.overlay--transparent {
    backdrop-filter: none;
    background-color: initial
}

.overlay--dark {
    background-color: #000000a3
}

@supports (backdrop-filter:blur(1px)) {
    .overlay--dark {
        backdrop-filter: blur(10px);
        background-color: #00000052
    }
}

.overlay--navigation {
    background-color: #0003;
    z-index: 9999
}

@media (prefers-color-scheme:dark) {
    .overlay--navigation {
        background-color: #000000a3
    }
}

@media screen and (max-width:1023px) {
    .overlay--navigation.is-active {
        background-color: #0003
    }
}

.overlay--cover-all {
    z-index: 100000
}

.overlay.is-active {
    opacity: 1;
    pointer-events: all;
    transition: opacity .25s ease-out, visibility 0s linear;
    visibility: visible
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .overlay.is-active {
        transition-duration: 1ms
    }
}

.overlay__wrapper {
    align-items: center;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    min-height: 100%;
    padding: 1rem
}

.overlay__sticky-navigation {
    left: 0;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 100
}

.overlay__hide {
    appearance: none;
    background-color: initial;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 1.5rem;
    border: 0;
    border-radius: 0;
    height: 2.5rem;
    line-height: normal;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    width: 2.5rem
}

.overlay--prism .overlay__hide {
    background-color: #000;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    border-radius: 9999px
}

.overlay--prism .overlay__hide:focus,
.overlay--prism .overlay__hide:hover {
    background-color: #000000d9
}

.activatable.is-active .activatable\\@active__hidden,
.activatable.is-inactive .activatable\\@inactive__hidden,
.activatable:not(.is-active):not(.is-inactive) .activatable\\@failed__hidden {
    display: none
}

.back-nav--floating {
    position: absolute;
    width: 100%;
    z-index: 10
}

.back-nav__content {
    align-items: stretch;
    display: flex;
    height: 4rem
}

.back-nav__link {
    align-items: center;
    color: #0000007a;
    display: flex;
    font-size: 1.0625rem;
    font-weight: 300;
    font-weight: 600;
    line-height: 1.5rem;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .back-nav__link {
        transition-duration: 1ms
    }
}

.back-nav__link:active,
.back-nav__link:hover {
    color: #000000d9
}

.back-nav__link:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    content: "";
    display: inline-block;
    flex: 0 0 auto;
    height: 1.5rem;
    width: 1.5rem
}

.banner {
    bottom: 0;
    max-width: 40.875rem;
    padding: 1rem;
    position: fixed;
    right: 0;
    transition: opacity .25s ease-out, transform .8s cubic-bezier(.19, 1, .22, 1), visibility 0s linear;
    -webkit-user-select: none;
    user-select: none;
    z-index: 1000
}

@media screen and (min-width:640px) {
    .banner {
        padding: 1.5rem
    }
}

@media screen and (min-width:1220px) {
    .banner {
        padding: 2rem
    }
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .banner {
        transition-duration: 1ms
    }
}

.banner.js-visibility-hidden {
    opacity: 0;
    transform: translateY(2rem);
    transition: opacity 125ms ease-out, transform 125ms cubic-bezier(.19, 1, .22, 1), visibility 0s linear 125ms;
    visibility: hidden
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .banner.js-visibility-hidden {
        transition-duration: 1ms
    }
}

.banner__wrapper {
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid #0000001a;
    border-radius: 12px;
    box-shadow: 0 8px 16px 0 #0000001a;
    min-height: 7.5rem;
    overflow: hidden;
    padding: 1rem;
    position: relative
}

@media screen and (max-width:639px) {
    .banner__wrapper>:not(:last-child) {
        margin-bottom: 1rem
    }
}

@media screen and (min-width:640px) {
    .banner__wrapper {
        grid-gap: 1rem;
        align-items: center;
        display: grid;
        grid-template-columns: 4rem auto 7.5rem;
        padding-left: 1.5rem
    }
}

.banner__badge {
    background: #fff;
    border: 3px solid #ff1e00;
    border-radius: 9999px;
    display: inline-block;
    padding: .1875rem;
    position: relative
}

.banner__badge:after {
    background-color: #ffb387;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: .75rem;
    border: 2.5px solid #fff;
    border-radius: .625rem;
    content: "";
    display: block;
    height: 1.5rem;
    position: absolute;
    right: -.375rem;
    top: -.375rem;
    width: 1.5rem
}

@media screen and (max-width:639px) {
    .banner__badge {
        display: none
    }
}

.banner__avatar {
    border-radius: 9999px;
    display: block;
    height: auto;
    width: 100%
}

@media screen and (max-width:639px) {
    .banner__actions {
        grid-gap: .5rem;
        display: grid;
        grid-template-columns: 1fr 1fr
    }
}

@media screen and (min-width:640px) {
    .banner__actions {
        margin-left: .5rem
    }

    .banner__actions>:not(:last-child) {
        margin-bottom: .5rem
    }
}

.banner__title {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem
}

.banner__blurb {
    color: #212123b3;
    font-size: .875rem;
    font-weight: 300;
    line-height: 1.3125rem;
    margin-top: .25rem
}

.banner__blurb strong {
    font-weight: 600
}

.dialog--full,
.dialog--media {
    width: 100%
}

.dialog__video {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%
}

.entrance {
    --entrance-animation-delay: 0ms
}

.entrance--drop.was-shown:not([data-entrance-split-value]),
.entrance--drop.was-shown[data-entrance-split-value~=lines] .word,
.entrance--drop.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--drop:not([data-entrance-split-value]),
.no-js .entrance--drop[data-entrance-split-value~=lines] .word,
.no-js .entrance--drop[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: dropIn
}

.entrance--fade.was-shown:not([data-entrance-split-value]),
.entrance--fade.was-shown[data-entrance-split-value~=lines] .word,
.entrance--fade.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--fade:not([data-entrance-split-value]),
.no-js .entrance--fade[data-entrance-split-value~=lines] .word,
.no-js .entrance--fade[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: fadeIn
}

.entrance--fadeDown.was-shown:not([data-entrance-split-value]),
.entrance--fadeDown.was-shown[data-entrance-split-value~=lines] .word,
.entrance--fadeDown.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--fadeDown:not([data-entrance-split-value]),
.no-js .entrance--fadeDown[data-entrance-split-value~=lines] .word,
.no-js .entrance--fadeDown[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: fadeInDown
}

.entrance--fadeUp.was-shown:not([data-entrance-split-value]),
.entrance--fadeUp.was-shown[data-entrance-split-value~=lines] .word,
.entrance--fadeUp.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--fadeUp:not([data-entrance-split-value]),
.no-js .entrance--fadeUp[data-entrance-split-value~=lines] .word,
.no-js .entrance--fadeUp[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: fadeInUp
}

.entrance--lay.was-shown:not([data-entrance-split-value]),
.entrance--lay.was-shown[data-entrance-split-value~=lines] .word,
.entrance--lay.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--lay:not([data-entrance-split-value]),
.no-js .entrance--lay[data-entrance-split-value~=lines] .word,
.no-js .entrance--lay[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: layIn
}

.entrance--scaleDown.was-shown:not([data-entrance-split-value]),
.entrance--scaleDown.was-shown[data-entrance-split-value~=lines] .word,
.entrance--scaleDown.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--scaleDown:not([data-entrance-split-value]),
.no-js .entrance--scaleDown[data-entrance-split-value~=lines] .word,
.no-js .entrance--scaleDown[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: scaleInDown
}

.entrance--zoom.was-shown:not([data-entrance-split-value]),
.entrance--zoom.was-shown[data-entrance-split-value~=lines] .word,
.entrance--zoom.was-shown[data-entrance-split-value~=words] .word,
.no-js .entrance--zoom:not([data-entrance-split-value]),
.no-js .entrance--zoom[data-entrance-split-value~=lines] .word,
.no-js .entrance--zoom[data-entrance-split-value~=words] .word {
    animation-fill-mode: both;
    animation-name: zoomIn
}

.entrance:not([data-entrance-split-value]) {
    animation-delay: var(--entrance-animation-delay);
    animation-duration: .8s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(.19, 1, .22, 1)
}

.entrance[data-entrance-split-value~=words] .word {
    animation-delay: calc(var(--entrance-animation-delay) + var(--word-index)*.1s);
    animation-duration: .8s;
    animation-timing-function: cubic-bezier(.19, 1, .22, 1);
    display: inline-block
}

.entrance[data-entrance-split-value~=lines] .word {
    animation-delay: calc(var(--entrance-animation-delay) + var(--line-index)*.2s);
    animation-duration: .8s;
    animation-timing-function: cubic-bezier(.19, 1, .22, 1);
    display: inline-block
}

@media percy,
screen and (prefers-reduced-motion:reduce) {

    .entrance:not([data-entrance-split-value]),
    .entrance[data-entrance-split-value~=lines] .word,
    .entrance[data-entrance-split-value~=words] .word {
        animation-delay: 0ms;
        animation-duration: 1ms
    }
}

.grid-layout {
    bottom: 0;
    left: 0;
    margin: 0 auto;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity .6s cubic-bezier(.19, 1, .22, 1);
    -webkit-user-select: none;
    user-select: none;
    z-index: 100000
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .grid-layout {
        transition-duration: 1ms
    }
}

body.is-loading .grid-layout {
    transition-duration: 0s
}

.grid-layout.is-visible {
    opacity: 1
}

.grid-layout__pad {
    height: 100%;
    position: relative
}

.grid-layout__wrapper {
    column-gap: 1.5rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    height: 100%
}

@media screen and (min-width:640px) {
    .grid-layout__wrapper {
        grid-template-columns: repeat(6, 1fr)
    }
}

@media screen and (min-width:1024px) {
    .grid-layout__wrapper {
        grid-template-columns: repeat(12, 1fr)
    }
}

.grid-layout__col {
    background-color: #ff784333
}

.grid-layout__guides {
    height: 100%;
    position: relative;
    transform: translateY(-100%)
}

.grid-layout__guide {
    background-color: red;
    height: 100%;
    position: absolute;
    top: 0;
    width: 1px
}

.grid-layout__guide:nth-child(2) {
    left: 1.25rem
}

@media screen and (min-width:768px) {
    .grid-layout__guide:nth-child(2) {
        left: 2rem
    }
}

.grid-layout__guide:nth-child(3) {
    left: calc(50% - 2rem)
}

@media screen and (min-width:768px) {
    .grid-layout__guide:nth-child(3) {
        left: calc(50% - 2.75rem)
    }
}

.grid-layout__guide:nth-child(4) {
    left: calc(50% - .75rem)
}

.grid-layout__guide:nth-child(5) {
    left: 50%
}

.grid-layout__guide:nth-child(6) {
    left: calc(50% + .75rem)
}

.grid-layout__guide:nth-child(7) {
    left: calc(50% + 2rem)
}

@media screen and (min-width:768px) {
    .grid-layout__guide:nth-child(7) {
        left: calc(50% + 2.75rem)
    }
}

.grid-layout__guide:nth-child(8) {
    right: 1.25rem
}

@media screen and (min-width:768px) {
    .grid-layout__guide:nth-child(8) {
        right: 2rem
    }
}

.grid-layout__guide:nth-child(9) {
    right: 0
}

.grid-layout__res {
    background-color: #000000d9;
    border-radius: 9999px;
    bottom: 1rem;
    color: #fff;
    font-size: .75rem;
    font-weight: 600;
    left: 50%;
    padding: .375rem .75rem;
    position: fixed;
    transform: translateX(-50%);
    z-index: 100000
}

.home-nav {
    padding-left: 1rem;
    padding-right: 1rem;
    position: relative;
    z-index: 1000
}

@media screen and (min-width:640px) {
    .home-nav {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
}

@media screen and (min-width:1220px) {
    .home-nav {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

.home-nav__inner {
    align-items: center;
    display: flex;
    height: 4rem;
    justify-content: space-between
}

.home-nav__link {
    color: #000;
    font-weight: 600;
    transition: color 125ms ease-out
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .home-nav__link {
        transition-duration: 1ms
    }
}

.home-nav__link:hover {
    color: #000000d9
}

.home-nav__link__icon {
    color: #0000004d;
    display: inline-block;
    transition: color 125ms ease-out;
    vertical-align: middle
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .home-nav__link__icon {
        transition-duration: 1ms
    }
}

.home-nav__link:hover .home-nav__link__icon {
    color: #000000d9
}

.icon-text-card {
    background-color: #0000000a;
    border-radius: 8px;
    padding: 1.25rem 1.25rem 2rem;
    text-align: left
}

.icon-text-card__icon {
    margin-bottom: .5rem
}

.icon-text-card__text {
    font-size: 1rem;
    font-weight: 300;
    font-weight: 400;
    line-height: 1.5rem
}

.icon-text-card__text a {
    color: #212123;
    font-weight: 500;
    text-decoration-color: #0003;
    text-decoration-line: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 4px;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .icon-text-card__text a {
        transition-duration: 1ms
    }
}

.icon-text-card__text a:active,
.icon-text-card__text a:hover {
    color: #0000007a
}

.icon-text-card__text strong {
    font-weight: 600
}

.icon-text-card__title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: .5rem
}

@media screen and (min-width:768px) {
    .icon-text-card__title {
        font-size: 1.25rem
    }
}

.icon-text-card--white-bg {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005
}

img[data-controller~=lazyload] {
    opacity: 0;
    transition: opacity .25s ease-out
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    img[data-controller~=lazyload] {
        transition-duration: 1ms
    }
}

img[data-controller~=lazyload].is-failed-loading,
img[data-controller~=lazyload].is-loaded {
    opacity: 1
}

.video-player {
    aspect-ratio: 16/9;
    border-radius: 12px;
    box-shadow: 0 0 4px #00000014, 0 4px 8px #00000005, 0 1px 2px #00000014;
    overflow: hidden;
    position: relative;
    z-index: 1
}

.btc-blog-post .video-player {
    border: 2px solid #fff;
    border-radius: 0
}

.video-player[aspect-ratio=auto] {
    aspect-ratio: auto
}

[slot=end-screen] {
    height: 100%;
    width: 100%
}

[slot=end-screen] .end-screen {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center
}

[slot=end-screen] .end-screen__button {
    align-items: center;
    background-color: #0000007a;
    border-radius: 8px;
    color: #fff;
    display: flex;
    height: 3rem;
    justify-content: center;
    transition: background-color .4s cubic-bezier(.645, .045, .355, 1);
    width: 3rem
}

[slot=end-screen] .end-screen__button:hover {
    background-color: #000c
}

[slot=end-screen] .end-screen__icon {
    height: 1.5rem;
    width: 1.5rem
}

.page-nav-prism__nav {
    background-color: #fff;
    box-shadow: 0 0 1px 1px #0000001a;
    left: 0;
    position: fixed;
    right: 0;
    top: -4rem;
    transition: top .4s cubic-bezier(.19, 1, .22, 1);
    z-index: 10
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .page-nav-prism__nav {
        transition-duration: 1ms
    }
}

@supports (backdrop-filter:blur(1px)) {
    .page-nav-prism__nav {
        backdrop-filter: blur(10px);
        background-color: #ffffffd9
    }
}

.page-nav-prism__nav.is-visible {
    top: 4rem
}

@media screen and (min-width:1024px) {
    .page-nav-prism__nav.is-visible {
        top: 0
    }
}

.page-nav-prism__items {
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-flow: row nowrap;
    mask-image: linear-gradient(90deg, #0000 0, #000 4%, #000 96%, #0000);
    min-height: 4rem;
    overflow: auto;
    padding-left: 2rem;
    padding-right: 2rem;
    position: relative;
    -webkit-scrollbar-width: none;
    scrollbar-width: none;
    width: 100%
}

.page-nav-prism__items>:not(:last-child) {
    margin-right: 2rem
}

@media screen and (min-width:640px) {
    .page-nav-prism__items {
        padding-left: 3rem;
        padding-right: 3rem
    }
}

@media screen and (min-width:1220px) {
    .page-nav-prism__items {
        padding-left: 4rem;
        padding-right: 4rem
    }
}

.page-nav-prism__items::-webkit-scrollbar {
    display: none
}

@media screen and (max-width:767px) {
    .page-nav-prism__items {
        padding-left: 1rem;
        padding-right: 1rem
    }
}

@media screen and (max-width:767px) and (min-width:640px) {
    .page-nav-prism__items {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
}

@media screen and (max-width:767px) and (min-width:1220px) {
    .page-nav-prism__items {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

@media screen and (min-width:1220px) {
    .page-nav-prism__items {
        padding-left: 1rem;
        padding-right: 1rem
    }
}

@media screen and (min-width:1220px) and (min-width:640px) {
    .page-nav-prism__items {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
}

@media screen and (min-width:1220px) and (min-width:1220px) {
    .page-nav-prism__items {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

.page-nav-prism__item {
    display: flex;
    flex-wrap: nowrap
}

.page-nav-prism__item:last-child:after {
    content: "";
    display: block;
    margin-right: 1rem
}

@media screen and (min-width:640px) {
    .page-nav-prism__item:last-child:after {
        margin-right: 1.5rem
    }
}

@media screen and (min-width:1220px) {
    .page-nav-prism__item:last-child:after {
        margin-right: 2rem
    }
}

.page-nav-prism__link {
    align-items: center;
    color: #212123;
    display: flex;
    font-weight: 600;
    font-weight: 500;
    text-decoration: none;
    transition: color 125ms ease-out;
    white-space: nowrap
}

@media (prefers-reduced-motion:reduce) {
    .page-nav-prism__link {
        transition-duration: 1ms
    }
}

.page-nav-prism__link:active,
.page-nav-prism__link:hover {
    color: #0000007a
}

[data-controller=parallax] {
    --parallax-x: 0;
    --parallax-y: 0;
    transform: translate(var(--parallax-x), var(--parallax-y));
    will-change: transform
}

.release--no-sticky-bars .release__infos {
    top: 4rem
}

.release--hidden-cta .release__date {
    margin-bottom: 0
}

.release--hidden-cta .release__card .button,
.release--hidden-requirements .release__requirements {
    display: none
}

@media screen and (min-width:1024px) {
    .release__wrapper {
        align-items: flex-start;
        column-gap: 1.5rem;
        display: grid;
        grid-template-columns: repeat(12, 1fr)
    }
}

.release__infos {
    margin-bottom: 4rem
}

@media screen and (min-width:768px) {
    .release__infos {
        margin: 0 auto 4rem;
        max-width: 21.5rem
    }
}

@media screen and (min-width:1024px) {
    .release__infos {
        grid-column: 1/span 5;
        margin: 0;
        max-width: none;
        padding-left: 2rem;
        padding-right: 2rem;
        position: sticky;
        top: 8rem
    }
}

@media screen and (min-width:1220px) {
    .release__infos {
        grid-column: 1/span 4;
        padding-left: 0;
        padding-right: 2.6875rem
    }
}

.release__card {
    background-color: #fff;
    border: 1px solid #00000014;
    border-radius: 12px;
    box-shadow: 0 4px 8px #00000014;
    margin-bottom: 1rem;
    padding: 1.25rem
}

@media screen and (min-width:1024px) {
    .release__card {
        padding: 1.5rem
    }
}

.release__version-wrapper {
    align-items: center;
    border-bottom: 1px solid #00000014;
    display: flex;
    justify-content: space-between;
    margin-bottom: .75rem;
    padding-bottom: .9375rem
}

.release__version-link {
    align-items: baseline;
    color: #212123;
    display: flex;
    font-size: 2rem;
    font-weight: 900;
    letter-spacing: -.5px;
    line-height: 2.125rem
}

.release__version-link:hover {
    color: #0000007a
}

.release__version-link:hover:after {
    content: "#";
    font-weight: 500;
    margin-left: .375rem
}

.release__badge {
    transform: translateY(-.125rem)
}

.release__date {
    color: #212123;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.5;
    margin-bottom: 1.25rem
}

@media screen and (min-width:1220px) {
    .release__date {
        margin-bottom: 1.5625rem
    }
}

.release__time {
    font-weight: 600
}

.release__requirements {
    color: #0000007a;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.25rem;
    text-align: center
}

@media screen and (min-width:768px) {
    .release__content {
        margin: 0 auto;
        max-width: 43.1875rem
    }
}

@media screen and (min-width:1024px) {
    .release__content {
        grid-column: 6/span 7;
        margin: 0;
        max-width: none
    }
}

@media screen and (min-width:1220px) {
    .release__content {
        grid-column: 5/span 8
    }
}

@media screen and (max-width:767px) {
    .release__warning {
        margin-top: -2rem
    }
}

.release__section.styled-text {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}

@media screen and (max-width:639px) {
    .release__section.styled-text {
        padding-left: 1.25rem;
        padding-right: 1.25rem
    }
}

@media screen and (min-width:1024px) {
    .release__section.styled-text {
        padding-left: 1.1875rem;
        padding-right: 1.1875rem
    }
}

.release__section.styled-text:not(:last-child) {
    margin-bottom: 4rem
}

.release__section.styled-text:not(:first-of-type) h4 {
    margin-bottom: 1rem
}

.release__section.styled-text h4 {
    color: #212123;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -.5px;
    line-height: 2rem;
    margin-bottom: 2rem;
    margin-top: 0
}

.release__section.styled-text h4:not(:first-of-type) {
    margin-top: 4rem
}

.release__section.styled-text ol,
.release__section.styled-text ul {
    padding-left: 0
}

.release__section.styled-text li {
    list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    padding-left: .1875rem;
    transform: translateX(-.1875rem)
}

.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets),
.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets),
.release__section:first-of-type ol:not(.custom-bullets),
.release__section:first-of-type ul:not(.custom-bullets) {
    list-style: none
}

.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets) li,
.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets) li,
.release__section:first-of-type ol:not(.custom-bullets) li,
.release__section:first-of-type ul:not(.custom-bullets) li {
    list-style-image: none
}

.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets) li:not(:last-child),
.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets) li:not(:last-child),
.release__section:first-of-type ol:not(.custom-bullets) li:not(:last-child),
.release__section:first-of-type ul:not(.custom-bullets) li:not(:last-child) {
    margin-bottom: 2rem
}

.update-highlight {
    align-items: center;
    color: #212123;
    display: flex;
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem;
    margin-bottom: .5rem;
    transform: translateX(-1.875rem)
}

@media screen and (min-width:1024px) {
    .update-highlight {
        transform: translateX(-2rem)
    }
}

.update-highlight:before {
    content: "";
    display: block;
    flex-shrink: 0;
    height: 1.5rem;
    margin-right: .375rem;
    transform: translateY(-.0625rem);
    width: 1.5rem
}

@media screen and (min-width:1024px) {
    .update-highlight:before {
        margin-right: .5rem
    }
}

@keyframes shimmer {
    0% {
        background-position: -100vw 0
    }

    to {
        background-position: 100vw 0
    }
}

.ribbon {
    bottom: 0;
    color: #000;
    position: fixed;
    width: 100%;
    z-index: 101
}

@media screen and (min-width:1024px) {
    .ribbon {
        bottom: auto;
        height: 2.5625rem;
        position: relative
    }
}

.ribbon--alt {
    bottom: 0;
    position: fixed
}

@media screen and (min-width:1024px) {
    .ribbon--alt {
        bottom: auto;
        top: 0;
        transform: translateY(-2.5625rem);
        transition: transform .25s ease
    }

    .ribbon--alt.is-visible {
        transform: translateY(0)
    }
}

.ribbon--alt~.ribbon {
    display: none
}

@media screen and (min-width:1024px) {
    .ribbon--alt~.ribbon {
        display: block
    }
}

.ribbon:hover .ribbon__message {
    text-decoration: none
}

.ribbon__wrapper {
    animation: shimmer 4s infinite;
    background-clip: padding-box;
    background-color: #fff;
    background-image: linear-gradient(270deg, #fff0 0, #fffc 25%, #fff 75%, #fff0);
    background-repeat: no-repeat;
    padding: .5rem .5rem .5rem 1rem
}

.page--inverted .ribbon__wrapper {
    background-color: #000;
    background-image: linear-gradient(270deg, #0000 0, #000c 25%, #000 75%, #0000)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .ribbon__wrapper {
        animation: none
    }
}

@supports (backdrop-filter:blur(1px)) {
    .ribbon__wrapper {
        backdrop-filter: blur(40px);
        background-color: #fffc
    }

    .page--inverted .ribbon__wrapper {
        background-color: #000c
    }
}

@media screen and (max-width:1023px) {
    .ribbon__wrapper {
        border-top: 1px solid #0000001a;
        padding-bottom: calc(env(safe-area-inset-bottom) + .5rem)
    }

    .page--inverted .ribbon__wrapper {
        border-top-color: #ffffff14
    }
}

@media screen and (min-width:1024px) {
    .ribbon__wrapper {
        border-bottom: 1px solid #0000001a
    }

    @supports (backdrop-filter:blur(1px)) {
        .ribbon__wrapper {
            background-color: #ffffff7a;
            background-image: linear-gradient(270deg, #fff0 0, #ffffff7a 25%, #fffc 75%, #fff0)
        }
    }

    .page--inverted .ribbon__wrapper {
        border-bottom-color: #ffffff14
    }

    @supports (backdrop-filter:blur(1px)) {
        .page--inverted .ribbon__wrapper {
            background-color: #0000007a;
            background-image: linear-gradient(270deg, #0000 0, #0000007a 25%, #000c 75%, #0000)
        }
    }
}

.ribbon__content {
    align-items: center;
    display: flex;
    justify-content: center
}

.ribbon__message {
    font-size: .875rem;
    font-weight: 300;
    font-weight: 500;
    line-height: 1.3125rem
}

.page--inverted .ribbon__message {
    color: #fff
}

.ribbon--truncated .ribbon__message {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.ribbon__arrow,
.ribbon__icon {
    content: "";
    display: inline-block;
    flex: none;
    height: 1.5rem;
    vertical-align: middle;
    width: 1.5rem
}

.page--inverted .ribbon__arrow,
.page--inverted .ribbon__icon {
    color: #fff
}

.ribbon__icon {
    margin-right: .375rem
}

@media screen and (max-width:389px) {
    .ribbon__icon {
        display: none
    }
}

.ribbon__arrow {
    margin-left: .25rem;
    opacity: .32
}

.media-player {
    align-items: center;
    display: flex;
    position: relative
}

.media-player.media-player--has-lightbox.is-active {
    z-index: 1000
}

.media-player.cursor-hidden {
    cursor: none
}

.media-player__wrapper {
    z-index: 9
}

.media-player--has-lightbox .media-player__wrapper {
    position: relative
}

@media screen and (min-width:1024px) {
    .media-player--has-lightbox .media-player__wrapper {
        transition: transform .4s cubic-bezier(.19, 1, .22, 1)
    }
}

@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {
    .media-player--has-lightbox .media-player__wrapper {
        transition: none
    }
}

.media-player--has-lightbox.is-active .media-player__wrapper {
    transform: translateX(-2rem);
    width: 100vw;
    z-index: 1000
}

@media screen and (min-width:768px) {
    .media-player--has-lightbox.is-active .media-player__wrapper {
        transform: translateX(-3rem)
    }
}

@media screen and (min-width:1024px) {
    .media-player--has-lightbox.is-active .media-player__wrapper {
        transform: translateX(var(--active-video-offset-x));
        width: auto
    }
}

.media-player__video-wrapper {
    -webkit-tap-highlight-color: transparent;
    background-color: initial;
    border-radius: 12px;
    box-shadow: 0 0 4px #00000014, 0 4px 8px #00000005, 0 1px 2px #00000014;
    flex: 1 1;
    overflow: hidden;
    position: relative;
    transform: translateZ(0);
    width: 100%;
    z-index: 1000
}

.media-player__video-wrapper:before {
    background-image: linear-gradient(180deg, #0000, #0000003d 63%, #0000008f);
    content: "";
    height: 100%;
    left: 0;
    opacity: .65;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1
}

.media-player:not(.is-stopped) .media-player__video-wrapper:before {
    display: none
}

.media-player__video {
    display: block;
    height: auto;
    position: relative;
    width: 100%
}

.media-player__subtitles-wrapper {
    bottom: 5rem;
    opacity: 0;
    padding: 0 2rem;
    pointer-events: none;
    position: absolute;
    text-align: center;
    transform: translateY(.5rem);
    transition: opacity 125ms ease-out, transform .4s cubic-bezier(.19, 1, .22, 1);
    -webkit-user-select: none;
    user-select: none;
    width: 100%;
    z-index: 1000
}

@media screen and (min-width:768px) {
    .media-player__subtitles-wrapper {
        bottom: 3.5rem
    }
}

.media-player.is-subtitles-on .media-player__subtitles-wrapper {
    opacity: 1;
    transform: translateY(0)
}

.media-player.controls-hidden .media-player__subtitles-wrapper {
    transform: translateY(4rem)
}

@media screen and (min-width:768px) {
    .media-player.controls-hidden .media-player__subtitles-wrapper {
        transform: translateY(2rem)
    }
}

.media-player.controls-hidden.is-subtitles-off .media-player__subtitles-wrapper {
    transform: translateY(4.5rem)
}

@media screen and (min-width:768px) {
    .media-player.controls-hidden.is-subtitles-off .media-player__subtitles-wrapper {
        transform: translateY(2.5rem)
    }
}

.media-player__subtitles {
    text-wrap: balance;
    background-color: #ffffffb3;
    border-radius: 18px;
    color: #000000d9;
    display: inline-block;
    font-size: .6875rem;
    font-weight: 600;
    line-height: .875rem;
    opacity: 0;
    padding: 8px 16px;
    transition: opacity 125ms ease-out
}

@supports (backdrop-filter:blur(1px)) {
    .media-player__subtitles {
        backdrop-filter: blur(20px)
    }
}

@media screen and (min-width:768px) {
    .media-player__subtitles {
        font-size: .9375rem;
        line-height: 1.25rem
    }
}

.media-player:not(.is-stopped) .media-player__subtitles.is-visible {
    opacity: 1
}

.media-player__progress-bar {
    cursor: pointer;
    overflow: hidden;
    padding-bottom: .5rem;
    padding-top: .5rem;
    position: relative;
    width: 100%;
    z-index: 1
}

.media-player:not(.is-stopped) .media-player__progress-bar {
    pointer-events: all
}

.media-player__progress-bar:before {
    background-color: #ffffff73;
    border-radius: 12px;
    content: "";
    display: block;
    height: .3125rem;
    left: 0;
    position: absolute;
    top: .5rem;
    width: 100%
}

@media (hover:hover) {
    .media-player__progress-bar:hover .media-player__progress-bar-fill:after {
        opacity: 1;
        transform: scale(1)
    }
}

.media-player__progress-bar-fill {
    background-color: #fff;
    border-radius: 12px;
    height: .3125rem;
    position: relative;
    transition: width var(--progress-bar-transition-duration) ease-out;
    width: 0
}

.media-player__progress-bar-fill:after {
    background-color: #fff;
    border-radius: 9999px;
    content: "";
    display: block;
    height: .8125rem;
    opacity: 0;
    position: absolute;
    right: -.25rem;
    top: -.25rem;
    transform: scale(.4);
    transition: transform 60ms ease-out;
    width: .8125rem
}

.media-player__time {
    color: #fff;
    font-size: .6875rem;
    line-height: 1rem;
    padding: .5rem 0
}

@media screen and (min-width:768px) {
    .media-player__time {
        font-size: .875rem
    }
}

.media-player__replay {
    align-items: center;
    appearance: none;
    background-color: initial;
    background-color: #ffffff1a;
    border: 0;
    border-radius: 0;
    border-radius: 8px;
    color: #fff;
    display: flex;
    font-size: 1.0625rem;
    font-weight: 300;
    font-weight: 400;
    left: calc(50% - 3.5625rem);
    line-height: normal;
    line-height: 1.5rem;
    margin: 0;
    opacity: 0;
    padding: .75rem 1.25rem .75rem 1rem;
    pointer-events: none;
    position: absolute;
    top: calc(50% - 1.5rem);
    transition: opacity .4s cubic-bezier(.165, .84, .44, 1);
    z-index: 1000
}

.media-player.has-ended .media-player__replay {
    opacity: 1;
    pointer-events: all
}

.media-player__replay:focus,
.media-player__replay:hover {
    background-color: #212123
}

.media-player__replay:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 1rem;
    content: "";
    display: block;
    height: 1rem;
    margin-right: .5rem;
    width: 1rem
}

.media-player__controls {
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    left: 0;
    padding: 1.5rem 1rem 1rem;
    pointer-events: none;
    position: absolute;
    right: 0;
    transition: opacity .25s ease-out;
    -webkit-user-select: none;
    user-select: none;
    z-index: 1000
}

.media-player.controls-hidden .media-player__controls,
.media-player.is-stopped .media-player__controls {
    opacity: 0
}

.media-player__controls:before {
    background-image: linear-gradient(0deg, #0000008f, #0000002b 53%, #0000);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    bottom: 0;
    content: "";
    display: block;
    height: 150%;
    left: 0;
    position: absolute;
    width: 100%
}

@media screen and (min-width:1024px) {
    .media-player__controls:before {
        height: 230%
    }
}

.media-player__controls__group {
    color: #fff;
    display: flex;
    position: relative;
    z-index: 1
}

.media-player:not(.is-stopped) .media-player__controls__group {
    pointer-events: all
}

.media-player__controls__group>:not(:first-child) {
    margin-left: .25rem
}

.media-player__controls__group>:not(:last-child) {
    margin-right: .25rem
}

.media-player__controls__group--expanded {
    color: #fff;
    display: flex;
    position: relative;
    z-index: 1
}

.media-player__controls__group--expanded>:not(:first-child) {
    margin-left: .5rem
}

.media-player__controls__group--expanded>:not(:last-child) {
    margin-right: .5rem
}

.media-player__control {
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    height: 2rem;
    justify-content: center;
    position: relative;
    transition: background-color .4s cubic-bezier(.19, 1, .22, 1);
    width: 2.5rem
}

.media-player.no-touch .media-player__control:hover {
    background-color: #0000001a
}

.media-player.is-fullscreen .media-player__control--fullscreen,
.media-player.is-muted .media-player__control--volume,
.media-player.is-subtitles-on .media-player__control--subtitles,
.media-player__control.is-active,
.media-player__control:active {
    background-color: #0000004d
}

.media-player.has-no-sound .media-player__control--volume {
    display: none
}

.media-player__control:after {
    background-color: initial;
    border-radius: 8px;
    color: #fff;
    font-size: .625rem;
    left: 50%;
    line-height: 1rem;
    opacity: 0;
    padding: .5rem .75rem;
    pointer-events: none;
    position: absolute;
    top: -2.5rem;
    transform: translate(-50%, .25rem);
    transition: opacity 125ms ease-out, transform .4s cubic-bezier(.19, 1, .22, 1);
    transition-delay: 0, 0;
    z-index: 1000
}

@media screen and (min-width:768px) {
    .media-player__control:after {
        font-size: .75rem
    }
}

.media-player.no-touch .media-player__control:hover:after {
    opacity: 1;
    transform: translate(-50%);
    transition-delay: .4s, .4s
}

.media-player__control--play-pause:after {
    content: attr(data-label-pause);
    left: 0;
    transform: translateY(.25rem)
}

.media-player.is-paused .media-player__control--play-pause:after {
    content: attr(data-label-play)
}

.media-player.no-touch .media-player__control--play-pause:hover:after {
    transform: translate(0)
}

.media-player__control--subtitles:after {
    content: attr(data-label-off);
    white-space: nowrap
}

.media-player.is-subtitles-on .media-player__control--subtitles:after {
    content: attr(data-label-on)
}

.media-player__control--fullscreen:after {
    content: attr(data-label-on);
    white-space: nowrap
}

.media-player.is-fullscreen .media-player__control--fullscreen:after {
    content: attr(data-label-off)
}

.media-player__control--volume:after {
    content: attr(data-label-on);
    left: auto;
    right: 0;
    transform: translateY(.25rem);
    white-space: nowrap
}

.media-player.is-muted .media-player__control--volume:after {
    content: attr(data-label-off)
}

.media-player.no-touch .media-player__control--volume:hover:after {
    transform: translate(0)
}

.media-player__play {
    display: none
}

.media-player.is-paused .media-player__play,
.media-player__pause {
    display: block
}

.media-player.is-paused .media-player__pause {
    display: none
}

.media-player__volume-on {
    display: block
}

.media-player.is-muted .media-player__volume-on,
.media-player__volume-off {
    display: none
}

.media-player.is-muted .media-player__volume-off {
    display: block
}

.media-player__large-play {
    background-clip: padding-box;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-position: calc(50% + 1px) 50%;
    background-repeat: no-repeat;
    border: 1px solid #0000001a;
    border-radius: 9999px;
    box-shadow: 0 1px 2px #0000001a;
    color: #fff;
    cursor: pointer;
    height: 2.75rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 125ms ease-out;
    -webkit-user-select: none;
    user-select: none;
    width: 2.75rem;
    z-index: 1000
}

.media-player--has-lightbox .media-player__large-play {
    display: none
}

@media screen and (min-width:768px) {
    .media-player__large-play {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
        height: 4.5rem;
        width: 4.5rem
    }
}

.media-player__large-play .media-player__large-play__icon {
    display: none
}

.media-player__large-play__icon {
    height: 3rem;
    width: 3rem
}

@media screen and (min-width:768px) {
    .media-player__large-play__icon {
        height: 6rem;
        width: 6rem
    }
}

.media-player__large-play.is-hidden {
    opacity: 0;
    pointer-events: none
}

.media-player {
    --active-video-offset-x: 0vw;
    --progress-bar-transition-duration: 250ms
}

.media-player__lightbox {
    background-color: #ffffff5c;
    height: 100vh;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .4s cubic-bezier(.19, 1, .22, 1);
    width: 100vw;
    will-change: opacity;
    z-index: 1000
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .media-player__lightbox {
        transition: none
    }
}

@supports (backdrop-filter:blur(1px)) {
    .media-player__lightbox {
        backdrop-filter: blur(20px)
    }
}

@supports not (backdrop-filter:blur(1px)) {
    .media-player__lightbox {
        background-color: #fffc
    }
}

.media-player--has-lightbox.is-active .media-player__lightbox {
    opacity: 1;
    pointer-events: all
}

.media-player__close {
    align-items: center;
    appearance: none;
    background-color: initial;
    background-color: #000;
    border: 0;
    border-radius: 0;
    border-radius: 9999px;
    box-shadow: 0 1px 2px #0000001a;
    display: flex;
    height: 2.5rem;
    justify-content: center;
    line-height: normal;
    margin: 0;
    opacity: 0;
    padding: 0;
    pointer-events: none;
    position: fixed;
    right: 1.5rem;
    top: 1.5rem;
    transition: opacity .25s cubic-bezier(.19, 1, .22, 1);
    width: 2.5rem;
    z-index: 1001
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .media-player__close {
        transition: none
    }
}

.media-player__close:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 1.5rem;
    content: "";
    height: 1.5rem;
    position: absolute;
    width: 1.5rem
}

.media-player--has-lightbox.is-active .media-player__close {
    opacity: 1;
    pointer-events: all
}

.media-player--has-lightbox.is-active .media-player__close:focus,
.media-player--has-lightbox.is-active .media-player__close:hover {
    background-color: #000000d9
}

.media-player__custom-play {
    align-items: center;
    appearance: none;
    background-color: initial;
    border: 0;
    border-radius: 0;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    line-height: normal;
    margin: 0;
    padding: 1rem;
    position: absolute;
    top: 0;
    transition: opacity .4s cubic-bezier(.19, 1, .22, 1), transform .4s cubic-bezier(.19, 1, .22, 1);
    width: 100%;
    z-index: 1000
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .media-player__custom-play {
        transition: none
    }
}

@media screen and (min-width:1024px) {
    .media-player__custom-play {
        align-items: flex-start;
        height: 45rem;
        justify-content: flex-start;
        width: 80rem
    }

    .media-player__custom-play:active,
    .media-player__custom-play:focus,
    .media-player__custom-play:hover {
        transform: translateX(-1rem);
        transition: transform .4s cubic-bezier(.19, 1, .22, 1)
    }
}

@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {

    .media-player__custom-play:active,
    .media-player__custom-play:focus,
    .media-player__custom-play:hover {
        transform: translateX(0)
    }
}

@media screen and (min-width:1024px) {

    .media-player__custom-play:active~.media-player__image-composition,
    .media-player__custom-play:focus~.media-player__image-composition,
    .media-player__custom-play:hover~.media-player__image-composition {
        transform: translateX(-1rem);
        transition: transform .4s cubic-bezier(.19, 1, .22, 1)
    }
}

@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {

    .media-player__custom-play:active~.media-player__image-composition,
    .media-player__custom-play:focus~.media-player__image-composition,
    .media-player__custom-play:hover~.media-player__image-composition {
        transform: translateX(0)
    }
}

.media-player__custom-play:focus .media-player__custom-play-label,
.media-player__custom-play:hover .media-player__custom-play-label {
    background-color: #000000d9
}

.media-player.is-active .media-player__custom-play {
    opacity: 0;
    pointer-events: none
}

@media screen and (min-width:1024px) {
    .media-player--reverse .media-player__custom-play {
        justify-content: flex-end;
        left: auto;
        right: 0
    }

    .media-player--reverse .media-player__custom-play:hover {
        transform: translateX(1rem)
    }
}

@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {
    .media-player--reverse .media-player__custom-play:hover {
        transform: translateX(0)
    }
}

@media screen and (min-width:1024px) {
    .media-player--reverse .media-player__custom-play:hover~.media-player__image-composition {
        transform: translateX(1rem)
    }
}

@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {
    .media-player--reverse .media-player__custom-play:hover~.media-player__image-composition {
        transform: translateX(0)
    }
}

.media-player__custom-play-label {
    align-items: center;
    background-color: #000;
    border-radius: 9999px;
    color: #fff;
    display: flex;
    font-size: .875rem;
    font-weight: 300;
    font-weight: 600;
    line-height: 1.3125rem;
    padding: .5rem 1rem
}

@media screen and (max-width:1023px) {
    .media-player__custom-play-label {
        color: #0000;
        height: 2.75rem;
        padding: 0;
        pointer-events: none;
        position: relative;
        text-indent: -100vw;
        width: 2.75rem
    }
}

.media-player__custom-play-label:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    background-position: calc(50% + 1px) 50%;
    background-repeat: no-repeat;
    background-size: 1.5rem;
    content: "";
    height: 1.5rem;
    margin-right: .5rem;
    width: 1.5rem
}

@media screen and (max-width:1023px) {
    .media-player__custom-play-label:before {
        height: 100%;
        margin-right: 0;
        position: absolute;
        width: 100%
    }
}

.media-player__image-composition {
    align-items: flex-start;
    background-clip: padding-box;
    background-color: #fffc;
    border: 1px solid #0000001a;
    border-radius: 8px;
    box-shadow: 0 8px 16px #0000001a;
    display: flex;
    height: 100%;
    pointer-events: none;
    width: 100%
}

@supports (backdrop-filter:blur(1px)) {
    .media-player__image-composition {
        backdrop-filter: blur(32px);
        background-color: #f9f9f95c
    }
}

@media screen and (min-width:1024px) {
    .media-player__image-composition {
        align-items: flex-end;
        height: 45rem;
        width: 80rem
    }
}

.media-player--has-lightbox .media-player__image-composition {
    position: absolute;
    transition: opacity .4s cubic-bezier(.19, 1, .22, 1), transform .4s cubic-bezier(.19, 1, .22, 1);
    z-index: 10
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .media-player--has-lightbox .media-player__image-composition {
        transition: none
    }
}

.media-player--has-lightbox.is-active .media-player__image-composition {
    opacity: 0;
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none
}

.media-player--reverse .media-player__image-composition {
    right: 0
}

.media-player__image-composition-mask {
    align-items: flex-start;
    border-radius: 8px;
    display: flex;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    width: 100%
}

@media screen and (min-width:1024px) {
    .media-player__image-composition-mask {
        align-items: flex-end
    }
}

.media-player--has-lightbox:not(.is-active) .media-player__controls,
.media-player--has-lightbox:not(.is-active) .media-player__progress-bar,
.media-player--has-lightbox:not(.is-active) .media-player__video-wrapper {
    opacity: 0;
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none
}

.media-player--has-lightbox .media-player__video-wrapper {
    transition: opacity .4s cubic-bezier(.19, 1, .22, 1);
    z-index: 1
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .media-player--has-lightbox .media-player__video-wrapper {
        transition: none
    }
}

@media screen and (min-width:1024px) {
    .media-player--has-lightbox .media-player__video-wrapper {
        min-width: 85vw
    }
}

@media screen and (min-width:1024px) and (min-aspect-ratio:16/9) {
    .media-player--has-lightbox .media-player__video-wrapper {
        height: 85vh;
        min-width: auto;
        width: 151vh
    }
}

@media screen and (max-width:1023px) {
    .media-player--has-lightbox.is-active .media-player__video-wrapper {
        border-radius: 0
    }
}

.media-player.is-fullscreen .media-player__video {
    height: 100vh;
    width: 100vw
}

.ribbon-large {
    background-color: #212123;
    overflow: hidden;
    position: relative;
    width: 100%;
    z-index: 101
}

.ribbon-large ::selection {
    background: #fff;
    color: #212123
}

@media screen and (max-width:1023px) {
    .ribbon-large .pad-viewport {
        padding-left: 0;
        padding-right: 0
    }
}

@media screen and (min-width:1024px) and (max-width:1219px) {
    .ribbon-large .pad-viewport {
        padding-right: 0
    }
}

.ribbon-large.hide {
    height: 0;
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none
}

.ribbon-large~.main-nav:not(.is-active) {
    box-shadow: 0 -1px 0 0 #00000014
}

.ribbon-large~.main-nav:not(.is-active):not(.is-sticky) {
    backdrop-filter: unset
}

@media screen and (prefers-color-scheme:dark) and (max-width:1023px) {
    .ribbon-large~.main-nav:not(.is-active):not(.main-nav--blurred) {
        box-shadow: 0 -1px 0 0 #fff3, 0 1px 0 0 #000
    }
}

.ribbon-large__wrapper {
    align-items: center;
    display: flex;
    gap: 3.625rem;
    height: 5rem;
    justify-content: space-between
}

.ribbon-large__message-container {
    display: flex;
    gap: .75rem;
    justify-content: center;
    min-width: 38.75rem
}

@media screen and (min-width:1024px) {
    .ribbon-large__message-container {
        justify-content: flex-start
    }
}

.ribbon-large__message {
    color: #fafafa;
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.5rem
}

.ribbon-large__message a,
.ribbon-large__message span {
    color: #212123;
    color: #fff;
    font-weight: 500;
    text-decoration-color: #0003;
    text-decoration-color: #fff3;
    text-decoration-line: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 4px;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {

    .ribbon-large__message a,
    .ribbon-large__message span {
        transition-duration: 1ms
    }
}

.ribbon-large__message a:active,
.ribbon-large__message a:hover,
.ribbon-large__message span:active,
.ribbon-large__message span:hover {
    color: #0000007a;
    color: #ffffff7a
}

@media screen and (min-width:1024px) {

    .ribbon-large__message a,
    .ribbon-large__message span {
        margin-left: 1rem
    }
}

.ribbon-large__message strong {
    font-weight: 600
}

.ribbon-large__video-container {
    height: 100%;
    width: 100%
}

@media screen and (min-width:1220px) {
    .ribbon-large__video-container {
        max-width: 30.375rem
    }
}

.ribbon-large__video-container .video {
    display: flex;
    height: 100%
}

.ribbon-large__video-container .video:hover .media-player__large-play {
    transform: scale(1.1)
}

@media screen and (min-width:1024px) {
    .ribbon-large__video-container .video:hover .media-player__large-play {
        transform: translate(-50%, -50%) scale(1.1)
    }
}

.ribbon-large__video-container .video:not(.mave-pop) .media-player__video-wrapper:before {
    content: unset
}

.ribbon-large__video-container .video:not(.mave-pop) .media-player__large-play {
    display: none
}

.ribbon-large__video-container .video:not(.mave-pop) .ribbon-large__message {
    text-align: center
}

.ribbon-large__video-container .media-player__video-wrapper {
    border-radius: 0;
    display: flex
}

.ribbon-large__video-container .media-player__video-wrapper:before {
    background-color: #0000007a;
    background-image: none;
    opacity: 1
}

@media screen and (max-width:1023px) {
    .ribbon-large__video-container .media-player__video-wrapper:before {
        background-color: unset
    }
}

.ribbon-large__video-container .video__preview {
    object-fit: cover;
    width: 100%
}

.ribbon-large__video-overlay {
    align-items: center;
    display: flex;
    gap: 1.5rem;
    inset: 0 0 0 0;
    justify-content: center;
    padding: 1rem;
    position: absolute
}

@media screen and (max-width:1023px) {
    .ribbon-large__video-overlay {
        backdrop-filter: blur(10px);
        background-color: #000000a3
    }
}

.ribbon-large__video-overlay .media-player__large-play {
    background-color: #f26725;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    flex: 0 0 auto;
    height: 2.75rem;
    transition: transform .25s ease-in-out;
    width: 2.75rem
}

@media screen and (max-width:1023px) {
    .ribbon-large__video-overlay .media-player__large-play {
        position: static;
        transform: none
    }
}

.secondary-nav {
    background-color: #fff;
    box-shadow: 0 0 0 1px #0000001a;
    color: #212123;
    overflow: visible;
    position: sticky;
    top: 0;
    z-index: 100
}

@supports (backdrop-filter:blur(1px)) {
    .secondary-nav {
        backdrop-filter: blur(10px);
        background-color: #fffc
    }
}

@media screen and (max-width:1023px) {
    .secondary-nav {
        top: 4rem
    }
}

.secondary-nav.has-focused-search {
    z-index: 999
}

.secondary-nav--static {
    position: static
}

.secondary-nav--transparent {
    backdrop-filter: none;
    background-color: initial;
    box-shadow: none
}

.secondary-nav__content {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 4rem;
    padding: .375rem 0
}

.secondary-nav__nav-items {
    display: flex;
    line-height: 1.5rem;
    list-style-type: none;
    margin: 0 1.5rem 0 0;
    overflow: auto;
    padding: 0 2rem 0 0;
    transition: width .25s cubic-bezier(.25, .46, .45, .94), opacity .25s cubic-bezier(.25, .46, .45, .94);
    white-space: nowrap;
    width: calc(100% - 2rem)
}

.secondary-nav__nav-items::-webkit-scrollbar {
    display: none
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .secondary-nav__nav-items {
        transition-duration: 1ms
    }
}

@media screen and (min-width:1024px) {
    .secondary-nav__nav-items {
        padding-right: 4rem
    }
}

@-moz-document url-prefix() {
    .secondary-nav__nav-items {
        scrollbar-width: none
    }
}

.secondary-nav.has-focused-search .secondary-nav__nav-items {
    margin-right: 0;
    opacity: 0;
    padding-right: 0;
    width: 0
}

.secondary-nav__nav-item {
    color: #000;
    display: inline-block;
    font-weight: 500;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .secondary-nav__nav-item {
        transition-duration: 1ms
    }
}

.secondary-nav__nav-item:active,
.secondary-nav__nav-item:hover {
    color: #0000007a
}

.secondary-nav__nav-item+.secondary-nav__nav-item:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    content: "";
    display: inline-block;
    height: 1rem;
    margin-left: .25rem;
    margin-right: .25rem;
    vertical-align: middle;
    width: 1rem
}

.secondary-nav__nav-item__chevron-left {
    display: inline-block;
    vertical-align: center
}

.secondary-nav__nav-item__chevron-left [stroke] {
    stroke: currentColor
}

.secondary-nav__search {
    text-align: center;
    transition: width .25s cubic-bezier(.19, 1, .22, 1);
    width: 20rem
}

.secondary-nav.has-focused-search .secondary-nav__search {
    width: 100%
}

@media screen and (max-width:639px) {
    .secondary-nav__search {
        width: 1.5rem
    }
}

.secondary-nav__search .algolia-autocomplete {
    max-width: 20rem;
    transition: max-width .25s cubic-bezier(.19, 1, .22, 1);
    width: 100%
}

.secondary-nav__search.is-above-overlay .algolia-autocomplete {
    max-width: 36.75rem
}

.secondary-nav__search__input {
    cursor: pointer;
    line-height: 1rem;
    width: 100%
}

.secondary-nav__search__input:enabled {
    background-color: #fff
}

.secondary-nav:not(.has-focused-search) .secondary-nav__search__input {
    font-size: 1rem;
    min-height: 2.25rem;
    padding-bottom: .25rem;
    padding-top: .25rem
}

@media screen and (max-width:639px) {
    .secondary-nav:not(.has-focused-search) .secondary-nav__search__input:enabled {
        background-color: initial;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
        background-position-x: 0;
        background-size: contain;
        border: 0;
        box-shadow: none;
        padding-left: 0
    }

    .secondary-nav:not(.has-focused-search) .secondary-nav__search__input:enabled::placeholder {
        opacity: 0
    }
}

.snackbar {
    align-items: center;
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid #ffffff1a;
    border-radius: 12px;
    bottom: 1.5rem;
    box-shadow: 0 4px 8px 0 #0000001a;
    color: #212123;
    display: flex;
    font-size: .875rem;
    font-weight: 300;
    left: 50%;
    line-height: 1.3125rem;
    line-height: 1rem;
    max-width: 27.5rem;
    padding: 1rem 1.25rem;
    position: fixed;
    transform: translate(-50%, 200%);
    transition: transform .25s cubic-bezier(.19, 1, .22, 1);
    width: calc(100% - 3.5rem);
    z-index: 1000
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .snackbar {
        transition-duration: 1ms
    }
}

.snackbar.is-visible {
    transform: translate(-50%);
    transition: transform .25s cubic-bezier(.19, 1, .22, 1)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .snackbar.is-visible {
        transition-duration: 1ms
    }
}

.snackbar__body {
    font-weight: 600
}

.snackbar__body a {
    color: inherit;
    font-weight: inherit;
    text-decoration: none;
    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .snackbar__body a {
        transition-duration: 1ms
    }
}

.snackbar__body a:focus,
.snackbar__body a:hover {
    opacity: .65
}

.snackbar__body em {
    font-style: italic
}

.snackbar__body strong {
    font-weight: 700
}

.snackbar__close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    background-position: 50%;
    background-repeat: no-repeat;
    cursor: pointer;
    height: 1rem;
    margin-left: auto;
    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955);
    width: 1rem
}

@media percy,
screen and (prefers-reduced-motion:reduce) {
    .snackbar__close {
        transition-duration: 1ms
    }
}

.snackbar__close:hover {
    opacity: 1
}

.snackbar--error {
    background-color: #c00;
    color: #fff
}

.snackbar--error .snackbar__close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___})
}

.snackbar--warning {
    background-color: #e6ac00;
    color: #212123
}

.snackbar--warning .snackbar__close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___})
}

.snackbar--success {
    background-color: #13bf3e;
    color: #fff
}

.snackbar--top {
    bottom: auto;
    top: 4.5rem;
    transform: translate(-50%, -300%)
}

.snackbar--no-max-width {
    width: calc(100% - 2rem)
}

@media screen and (min-width:768px) {
    .snackbar--no-max-width {
        max-width: none;
        width: auto
    }
}

.snackbar--no-max-width .snackbar__close {
    margin-left: 1rem
}

.support__contact .wrapper {
    border-top: 1px solid #e6e6e6;
    padding: 4rem 0
}

@media screen and (min-width:768px) {
    .support__contact .wrapper {
        padding: 6rem 0
    }
}

.support__contact__title {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: -.03125rem;
    line-height: 2.25rem;
    margin-bottom: 1rem
}

@media screen and (max-width:767px) {
    .support__contact__title {
        font-size: 1.625rem;
        line-height: 2rem
    }
}

.support__contact__lead {
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.5rem
}

.support__contact__lead,
.support__contact__title {
    color: #212123
}

.support__contact__actions {
    margin-top: 1.5rem
}

.support__features__list {
    grid-gap: 3rem;
    display: grid;
    grid-template-columns: 1fr;
    margin: 0 auto
}

@media screen and (min-width:640px) {
    .support__features__list {
        grid-gap: 3rem 1.5rem;
        grid-template-columns: repeat(2, 1fr)
    }
}

.support__feature__title {
    font-size: 1.5rem;
    font-weight: 700;
    font-weight: 600;
    line-height: 2rem;
    margin-bottom: .25rem
}

@media screen and (max-width:767px) {
    .support__feature__title {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.75rem
    }
}

@media screen and (min-width:768px) {
    .support__feature__title {
        margin-bottom: .5rem
    }
}

.support__feature__lead {
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.5rem;
    margin-bottom: 1.25rem
}

.support__feature__action {
    color: #212123;
    font-size: 1rem;
    font-weight: 300;
    font-weight: 600;
    line-height: 1.5rem
}

.support__feature__action:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
    background-size: contain;
    content: "";
    display: inline-block;
    height: 1.5rem;
    opacity: .32;
    vertical-align: -.4375em;
    width: 1.5rem
}

.support__feature__action:hover {
    text-decoration: none
}

.support__feature__image {
    border-radius: 6px;
    display: block;
    margin-bottom: 1.5rem;
    max-width: 100%;
    overflow: hidden
}

.text-callout {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005;
    color: #212123;
    display: flex;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    margin-bottom: 1.5rem;
    padding: 1.25rem;
    position: relative
}

.text-callout strong {
    font-weight: 500
}

.text-callout__icon {
    display: block;
    flex: 0 0 auto;
    height: 1.25rem;
    margin-right: .75rem;
    margin-top: .125rem;
    width: 1.25rem
}

.text-callout--red {
    background-color: #f267251a
}

.text-callout--red .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--red .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #c00
}

.text-callout--red .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--red .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #c00
}

.styled-text .text-callout--red a,
.text-callout--red .text-callout__icon [color],
.text-callout--red .text-callout__icon[color] {
    color: #c00
}

.text-callout--beige {
    background-color: #fbf3da
}

.text-callout--beige .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--beige .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #f5a925
}

.text-callout--beige .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--beige .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #f5a925
}

.styled-text .text-callout--beige a,
.text-callout--beige .text-callout__icon [color],
.text-callout--beige .text-callout__icon[color] {
    color: #f5a925
}

.text-callout--teal {
    background-color: #83d7cf1a
}

.text-callout--teal .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--teal .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #3fb2a5
}

.text-callout--teal .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--teal .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #3fb2a5
}

.styled-text .text-callout--teal a,
.text-callout--teal .text-callout__icon [color],
.text-callout--teal .text-callout__icon[color] {
    color: #3fb2a5
}

.text-callout--purple {
    background-color: #d097db1a
}

.text-callout--purple .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--purple .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #a060ae
}

.text-callout--purple .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--purple .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #a060ae
}

.styled-text .text-callout--purple a,
.text-callout--purple .text-callout__icon [color],
.text-callout--purple .text-callout__icon[color] {
    color: #a060ae
}

.text-callout--green {
    background-color: #bbd9751a
}

.text-callout--green .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--green .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #85b532
}

.text-callout--green .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--green .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #85b532
}

.styled-text .text-callout--green a,
.text-callout--green .text-callout__icon [color],
.text-callout--green .text-callout__icon[color] {
    color: #85b532
}

.text-callout--coal {
    background-color: #fafafa
}

.text-callout--coal .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--coal .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #212123
}

.text-callout--coal .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--coal .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #212123
}

.styled-text .text-callout--coal a,
.text-callout--coal .text-callout__icon [color],
.text-callout--coal .text-callout__icon[color] {
    color: #212123
}

.text-callout--white {
    background-color: #fff
}

.text-callout--white .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--white .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #212123
}

.text-callout--white .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--white .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #212123
}

.styled-text .text-callout--white a,
.text-callout--white .text-callout__icon [color],
.text-callout--white .text-callout__icon[color] {
    color: #212123
}

.text-callout--gray {
    background-color: #0000000a
}

.text-callout--gray .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),
.text-callout--gray .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {
    stroke: #212123
}

.text-callout--gray .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),
.text-callout--gray .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {
    fill: #212123
}

.styled-text .text-callout--gray a,
.text-callout--gray .text-callout__icon [color],
.text-callout--gray .text-callout__icon[color] {
    color: #212123
}

.user-profile {
    height: 2.5rem
}

@media screen and (max-width:1023px) {
    .user-profile {
        background: #0000;
        border: none;
        box-shadow: none;
        padding: 0
    }
}

.user-profile__label {
    display: none
}

@media screen and (min-width:1024px) {
    .user-profile__label {
        display: block
    }
}

.user-profile__avatar {
    border-radius: 9999px;
    display: block;
    height: 1.5rem;
    margin-right: .5rem;
    object-fit: cover;
    object-position: center;
    position: relative;
    width: 1.5rem
}

.artboard {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    position: relative;
    will-change: transform
}

@media screen and (min-width:1024px) {
    .artboard--fixed {
        position: absolute
    }
}

.artboard--symbol .artboard__name {
    color: #b620e0
}

.artboard__name {
    align-items: center;
    color: #858585;
    cursor: default;
    display: flex;
    font-size: .75rem;
    gap: .25rem;
    letter-spacing: -.4px;
    line-height: 1rem;
    margin-bottom: .25rem;
    margin-left: .25rem
}

.artboard:not(.artboard--selected) .artboard__name:hover+.artboard__body {
    position: relative
}

.artboard:not(.artboard--selected) .artboard__name:hover+.artboard__body:before {
    background-color: initial;
    border: 2px solid #f26725;
    bottom: 0;
    content: "";
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%
}

.artboard__body {
    background-color: #fff;
    box-shadow: 0 0 2px #0000001a, 0 2px 4px #0000001a
}

.artboard--selected,
.artboard__body {
    position: relative
}

.artboard--selected .artboard__body {
    border: .5px solid #f26725
}

.artboard--selected .artboard__body:after,
.artboard--selected .artboard__body:before {
    background-color: #fff;
    border: .5px solid #00000040;
    box-shadow: 0 1px 2px #0003;
    content: "";
    display: block;
    height: .5rem;
    position: absolute;
    width: .5rem
}

.artboard--selected .artboard__body:before {
    left: -.25rem;
    top: -.25rem
}

.artboard--selected .artboard__body:after {
    right: -.25rem;
    top: -.25rem
}

@media screen and (min-width:1024px) {
    .artboard--selected .artboard__body {
        border: 0;
        outline: .5px solid #f26725
    }
}

.artboard--selected:after,
.artboard--selected:before {
    background-color: #fff;
    border: .5px solid #00000040;
    box-shadow: 0 1px 2px #0003;
    content: "";
    display: block;
    height: .5rem;
    position: absolute;
    width: .5rem;
    z-index: 10
}

.artboard--selected:before {
    bottom: -.25rem;
    left: -.25rem
}

.artboard--selected:after {
    bottom: -.25rem;
    right: -.25rem
}

.artboard--moving .artboard__body:after,
.artboard--moving .artboard__body:before,
.artboard--moving:after,
.artboard--moving:before {
    display: none
}

.artboard__asset {
    display: block
}

@media screen and (max-width:1023px) {
    .artboard__asset {
        max-width: 100%
    }
}

.artboard--full-width .artboard__body {
    width: 100%
}

@font-face {
    font-family: swiper-icons;
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff");
}

:root {
    --swiper-theme-color: #007aff
}

.swiper {
    list-style: none;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    padding: 0;
    position: relative;
    z-index: 1
}

.swiper-vertical>.swiper-wrapper {
    flex-direction: column
}

.swiper-wrapper {
    box-sizing: initial;
    display: flex;
    height: 100%;
    position: relative;
    transition-property: transform;
    width: 100%;
    z-index: 1
}

.swiper-android .swiper-slide,
.swiper-wrapper {
    transform: translateZ(0)
}

.swiper-pointer-events {
    touch-action: pan-y
}

.swiper-pointer-events.swiper-vertical {
    touch-action: pan-x
}

.swiper-slide {
    flex-shrink: 0;
    height: 100%;
    position: relative;
    transition-property: transform;
    width: 100%
}

.swiper-slide-invisible-blank {
    visibility: hidden
}

.swiper-autoheight,
.swiper-autoheight .swiper-slide {
    height: auto
}

.swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height
}

.swiper-backface-hidden .swiper-slide {
    backface-visibility: hidden;
    transform: translateZ(0)
}

.swiper-3d,
.swiper-3d.swiper-css-mode .swiper-wrapper {
    perspective: 1200px
}

.swiper-3d .swiper-cube-shadow,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-wrapper {
    transform-style: preserve-3d
}

.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10
}

.swiper-3d .swiper-slide-shadow {
    background: #00000026
}

.swiper-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(270deg, #00000080, #0000)
}

.swiper-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(90deg, #00000080, #0000)
}

.swiper-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(0deg, #00000080, #0000)
}

.swiper-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(180deg, #00000080, #0000)
}

.swiper-css-mode>.swiper-wrapper {
    -ms-overflow-style: none;
    overflow: auto;
    scrollbar-width: none
}

.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar {
    display: none
}

.swiper-css-mode>.swiper-wrapper>.swiper-slide {
    scroll-snap-align: start start
}

.swiper-horizontal.swiper-css-mode>.swiper-wrapper {
    scroll-snap-type: x mandatory
}

.swiper-vertical.swiper-css-mode>.swiper-wrapper {
    scroll-snap-type: y mandatory
}

.swiper-centered>.swiper-wrapper:before {
    content: "";
    flex-shrink: 0;
    order: 9999
}

.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child {
    margin-inline-start: var(--swiper-centered-offset-before)
}

.swiper-centered.swiper-horizontal>.swiper-wrapper:before {
    height: 100%;
    width: var(--swiper-centered-offset-after)
}

.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child {
    margin-block-start: var(--swiper-centered-offset-before)
}

.swiper-centered.swiper-vertical>.swiper-wrapper:before {
    height: var(--swiper-centered-offset-after);
    width: 100%
}

.swiper-centered>.swiper-wrapper>.swiper-slide {
    scroll-snap-align: center center;
    scroll-snap-stop: always
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transform: translateZ(0);
    transition: opacity .3s;
    z-index: 10
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0
}

.swiper-pagination-disabled>.swiper-pagination,
.swiper-pagination.swiper-pagination-disabled {
    display: none !important
}

.swiper-horizontal>.swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal,
.swiper-pagination-custom,
.swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%
}

.swiper-pagination-bullets-dynamic {
    font-size: 0;
    overflow: hidden
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    position: relative;
    transform: scale(.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    transform: scale(.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    transform: scale(.33)
}

.swiper-pagination-bullet {
    background: var(--swiper-pagination-bullet-inactive-color, #000);
    border-radius: 50%;
    display: inline-block;
    height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
    opacity: var(--swiper-pagination-bullet-inactive-opacity, .2);
    width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px))
}

button.swiper-pagination-bullet {
    appearance: none;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 0
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer
}

.swiper-pagination-bullet:only-child {
    display: none !important
}

.swiper-pagination-bullet-active {
    background: var(--swiper-pagination-color, var(--swiper-theme-color));
    opacity: var(--swiper-pagination-bullet-opacity, 1)
}

.swiper-pagination-vertical.swiper-pagination-bullets,
.swiper-vertical>.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0)
}

.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
    display: block;
    margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0
}

.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    transform: translateY(-50%);
    width: 8px
}

.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    display: inline-block;
    transition: transform .2s, top .2s
}

.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px)
}

.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap
}

.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: transform .2s, left .2s
}

.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: transform .2s, right .2s
}

.swiper-pagination-progressbar {
    background: #00000040;
    position: absolute
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: var(--swiper-pagination-color, var(--swiper-theme-color));
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: scale(0);
    transform-origin: left top;
    width: 100%
}

.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    transform-origin: right top
}

.swiper-horizontal>.swiper-pagination-progressbar,
.swiper-pagination-progressbar.swiper-pagination-horizontal,
.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,
.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    height: 4px;
    left: 0;
    top: 0;
    width: 100%
}

.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,
.swiper-pagination-progressbar.swiper-pagination-vertical,
.swiper-vertical>.swiper-pagination-progressbar {
    height: 100%;
    left: 0;
    top: 0;
    width: 4px
}

.swiper-pagination-lock {
    display: none
}

.swiper-fade.swiper-free-mode .swiper-slide {
    transition-timing-function: ease-out
}

.swiper-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity
}

.swiper-fade .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-fade .swiper-slide-active,
.swiper-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.customer-stories .artboard__body {
    box-shadow: 0 2px 4px #0000001a, 0 0 2px #0000001a;
    max-width: 100%
}

.customer-stories__story {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    padding: 2rem 1.75rem 0
}

@media screen and (min-width:768px) {
    .customer-stories__story {
        padding: 3.5rem 3.5rem 0
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__story {
        align-items: stretch;
        flex-wrap: nowrap;
        padding: 4.75rem 2rem 0 3.25rem
    }
}

@media screen and (min-width:1220px) {
    .customer-stories__story {
        padding-left: 4.375rem
    }
}

.customer-stories__content {
    min-height: 25.25rem;
    opacity: 0;
    position: relative;
    transition: opacity .25s ease-in-out, transform .4s ease-in-out
}

.customer-stories__content:before {
    content: "“";
    font-size: 3.625rem;
    font-weight: 500;
    left: 0;
    line-height: 2rem;
    position: absolute;
    top: 1.125rem
}

@media screen and (min-width:768px) {
    .customer-stories__content:before {
        left: -2.125rem;
        top: .875rem
    }
}

@media screen and (max-width:767px) {
    .customer-stories__content {
        padding: 2.25rem 0
    }
}

@media screen and (min-width:768px) {
    .customer-stories__content {
        min-height: 14.75rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__content {
        margin-right: auto;
        max-width: 29.75rem;
        min-height: 16.75rem
    }
}

@media screen and (min-width:1220px) {
    .customer-stories__content {
        margin-right: auto;
        max-width: 36.75rem;
        min-height: 14.75rem
    }
}

.swiper--move-all-to-the-left .customer-stories__content {
    transform: translateX(1.25rem)
}

.swiper--move-all-to-the-left .customer-stories__content.do-not-return-to-starting-position,
.swiper--move-all-to-the-right .customer-stories__content {
    transform: translateX(-1.25rem)
}

.swiper--move-all-to-the-right .customer-stories__content.do-not-return-to-starting-position {
    transform: translateX(1.25rem)
}

.swiper-slide-active .customer-stories__content {
    opacity: 1;
    transform: translateX(0)
}

.customer-stories__company-info {
    background-color: #fff;
    border-top: 1px solid #00000014;
    padding-top: 2.25rem;
    width: 100%;
    z-index: 1
}

@media screen and (min-width:768px) and (max-width:1023px) {
    .customer-stories__company-info {
        margin-top: 2.25rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info {
        align-items: center;
        border-left: 1px solid #00000014;
        border-top: none;
        display: flex;
        max-width: 16.8125rem;
        padding-left: 2rem;
        padding-top: 0
    }
}

@media screen and (min-width:1220px) {
    .customer-stories__company-info {
        max-width: 21.5rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info__image-link {
        margin: 0 auto
    }
}

.customer-stories__company-info__inner {
    align-items: center;
    display: flex;
    opacity: 0;
    transform: scale(.95) translateY(.625rem);
    transition: opacity .25s ease-in-out, transform .4s ease-in-out
}

@media screen and (min-width:768px) and (max-width:1023px) {
    .customer-stories__company-info__inner {
        max-width: 27.5rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info__inner {
        flex-wrap: wrap
    }
}

.customer-stories__company-info__title {
    display: none;
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.5rem
}

@media screen and (max-width:1023px) {
    .customer-stories__company-info--no-link .customer-stories__company-info__title {
        display: block;
        font-size: 1rem;
        font-weight: 300;
        line-height: 1.5rem;
        margin: 0 0 0 1rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info__title {
        display: block;
        min-width: 14.8125rem;
        text-align: center
    }
}

@media screen and (min-width:1220px) {
    .customer-stories__company-info__title {
        min-width: 19.5rem
    }
}

.customer-stories__company-info__link {
    margin: 0 auto;
    width: fit-content
}

.customer-stories__company-info__link svg {
    color: #00000052;
    vertical-align: top
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info__link {
        display: block;
        margin-top: 1.25rem;
        order: 1
    }
}

.customer-stories__company-info__link--mobile {
    color: #212123;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.5rem;
    margin-left: 1rem
}

@media screen and (min-width:768px) {
    .customer-stories__company-info__link--mobile {
        margin-left: 1.25rem;
        margin-top: 0
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__company-info__link--mobile {
        display: none
    }
}

.swiper-slide-active .customer-stories__company-info__inner {
    opacity: 1;
    transform: scale(1)
}

.customer-stories__company-logo {
    border-radius: 6px;
    height: 4rem;
    width: 4rem
}

@media screen and (min-width:1024px) {
    .customer-stories__company-logo {
        display: block;
        height: 4.5rem;
        margin: 0 auto 1.25rem;
        width: 4.5rem
    }
}

.customer-stories__quote {
    font-size: 1.25rem;
    letter-spacing: -.03125rem;
    line-height: 1.75rem
}

@media screen and (min-width:768px) {
    .customer-stories__quote {
        font-size: 1.5rem;
        line-height: 2rem
    }
}

@media screen and (min-width:1024px) {
    .customer-stories__quote {
        min-width: 29.75rem
    }
}

@media screen and (min-width:1220px) {
    .customer-stories__quote {
        min-width: 36.75rem
    }
}

.customer-stories__author {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem
}

.customer-stories__author__name {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    width: 100%
}

.customer-stories__author__date,
.customer-stories__author__position {
    font-size: .875rem;
    font-weight: 300;
    line-height: 1.25rem
}

.customer-stories__author__date {
    opacity: .64
}

.customer-stories__author__avatar {
    border: 2px solid #83d7cf;
    border-radius: 9999px;
    height: 3rem;
    margin-right: 1rem;
    padding: .125rem;
    width: 3rem
}

.customer-stories .swiper-pagination {
    bottom: 0;
    display: flex;
    justify-content: center;
    margin-top: 2.25rem;
    padding-bottom: 1.5rem;
    position: relative
}

@media screen and (min-width:1024px) {
    .customer-stories .swiper-pagination {
        margin-top: 1.5rem
    }
}

@keyframes customer-stories-fill-circle {
    0% {
        stroke-dashoffset: 114
    }

    to {
        stroke-dashoffset: 0
    }
}

.customer-stories__paginator-item {
    cursor: pointer;
    opacity: .48;
    padding: .5rem;
    position: relative
}

@media screen and (max-width:1023px) {
    .customer-stories__paginator-item:not(:last-child) {
        margin-right: .5rem
    }
}

.customer-stories__paginator-item .customer-stories__paginator-circle {
    display: none
}

.customer-stories__paginator-item--active {
    opacity: 1
}

.customer-stories__paginator-item--active .customer-stories__paginator-circle {
    display: block
}

.customer-stories__paginator-item--active .customer-stories__paginator-circle--progress {
    stroke-dasharray: 114;
    animation: customer-stories-fill-circle var(--animation-time) linear forwards
}

.customer-stories__paginator-item svg {
    left: 0;
    position: absolute;
    top: 0;
    transform: rotate(-90deg)
}

.customer-stories__paginator-item img {
    border-radius: 9999px;
    height: 1.5rem;
    width: 1.5rem
}

.customer-stories-section {
    background-color: #fafafa;
    padding-bottom: 4rem;
    padding-top: 4rem
}

@media screen and (min-width:1024px) {
    .customer-stories-section {
        padding-bottom: 6rem;
        padding-top: 6rem
    }
}

.customer-stories-section__title {
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: -.5px;
    line-height: 2.5rem;
    margin-bottom: 2.75rem;
    text-align: center
}

@media screen and (max-width:767px) {
    .customer-stories-section__title {
        font-size: 1.75rem;
        line-height: 2rem
    }
}

.customer-stories-section__inner {
    position: relative
}

@media screen and (min-width:1024px) {
    .customer-stories-section .wrapper {
        padding-left: 1.25rem;
        padding-right: 1.25rem
    }
}

@media screen and (min-width:1024px) and (min-width:1024px) {
    .customer-stories-section .wrapper {
        padding-left: 2rem;
        padding-right: 2rem
    }
}

.customer-stories-section--with-borders {
    border-bottom: 1px solid #00000014;
    border-top: 1px solid #00000014
}

.get-started-sticker {
    margin-bottom: 4rem;
    margin-top: 4rem
}

@media screen and (min-width:1024px) {
    .get-started-sticker {
        margin-bottom: 6rem;
        margin-top: 6rem
    }
}

.get-started-sticker--no-margins {
    margin-bottom: 0;
    margin-top: 0
}

.get-started-sticker--with-divider .wrapper {
    padding-top: 4rem;
    position: relative
}

.get-started-sticker--with-divider .wrapper:before {
    border-top: 1px solid #00000014;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0
}

@media screen and (min-width:1024px) {
    .get-started-sticker--with-divider .wrapper {
        padding-top: 6rem
    }
}

.get-started-sticker__sticker {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    display: block;
    height: 7.75rem;
    margin: 0 auto 1.5rem;
    -webkit-mask-image: -webkit-radial-gradient(#fff, #000);
    width: 7.75rem
}

.get-started-sticker__heading {
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -.5px;
    line-height: 2.75rem;
    margin: 0 auto 2rem;
    max-width: 20.5rem;
    text-align: center
}

@media screen and (min-width:768px) {
    .get-started-sticker__heading {
        font-size: 2.75rem;
        letter-spacing: -1px;
        line-height: 3.5rem;
        margin-bottom: 2.25rem;
        max-width: 32.5rem
    }
}

@media screen and (min-width:1024px) {
    .get-started-sticker__heading {
        max-width: 36.75rem
    }
}

.get-started-sticker__heading em {
    color: #f26725;
    display: block;
    font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 2.75rem;
    font-weight: 700;
    line-height: 2rem
}

@media screen and (min-width:768px) {
    .get-started-sticker__heading em {
        font-size: 3.5rem;
        letter-spacing: -1px;
        margin-top: .5rem
    }
}

.get-started-sticker__blurb {
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.5rem;
    margin: 0 auto 1.5rem;
    max-width: 18rem;
    text-align: center
}

@media screen and (min-width:1024px) {
    .get-started-sticker__blurb {
        font-size: 1.25rem;
        line-height: 1.75rem
    }
}

@media screen and (min-width:768px) {
    .get-started-sticker__blurb {
        max-width: 29.5rem
    }
}

@media screen and (min-width:1024px) {
    .get-started-sticker__blurb {
        margin: 0 auto 1.5rem;
        max-width: 32.5rem;
        max-width: 36.75rem
    }
}

.get-started-sticker__actions {
    text-align: center
}

.artboard.pitch .artboard__body {
    padding: 2rem 1.25rem
}

@media screen and (min-width:768px) {
    .artboard.pitch .artboard__body {
        padding: 3.5rem
    }
}

.event-dialog {
    align-items: center;
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid #00000014;
    border-radius: 12px;
    box-shadow: 0 4px 8px #00000014;
    color: #212123;
    display: flex;
    flex-direction: column;
    max-width: 29.6875rem;
    overflow: hidden;
    padding: 1.5rem;
    width: 100%
}

@media screen and (min-width:1024px) {
    .event-dialog {
        max-width: 36.75rem
    }
}

.event-dialog__header {
    width: 100%
}

.event-dialog__asset {
    aspect-ratio: auto;
    border-radius: 0;
    height: 9.25rem;
    margin: -1.5rem -1.5rem 1.5rem;
    object-fit: cover;
    object-position: center;
    overflow: visible;
    width: calc(100% + 3rem)
}

.event-dialog__title {
    color: #212123;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -.5px;
    line-height: 2rem;
    margin-bottom: .5rem
}

.event-dialog__content {
    color: #212123;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.5rem;
    width: 100%
}

.event-dialog__content strong {
    font-weight: 600
}

.event-dialog__content em {
    font-style: italic
}

.event-dialog__content p {
    margin-bottom: 1rem
}

.event-dialog__content p:last-of-type {
    margin-bottom: 0
}

.event-dialog__content a:not(.button) {
    color: #212123;
    font-weight: 500;
    text-decoration-color: #0003;
    text-decoration-line: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 4px;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .event-dialog__content a:not(.button) {
        transition-duration: 1ms
    }
}

.event-dialog__content a:not(.button):active,
.event-dialog__content a:not(.button):hover {
    color: #0000007a
}

.event-dialog__actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: .5rem;
    margin-top: 1.5rem;
    width: 100%
}

.event-dialog__action,
.event-dialog__button {
    width: 100%
}

.event-dialog__footer {
    margin-top: 1rem;
    opacity: .64
}

.event-dialog__footer p {
    font-size: .875rem
}

.input-group {
    align-items: stretch;
    display: flex;
    width: 100%
}

.input-group--gap {
    gap: .5rem
}

.overflow-blur {
    mask-image: linear-gradient(90deg, #000 90%, #0000);
    position: relative
}

.overflow-blur--scrolled {
    mask-image: linear-gradient(90deg, #0000 0, #000 10%, #000 90%, #0000)
}

.aspect-ratio {
    display: block;
    padding: 0;
    position: relative
}

.aspect-ratio[data-aspect-ratio-ratio-value="16:9"]:before {
    padding-top: 56.25%
}

.aspect-ratio[data-aspect-ratio-ratio-value="16:10"]:before {
    padding-top: 62.5%
}

.aspect-ratio[data-aspect-ratio-ratio-value="1:1"]:before {
    padding-top: 100%
}

.aspect-ratio:before {
    content: "";
    display: block;
    float: left;
    height: 0;
    margin-left: -1px;
    width: 1px
}

.aspect-ratio:after {
    clear: both;
    content: "";
    display: table
}

.aspect-ratio__fill {
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%
}

.hidden,
.is-hidden,
.js-hidden {
    display: none
}

.opacity-0 {
    opacity: 0
}

.hide {
    display: none !important
}

.block {
    display: block
}

.inline {
    display: inline
}

.inline-block {
    display: inline-block
}

.visuallyhidden {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute !important;
    white-space: nowrap;
    width: 1px
}

@media only percy {
    .hidden-in-percy {
        visibility: hidden
    }
}

.overflow-hidden {
    overflow: hidden
}

.overflow-x-hidden {
    overflow-x: hidden
}

.overflow-y-hidden {
    overflow-y: hidden
}

.relative {
    position: relative
}

@media screen and (max-width:359px) {
    .below-viewport-2xs-block {
        display: block
    }

    .below-viewport-2xs-flex {
        display: flex
    }

    .below-viewport-2xs-grid {
        display: grid
    }

    .below-viewport-2xs-inline {
        display: inline
    }

    .below-viewport-2xs-inline-block {
        display: inline-block
    }

    .below-viewport-2xs-none {
        display: none
    }
}

@media screen and (min-width:360px) {
    .above-viewport-2xs-block {
        display: block
    }

    .above-viewport-2xs-flex {
        display: flex
    }

    .above-viewport-2xs-grid {
        display: grid
    }

    .above-viewport-2xs-inline {
        display: inline
    }

    .above-viewport-2xs-inline-block {
        display: inline-block
    }

    .above-viewport-2xs-none {
        display: none
    }
}

@media screen and (max-width:389px) {
    .below-viewport-xs-block {
        display: block
    }

    .below-viewport-xs-flex {
        display: flex
    }

    .below-viewport-xs-grid {
        display: grid
    }

    .below-viewport-xs-inline {
        display: inline
    }

    .below-viewport-xs-inline-block {
        display: inline-block
    }

    .below-viewport-xs-none {
        display: none
    }
}

@media screen and (min-width:390px) {
    .above-viewport-xs-block {
        display: block
    }

    .above-viewport-xs-flex {
        display: flex
    }

    .above-viewport-xs-grid {
        display: grid
    }

    .above-viewport-xs-inline {
        display: inline
    }

    .above-viewport-xs-inline-block {
        display: inline-block
    }

    .above-viewport-xs-none {
        display: none
    }
}

@media screen and (max-width:639px) {
    .below-viewport-s-block {
        display: block
    }

    .below-viewport-s-flex {
        display: flex
    }

    .below-viewport-s-grid {
        display: grid
    }

    .below-viewport-s-inline {
        display: inline
    }

    .below-viewport-s-inline-block {
        display: inline-block
    }

    .below-viewport-s-none {
        display: none
    }
}

@media screen and (min-width:640px) {
    .above-viewport-s-block {
        display: block
    }

    .above-viewport-s-flex {
        display: flex
    }

    .above-viewport-s-grid {
        display: grid
    }

    .above-viewport-s-inline {
        display: inline
    }

    .above-viewport-s-inline-block {
        display: inline-block
    }

    .above-viewport-s-none {
        display: none
    }
}

@media screen and (max-width:767px) {
    .below-viewport-m-block {
        display: block
    }

    .below-viewport-m-flex {
        display: flex
    }

    .below-viewport-m-grid {
        display: grid
    }

    .below-viewport-m-inline {
        display: inline
    }

    .below-viewport-m-inline-block {
        display: inline-block
    }

    .below-viewport-m-none {
        display: none
    }
}

@media screen and (min-width:768px) {
    .above-viewport-m-block {
        display: block
    }

    .above-viewport-m-flex {
        display: flex
    }

    .above-viewport-m-grid {
        display: grid
    }

    .above-viewport-m-inline {
        display: inline
    }

    .above-viewport-m-inline-block {
        display: inline-block
    }

    .above-viewport-m-none {
        display: none
    }
}

@media screen and (max-width:1023px) {
    .below-viewport-l-block {
        display: block
    }

    .below-viewport-l-flex {
        display: flex
    }

    .below-viewport-l-grid {
        display: grid
    }

    .below-viewport-l-inline {
        display: inline
    }

    .below-viewport-l-inline-block {
        display: inline-block
    }

    .below-viewport-l-none {
        display: none
    }
}

@media screen and (min-width:1024px) {
    .above-viewport-l-block {
        display: block
    }

    .above-viewport-l-flex {
        display: flex
    }

    .above-viewport-l-grid {
        display: grid
    }

    .above-viewport-l-inline {
        display: inline
    }

    .above-viewport-l-inline-block {
        display: inline-block
    }

    .above-viewport-l-none {
        display: none
    }
}

@media screen and (max-width:1219px) {
    .below-viewport-xl-block {
        display: block
    }

    .below-viewport-xl-flex {
        display: flex
    }

    .below-viewport-xl-grid {
        display: grid
    }

    .below-viewport-xl-inline {
        display: inline
    }

    .below-viewport-xl-inline-block {
        display: inline-block
    }

    .below-viewport-xl-none {
        display: none
    }
}

@media screen and (min-width:1220px) {
    .above-viewport-xl-block {
        display: block
    }

    .above-viewport-xl-flex {
        display: flex
    }

    .above-viewport-xl-grid {
        display: grid
    }

    .above-viewport-xl-inline {
        display: inline
    }

    .above-viewport-xl-inline-block {
        display: inline-block
    }

    .above-viewport-xl-none {
        display: none
    }
}

@media screen and (max-width:1439px) {
    .below-viewport-2xl-block {
        display: block
    }

    .below-viewport-2xl-flex {
        display: flex
    }

    .below-viewport-2xl-grid {
        display: grid
    }

    .below-viewport-2xl-inline {
        display: inline
    }

    .below-viewport-2xl-inline-block {
        display: inline-block
    }

    .below-viewport-2xl-none {
        display: none
    }
}

@media screen and (min-width:1440px) {
    .above-viewport-2xl-block {
        display: block
    }

    .above-viewport-2xl-flex {
        display: flex
    }

    .above-viewport-2xl-grid {
        display: grid
    }

    .above-viewport-2xl-inline {
        display: inline
    }

    .above-viewport-2xl-inline-block {
        display: inline-block
    }

    .above-viewport-2xl-none {
        display: none
    }
}

@media screen and (max-width:1599px) {
    .below-viewport-3xl-block {
        display: block
    }

    .below-viewport-3xl-flex {
        display: flex
    }

    .below-viewport-3xl-grid {
        display: grid
    }

    .below-viewport-3xl-inline {
        display: inline
    }

    .below-viewport-3xl-inline-block {
        display: inline-block
    }

    .below-viewport-3xl-none {
        display: none
    }
}

@media screen and (min-width:1600px) {
    .above-viewport-3xl-block {
        display: block
    }

    .above-viewport-3xl-flex {
        display: flex
    }

    .above-viewport-3xl-grid {
        display: grid
    }

    .above-viewport-3xl-inline {
        display: inline
    }

    .above-viewport-3xl-inline-block {
        display: inline-block
    }

    .above-viewport-3xl-none {
        display: none
    }
}

@media screen and (max-width:1919px) {
    .below-viewport-4xl-block {
        display: block
    }

    .below-viewport-4xl-flex {
        display: flex
    }

    .below-viewport-4xl-grid {
        display: grid
    }

    .below-viewport-4xl-inline {
        display: inline
    }

    .below-viewport-4xl-inline-block {
        display: inline-block
    }

    .below-viewport-4xl-none {
        display: none
    }
}

@media screen and (min-width:1920px) {
    .above-viewport-4xl-block {
        display: block
    }

    .above-viewport-4xl-flex {
        display: flex
    }

    .above-viewport-4xl-grid {
        display: grid
    }

    .above-viewport-4xl-inline {
        display: inline
    }

    .above-viewport-4xl-inline-block {
        display: inline-block
    }

    .above-viewport-4xl-none {
        display: none
    }
}

.max-w-col-10,
.max-w-col-4,
.max-w-col-6,
.max-w-col-8 {
    width: 100%
}

.max-w-col-4 {
    max-width: 24rem
}

.max-w-col-6 {
    max-width: 36.75rem
}

.max-w-col-8 {
    max-width: 49.5rem
}

.max-w-col-10 {
    max-width: 62.25rem
}

.prevent-scroll {
    overflow: hidden
}

.styled-text-minimal em {
    font-style: italic
}

.styled-text-minimal strong {
    font-weight: 600
}

.styled-text-minimal a {
    color: inherit;
    text-decoration: none;
    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)
}

@media (prefers-reduced-motion:reduce) {
    .styled-text-minimal a {
        transition-duration: 1ms
    }
}

.styled-text-minimal a:focus,
.styled-text-minimal a:hover {
    opacity: .65
}

.styled-text {
    color: #212123;
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.5rem
}

.styled-text h1 {
    font-size: 2.25rem;
    font-weight: 900;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
    margin-top: 3rem
}

@media screen and (min-width:390px) {
    .styled-text h1 {
        font-size: 2.5rem;
        line-height: 2.75rem
    }
}

@media screen and (min-width:768px) {
    .styled-text h1 {
        font-size: 3rem;
        line-height: 3rem;
        margin-bottom: 2rem
    }
}

@media screen and (min-width:1024px) {
    .styled-text h1 {
        font-size: 4.75rem;
        line-height: 4.75rem;
        margin-bottom: 2rem
    }
}

.styled-text h2 {
    font-size: 2rem;
    font-weight: 900;
    line-height: 2.25rem;
    margin-bottom: 1.5rem;
    margin-top: 3rem
}

@media screen and (min-width:768px) {
    .styled-text h2 {
        font-size: 2.5rem;
        line-height: 3rem;
        margin-bottom: 2rem
    }
}

@media screen and (min-width:1024px) {
    .styled-text h2 {
        font-size: 3.5rem;
        line-height: 3.75rem;
        margin-bottom: 2rem
    }
}

.styled-text h3 {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: -.03125rem;
    line-height: 2.25rem;
    margin-bottom: 1rem;
    margin-top: 4rem
}

@media screen and (max-width:767px) {
    .styled-text h3 {
        font-size: 1.625rem;
        line-height: 2rem;
        margin-top: 3rem
    }
}

.styled-text h4 {
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.5rem;
    margin-bottom: 1rem;
    margin-top: 1.5rem
}

@media screen and (min-width:768px) {
    .styled-text h4 {
        margin-top: 2.5rem
    }
}

.styled-text h5 {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem;
    margin-bottom: .75rem;
    margin-top: 1rem
}

@media screen and (min-width:768px) {
    .styled-text h5 {
        margin-top: 2rem
    }
}

.styled-text ol,
.styled-text ul {
    list-style-position: outside;
    padding-left: 1.2em
}

.styled-text ul {
    list-style-type: disc
}

.styled-text ol {
    list-style-type: decimal
}

.styled-text li:not(:last-child),
.styled-text ol:not(:last-child),
.styled-text p:not(:last-child),
.styled-text ul:not(:last-child) {
    margin-bottom: 1rem
}

.styled-text li ol,
.styled-text li ul {
    margin-top: .5em
}

.styled-text blockquote {
    border-left: .12em solid #0000001a;
    font-family: Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 1.125em;
    margin-bottom: 1.5em;
    margin-top: 1.5em;
    padding-left: 1em
}

@media screen and (min-width:768px) {
    .styled-text blockquote {
        font-size: 1.333333333em;
        line-height: 1.4
    }
}

.styled-text blockquote>p:last-of-type {
    margin-bottom: 0
}

.styled-text blockquote>footer {
    color: #212123b3;
    font-size: .8888888889em;
    margin-top: 1em
}

@media screen and (min-width:768px) {
    .styled-text blockquote>footer {
        font-size: .7500000002em
    }
}

.styled-text details[open] summary {
    margin-bottom: 1em
}

.styled-text figcaption {
    color: #212123b3;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.25rem;
    margin-bottom: 1.5rem;
    margin-top: .5rem
}

.styled-text b,
.styled-text strong {
    font-weight: 600
}

.styled-text b a:not(.button),
.styled-text strong a:not(.button) {
    font-weight: inherit
}

.styled-text em {
    font-style: italic
}

.styled-text a:not(.button) {
    color: #212123;
    font-weight: 500;
    text-decoration-color: #0003;
    text-decoration-line: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 4px;
    transition: color 125ms ease-out
}

@media (prefers-reduced-motion:reduce) {
    .styled-text a:not(.button) {
        transition-duration: 1ms
    }
}

.styled-text a:not(.button):active,
.styled-text a:not(.button):hover {
    color: #0000007a
}

.styled-text figcaption a {
    color: inherit;
    font-weight: inherit;
    text-decoration: none
}

.styled-text h1 a,
.styled-text h1 strong,
.styled-text h2 a,
.styled-text h2 strong,
.styled-text h3 a,
.styled-text h3 strong,
.styled-text h4 a,
.styled-text h4 strong,
.styled-text h5 a,
.styled-text h5 strong,
.styled-text h6 a,
.styled-text h6 strong {
    font-weight: inherit
}

.styled-text code,
.styled-text pre {
    font-family: Marfa Mono, SF Mono, Source Code Pro, Consolas, Menlo, monospace
}

.styled-text :not(pre)>code {
    background-color: #0000000a;
    line-height: 1.75rem
}

.styled-text :not(pre)>code,
.styled-text kbd {
    border-radius: 6px;
    font-size: .875em;
    overflow-wrap: break-word;
    overflow-x: hidden;
    padding: .2em .4em
}

.styled-text kbd {
    background-color: #ffffffb3;
    box-shadow: inset 0 0 0 1px #0000001a, inset 0 -2px 0 #0000001a;
    color: #212123;
    font-family: inherit;
    font-weight: 500;
    margin: 0 .2em;
    min-width: 1.625rem
}

.styled-text pre:not(.highlight)>code {
    background-color: #454545;
    border-radius: 6px;
    display: block;
    overflow-wrap: break-word;
    padding: 1.1428571429em
}

.styled-text hr {
    border: 0;
    display: block;
    font-weight: 300;
    height: auto;
    margin: 1.5em 0;
    text-align: center
}

.styled-text hr:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
    content: "";
    display: inline-block;
    height: 1rem;
    width: 1rem
}

.styled-text img:not([class]),
.styled-text img[data-controller=lazyload][class=is-loaded] {
    display: block;
    max-width: 100%
}

.styled-text img:not([class]):not([height]),
.styled-text img[data-controller=lazyload][class=is-loaded]:not([height]) {
    height: auto
}

.styled-text figure iframe,
.styled-text figure:not([class]) img,
.styled-text video {
    border-radius: 12px;
    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005, 0 0 4px #00000014;
    display: block;
    overflow: hidden
}

.styled-text figure.embed,
.styled-text figure:not([class]) img,
.styled-text video {
    margin-top: 1em;
    width: 100%
}

.styled-text figure+ol,
.styled-text figure+p,
.styled-text figure+ul {
    margin-top: 2em
}

.styled-text li figure:last-child {
    margin-bottom: 2rem
}

.styled-text figure+.text-callout {
    margin-top: 1.5rem
}

.styled-text .docs-tabs+.text-callout {
    margin-top: 1rem
}

.styled-text--secondary {
    color: #212123b3
}

.styled-text--secondary b,
.styled-text--secondary strong {
    color: #212123
}

@media screen and (min-width:768px) {
    .styled-text--font-bump {
        font-size: 1.125rem
    }
}

.styled-text--alt-headings h2 {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: -.03125rem;
    line-height: 2.25rem;
    margin-bottom: 1rem;
    margin-top: 4rem
}

@media screen and (max-width:767px) {
    .styled-text--alt-headings h2 {
        font-size: 1.625rem;
        line-height: 2rem;
        margin-top: 3rem
    }
}

.styled-text--alt-headings h3 {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2rem;
    margin-bottom: .5rem;
    margin-top: 2.5rem
}

@media screen and (max-width:767px) {
    .styled-text--alt-headings h3 {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.75rem;
        margin-bottom: .25rem;
        margin-top: 1.5rem
    }
}

.styled-text--alt-headings h4 {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem;
    margin-bottom: .75rem;
    margin-top: 1rem
}

@media screen and (min-width:768px) {
    .styled-text--alt-headings h4 {
        margin-top: 2rem
    }
}

.styled-text #markdown-toc {
    margin-bottom: 2rem;
    margin-top: 2rem
}

.styled-text #markdown-toc ol,
.styled-text #markdown-toc ul {
    margin-top: .5rem
}

.styled-text #markdown-toc a {
    font-weight: 600
}

.styled-text .apple-symbol {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif
}

.styled-text .footnotes {
    color: #212123b3;
    font-size: 81.25%
}

.ui-icon {
    vertical-align: middle
}

.styled-table {
    background: none;
    border: 1px solid #00000014;
    border-radius: 12px;
    margin: 1rem auto;
    overflow: auto;
    padding: 0;
    width: 100%
}

.styled-table table {
    font-size: .875rem;
    min-width: 40rem
}

.styled-table td,
.styled-table th {
    padding: 1.25rem 1.5rem 1.25rem 1.25rem
}

.styled-table th {
    font-size: .875rem;
    font-weight: 600;
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap
}

.styled-table td {
    color: #212123;
    font-weight: 300;
    line-height: 1.25rem
}

.styled-table td>strong {
    font-weight: 600
}

.styled-table td sup>a {
    color: #ff7843
}

.styled-table tbody tr:nth-child(odd) {
    background-color: #f5f5f5
}

.styled-table--full table {
    width: 100%
}

.styled-table--first td:first-child {
    font-weight: 600
}

@media screen and (max-width:767px) {
    .styled-table--first td:first-child {
        max-width: 50vw
    }
}

.shortcuts-table {
    margin-bottom: 1rem
}

.shortcuts-table table {
    border: 1px solid #0000001a;
    border-collapse: initial;
    border-radius: 6px
}

.shortcuts-table tr:nth-child(odd) {
    background: #00000005
}

.shortcuts-table td {
    padding: .75rem;
    vertical-align: middle
}

.shortcuts-table td:first-child {
    padding-bottom: .625rem;
    padding-top: .625rem
}

.shortcuts-table td:last-child {
    border-left: 1px solid #0000000f;
    padding-right: 1em
}

.shortcuts-table tr:not(:last-child) td {
    border-bottom: 1px solid #f0f0f0
}

.shortcuts-table td:first-child em {
    font-style: normal;
    vertical-align: middle
}

.shortcuts-table td:first-child kbd+em {
    margin-left: .25em
}

.shortcuts-table td:first-child kbd+em:not(:last-child) {
    margin-right: .25em
}

.highlighter-rouge {
    margin-bottom: 1rem
}

.highlight code {
    background-color: #00000014;
    border-radius: 6px;
    display: block;
    font-size: .9375rem;
    overflow-x: hidden;
    padding: 1rem 1.25rem
}

@media screen and (min-width:640px) {
    .highlight code {
        overflow-x: hidden;
        white-space: pre-wrap
    }
}

.highlight .o,
.highlight .p {
    color: #000000a3
}

.highlight .err {
    color: #000c
}

.highlight .n {
    color: #62266e
}

.highlight .na {
    color: #1a5e54
}

.highlight .nb,
.highlight .nc,
.highlight .nd,
.highlight .ne,
.highlight .nf,
.highlight .ni,
.highlight .nl,
.highlight .nn,
.highlight .no {
    color: #62266e
}

.highlight .nx {
    color: #000c
}

.highlight .bp,
.highlight .nt,
.highlight .nv,
.highlight .py,
.highlight .vc,
.highlight .vg,
.highlight .vi {
    color: #62266e
}

.highlight .c,
.highlight .c1,
.highlight .cm {
    color: #0000007a
}

.highlight .k {
    color: #1a5e54
}

.highlight .kc,
.highlight .kd,
.highlight .kn,
.highlight .kp,
.highlight .kr,
.highlight .kt {
    color: #8d5f10
}

.highlight .l,
.highlight .ld,
.highlight .m,
.highlight .mf,
.highlight .mh {
    color: #482000
}

.highlight .mi {
    color: #1a5e54
}

.highlight .il,
.highlight .mo,
.highlight .s,
.highlight .s1,
.highlight .s2,
.highlight .sb,
.highlight .sc,
.highlight .sd,
.highlight .se,
.highlight .sh,
.highlight .si,
.highlight .sr,
.highlight .ss,
.highlight .sx {
    color: #482000
}

.highlight .gi {
    color: #000c
}

.is-referral-iphone {
    padding-bottom: 4rem
}

.is-referral-iphone .get-started,
.is-referral-iphone .get-started-sticker,
.is-referral-iphone .main-footer,
.is-referral-iphone .main-nav,
.is-referral-iphone .ribbon,
.is-referral-iphone a[href^="/signup"] {
    visibility: hidden
}`, "",{"version":3,"sources":["webpack://./src/styles/pricing-skpabloocss/main.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;IAC1C,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IAErB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAkFI,SAAS;IACT,eAAe;IACf,aAAa;IACb,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA,2EAA2E;AAC3E;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oCAAoC;IACpC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2CAA2C;QAC3C;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV,iCAAiC;QACjC;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV,yCAAyC;QACzC;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8GAA8G;IAC9G;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,2DAA2D;IAC/D;;IAEA;QACI,aAAa;QACb,eAAe;QACf,2CAA2C;QAC3C,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,oDAAoD;QACpD,eAAe;QACf,cAAc;QACd,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,cAAc;QACd,WAAW;QACX,2CAA2C;QAC3C,wBAAwB;IAC5B;AACJ;;;AAGA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;;IAGI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,oEAAoE;IACpE;AACJ;;AAEA;;IAGI,gBAAgB;IAChB,sBAAsB;IACtB,iEAAiE;IACjE;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,gBAAgB;IAChB,sBAAsB;IACtB,iEAAiE;IACjE;AACJ;;AAEA;IACI,mBAAmB;IAEnB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,yDAAqU;IACrU,yCAAyC;IACzC,4BAA4B;IAC5B,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yDAAkX;IAClX,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,wBAAwB;IACxB,yDAAic;IACjc,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,0CAA0C;IAC1C,eAAe;IACf,UAAU;IACV,YAAY;IACZ,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,yDAA4R;IAC5R,wBAAwB;IACxB,qBAAqB;IACrB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yDAAwS;IACxS,wBAAwB;IACxB;AACJ;;AAEA;IAEI,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,0CAA0C;IAC1C,eAAe;IACf,UAAU;IACV,YAAY;IACZ,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB,yDAA0M;IAC1M,wBAAwB;IACxB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yDAAsN;IACtN,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;QACf,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC;AACJ;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB;AACJ;;AAEA;IACI;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,mCAAmC;IACnC,yDAAkyB;IAClyB;AACJ;;AAEA;;IAEI,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;;IAGI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,yDAAuW;IACvW;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,yDAA8Q;IAC9Q;AACJ;;AAEA;;;IAGI;;QAEI;IACJ;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,8EAA8E;IAC9E,cAAc;IACd;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,qCAAqC;IACrC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;;QAEI,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf;AACJ;;;AAGA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,qBAAqB;IACrB,sCAAsC;IACtC,wBAAwB;IACxB,OAAO;IACP,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,SAAS;IACT,4BAA4B;IAC5B,kFAAkF;IAClF,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,4EAA4E;IAC5E;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;IAChB,MAAM;IACN;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;IAC1D,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,uCAAuC;IACvC,4DAA4D;IAC5D;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;IACjC,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,WAAW;IACX,SAAS;IACT,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,iCAAiC;IACjC,iHAAiH;IACjH;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,0DAAk8B;IACl8B,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,qCAAqC;IACrC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QAEI,qBAAqB;QACrB,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI,aAAa;QACb;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iCAAiC;QACjC,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sDAAsD;QACtD,aAAa;QACb,sBAAsB;QACtB,UAAU;QACV,oBAAoB;QACpB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,4BAA4B;QAC5B,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,+BAA+B;QAC/B,aAAa;QACb,oBAAoB;QACpB,8BAA8B;QAC9B,UAAU;QACV,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;QAClB;IACJ;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,oBAAoB;QACpB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kCAAkC;QAClC,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;YAEI,2BAA2B;YAC3B;QACJ;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;YACI;QACJ;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;YACI;QACJ;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B,0DAA0D;IAC1D;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,uBAAuB;QACvB,kCAAkC;QAClC;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QAEI,2BAA2B;QAC3B,SAAS;QACT,WAAW;QACX,YAAY;QACZ,OAAO;QAEP,4CAA4C;QAC5C,oBAAoB;QACpB,kBAAkB;QAClB,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI,6DAA6D;QAC7D,sBAAsB;QACtB,oCAAoC;QACpC,UAAU;QACV,gBAAgB;QAChB;IACJ;;IAEA;QACI;YACI,UAAU;YACV;QACJ;;QAEA;YACI,UAAU;YACV;QACJ;IACJ;;IAEA;QACI;YAEI,2BAA2B;YAC3B;QACJ;IACJ;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,2DAA2D;QAC3D,UAAU;QACV,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;YACI;QACJ;;QAEA;YACI,kBAAkB;YAClB;QACJ;IACJ;AACJ;;AAEA;IAEI,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,4CAA4C;IAC5C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sDAAsD;IACtD;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,4DAA4D;IAC5D,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,6DAA6D;IAC7D;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,wBAAwB;IACxB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,0DAA+8B;IAC/8B,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;;IAGI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,qBAAqB;QACrB,gBAAgB;QAChB,+BAA+B;QAC/B,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,yBAAyB;QACzB,0BAA0B;QAC1B,yBAAyB;QACzB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,aAAa;IACb,OAAO;IACP,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,4DAA4D;IAC5D,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,uDAAuD;IACvD;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,0DAAiU;IACjU;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0DAA2T;IAC3T,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mGAAmG;IACnG,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,4GAA4G;IAC5G;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;QACnB,aAAa;QACb,uCAAuC;QACvC;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,0DAAghC;IAChhC,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;IAMI,yBAAyB;IACzB;AACJ;;AAEA;IACI,gDAAgD;IAChD,uBAAuB;IACvB,yBAAyB;IACzB;AACJ;;AAEA;IACI,8EAA8E;IAC9E,uBAAuB;IACvB,uDAAuD;IACvD;AACJ;;AAEA;IACI,8EAA8E;IAC9E,uBAAuB;IACvB,uDAAuD;IACvD;AACJ;;AAEA;;;IAGI;;;QAGI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,OAAO;IACP,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,oDAAoD;IACpD,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uEAAuE;IACvE,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kEAAkE;IAClE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,OAAO;IACP,eAAe;IACf,QAAQ;IACR,UAAU;IACV,gDAAgD;IAChD;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,qBAAqB;IAErB,qEAAqE;IACrE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,0DAA0D;IAC1D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,kBAAkB;QAClB,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,SAAS;QACT,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,eAAe;QACf;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0DAA8N;IAC9N,sBAAsB;IACtB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,MAAM;QACN,iCAAiC;QACjC;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,8EAA8E;IAC9E,4BAA4B;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;YACI,2BAA2B;YAC3B;QACJ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;YACI,2BAA2B;YAC3B;QACJ;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,mDAAmD;QACnD;IACJ;AACJ;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,mBAAmB;IACnB,uEAAuE;IACvE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI,0EAA0E;IAC1E,WAAW;IACX,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,8EAA8E;IAC9E,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kEAAkE;IAClE;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IAEnB,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,uDAAuD;IACvD;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0DAAyqB;IACzqB,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,OAAO;IACP,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;IACjC,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,wEAAwE;IACxE,+BAA+B;IAC/B,gCAAgC;IAChC,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,6DAA6D;IAC7D;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,8EAA8E;IAC9E,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,QAAQ;IACR,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,0DAAuY;IACvY,wCAAwC;IACxC,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;IAC/B,WAAW;IACX,eAAe;IACf,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,kCAAkC;IAClC,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,0DAA6V;QAC7V,cAAc;QACd;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,MAAM;IACN,oDAAoD;IACpD,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IAEnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,+BAA+B;IAC/B,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,WAAW;IACX,qDAAqD;IACrD,aAAa;IACb;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,0DAAiU;IACjU,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,mBAAmB;IAEnB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,OAAO;IACP,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,gGAAgG;IAChG,WAAW;IACX;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,aAAa;QACb,2BAA2B;QAC3B;IACJ;;IAEA;;;QAGI,4BAA4B;QAC5B;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI,4BAA4B;QAC5B;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,UAAU;QACV,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,0DAAuY;IACvY,wCAAwC;IACxC,4BAA4B;IAC5B,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,aAAa;QACb;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gGAAgG;IAChG;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI,oDAAoD;IACpD;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;IAII,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,0DAAoX;IACpX,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN;AACJ;;AAEA;IACI;QAEI,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,sGAAsG;IACtG,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0DAA8T;IAC9T,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mDAAmD;IACnD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,uDAAuD;IACvD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,0DAAqW;QACrW,wBAAwB;QACxB,wBAAwB;QACxB,SAAS;QACT,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,iCAAiC;IACjC,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gCAAgC;IAChC,uDAAuD;IACvD,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0DAAkU;IAClU,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,6DAA6D;IAC7D;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0DAAgS;IAChS,wBAAwB;IACxB,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,oDAAoD;IACpD,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4sE;AAChtE;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;;;;;IAKI,YAAY;IACZ,OAAO;IACP,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;IAC3C;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,YAAY;IACZ,OAAO;IACP;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gEAAgE;IAChE,kBAAkB;IAClB,qBAAqB;IACrB,yFAAyF;IACzF,6DAA6D;IAC7D;AACJ;;AAEA;IAEI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qEAAqE;IACrE;AACJ;;AAEA;;IAEI,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,QAAQ;IACR,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qEAAqE;IACrE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,WAAW;IACX,OAAO;IACP,MAAM;IACN;AACJ;;AAEA;;;;IAII,YAAY;IACZ,OAAO;IACP,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kDAAkD;IAClD;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,gCAAgC;QAChC,gBAAgB;QAChB,aAAa;QACb,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,yCAAyC;IACzC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IAEd;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,cAAc;QACd,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,uDAAuD;IACvD;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,sHAAsH;IACtH,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,mDAAmD;IACnD;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kCAAkC;IAClC,8GAA8G;IAC9G,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,+DAA+D;IAC/D,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,0DAAorB;IACprB,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,uEAAuE;IACvE,cAAc;IACd;AACJ;;AAEA;;;IAGI,eAAe;IACf;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;QACpB,qBAAqB;QACrB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;IASI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;IAcI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI;AACJ","sourcesContent":["@charset \"UTF-8\";\n\n.pricing-box {\n    background-color: #fff;\n    border-radius: 30px;\n    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);\n    padding: 0px 120px 20px;\n    margin: 50px 150px 0px;\n}\n\n.flex {\n    display: flex\n}\n\n.inline-flex {\n    display: inline-flex\n}\n\n.flex-row {\n    flex-direction: row\n}\n\n.flex-col {\n    flex-direction: column\n}\n\n.items-start {\n    align-items: flex-start\n}\n\n.items-end {\n    align-items: flex-end\n}\n\n.items-center {\n    align-items: center\n}\n\n.items-baseline {\n    align-items: baseline\n}\n\n.items-stretch {\n    align-items: stretch\n}\n\n.justify-between {\n    justify-content: space-between\n}\n\n.justify-around {\n    justify-content: space-around\n}\n\n.justify-center {\n    justify-content: center\n}\n\n.justify-start {\n    justify-content: flex-start\n}\n\n.justify-end {\n    justify-content: flex-end\n}\n\n.flex-1 {\n    flex: 1 1 0\n}\n\n.flex-auto {\n    flex: 1 1 auto\n}\n\n.flex-none {\n    flex: none\n}\n\n.text-center {\n    text-align: center\n}\n\n.text-right {\n    text-align: right\n}\n\n.text-left {\n    text-align: left\n}\n\n.uppercase {\n    text-transform: uppercase\n}\n\n.hyphenate {\n    word-wrap: break-word;\n    -webkit-hyphens: auto;\n    hyphens: auto;\n    overflow-wrap: break-word\n}\n\n.no-wrap {\n    white-space: nowrap\n}\n\na,\nabbr,\nacronym,\naddress,\napplet,\narticle,\naside,\naudio,\nb,\nbig,\nblockquote,\nbody,\ncanvas,\ncaption,\ncenter,\ncite,\ncode,\ndd,\ndel,\ndetails,\ndfn,\ndiv,\ndl,\ndt,\nem,\nembed,\nfieldset,\nfigcaption,\nfigure,\nfooter,\nform,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nheader,\nhgroup,\nhtml,\ni,\niframe,\nimg,\nins,\nkbd,\nlabel,\nlegend,\nli,\nmain,\nmark,\nmenu,\nnav,\nobject,\nol,\noutput,\np,\npre,\nq,\nruby,\ns,\nsamp,\nsection,\nsmall,\nspan,\nstrike,\nstrong,\nsub,\nsummary,\nsup,\ntable,\ntbody,\ntd,\ntfoot,\nth,\nthead,\ntime,\ntr,\ntt,\nu,\nul,\nvar,\nvideo {\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    margin: 0;\n    padding: 0;\n    vertical-align: initial\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection {\n    display: block\n}\n\nbody {\n    line-height: 1\n}\n\nmenu,\nol,\nul {\n    list-style: none\n}\n\nblockquote,\nq {\n    quotes: none\n}\n\nblockquote:after,\nblockquote:before,\nq:after,\nq:before {\n    content: \"\";\n    content: none\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0\n}\n\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\nhtml {\n    -webkit-text-size-adjust: 100%;\n    line-height: 1.15\n}\n\nbody {\n    margin: 0\n}\n\nmain {\n    display: block\n}\n\nh1 {\n    font-size: 2em;\n    margin: .67em 0\n}\n\nhr {\n    box-sizing: initial;\n    height: 0;\n    overflow: visible\n}\n\npre {\n    font-family: monospace, monospace;\n    font-size: 1em\n}\n\na {\n    background-color: initial\n}\n\nabbr[title] {\n    border-bottom: none;\n    text-decoration: none;\n    -webkit-text-decoration: none dotted;\n    text-decoration: none dotted\n}\n\nb,\nstrong {\n    font-weight: bolder\n}\n\ncode,\nkbd,\nsamp {\n    font-family: monospace, monospace;\n    font-size: 1em\n}\n\nsmall {\n    font-size: 80%\n}\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: initial\n}\n\nsub {\n    bottom: -.25em\n}\n\nsup {\n    top: -.5em\n}\n\nimg {\n    border-style: none\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0\n}\n\nbutton,\ninput {\n    overflow: visible\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\n[type=button],\n[type=reset],\n[type=submit],\n\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    border-style: none;\n    padding: 0\n}\n\n[type=button]:-moz-focusring,\n[type=reset]:-moz-focusring,\n[type=submit]:-moz-focusring,\nbutton:-moz-focusring {\n    outline: 1px dotted ButtonText\n}\n\nfieldset {\n    padding: .35em .75em .625em\n}\n\nlegend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal\n}\n\nprogress {\n    vertical-align: initial\n}\n\ntextarea {\n    overflow: auto\n}\n\n[type=checkbox],\n[type=radio] {\n    box-sizing: border-box;\n    padding: 0\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n    height: auto\n}\n\n[type=search] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px\n}\n\n[type=search]::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit\n}\n\ndetails {\n    display: block\n}\n\nsummary {\n    display: list-item\n}\n\n[hidden],\ntemplate {\n    display: none\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg)\n    }\n\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes visibilityIn {\n    0% {\n        visibility: hidden\n    }\n\n    to {\n        visibility: visible\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n\n    to {\n        opacity: 0\n    }\n}\n\n@keyframes fadeInDown {\n    0% {\n        opacity: 0;\n        transform: translateY(-2rem)\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0)\n    }\n}\n\n@keyframes fadeInUp {\n    0% {\n        opacity: 0;\n        transform: translateY(2rem)\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0)\n    }\n}\n\n@keyframes blink {\n\n    0%,\n    to {\n        opacity: 0\n    }\n\n    50% {\n        opacity: 1\n    }\n}\n\n@keyframes flash {\n\n    0%,\n    50%,\n    to {\n        opacity: 1\n    }\n\n    25%,\n    75% {\n        opacity: 0\n    }\n}\n\n@keyframes layIn {\n    0% {\n        opacity: 0;\n        transform: rotateX(-30deg) translateZ(50px);\n        transform-origin: 50% 100%\n    }\n\n    to {\n        opacity: 1;\n        transform: rotateX(0deg) translateZ(0)\n    }\n}\n\n@keyframes shake {\n\n    41%,\n    8% {\n        transform: translateX(-4px)\n    }\n\n    25%,\n    58% {\n        transform: translateX(4px)\n    }\n\n    75% {\n        transform: translateX(-2px)\n    }\n\n    92% {\n        transform: translateX(2px)\n    }\n\n    0%,\n    to {\n        transform: translateX(0)\n    }\n}\n\n@keyframes scaleInDown {\n    0% {\n        opacity: 0;\n        transform: translateY(-.75rem) scale(.95)\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n        visibility: visible\n    }\n}\n\n@keyframes scaleOutUp {\n    0% {\n        opacity: 1;\n        transform: translateY(0) scale(1)\n    }\n\n    to {\n        opacity: 0;\n        transform: translateY(-.75rem) scale(.95);\n        visibility: hidden\n    }\n}\n\n@keyframes dropIn {\n    0% {\n        opacity: 0;\n        transform: scale(1.333)\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1)\n    }\n}\n\n@keyframes zoomIn {\n    0% {\n        opacity: 0;\n        transform: scale(.9)\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1)\n    }\n}\n\n*,\n:after,\n:before {\n    box-sizing: border-box\n}\n\nh1 {\n    font-size: 100%;\n    margin: 0\n}\n\nol,\nul {\n    list-style: none;\n    margin: 0;\n    padding: 0\n}\n\nb,\nstrong {\n    font-weight: inherit\n}\n\nem,\ni {\n    font-style: normal\n}\n\nbutton,\ndetails>summary {\n    cursor: pointer\n}\n\na {\n    text-decoration: none\n}\n\nhtml {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 100%;\n    line-height: 1.5;\n    min-height: 100%;\n    text-rendering: optimizeLegibility\n}\n\nbody {\n    align-content: flex-start;\n    background-color: #fff;\n    color: #212123;\n    display: flex;\n    flex-direction: column;\n    font-family: Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;\n    min-height: 100vh\n}\n\n#content {\n    margin-bottom: auto\n}\n\n.wrapper {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 75rem\n}\n\n.pad-viewport {\n    padding-left: 1rem;\n    padding-right: 1rem\n}\n\n@media (max-width: 768px) {\n    .pricing-box {\n        max-width: 100%;\n        overflow: hidden;\n        /* padding: 20px; */\n        /* Add padding to prevent content from touching the edges */\n    }\n\n    .pricing-plans {\n        display: flex;\n        flex-wrap: wrap;\n        /* Allow plans to wrap on smaller screens */\n        justify-content: center;\n    }\n\n    .pricing-plan {\n        flex: 1 1 100%;\n        /* Make each plan take full width on small screens */\n        max-width: 100%;\n        margin: 16px 0;\n        /* Add margin to separate plans */\n    }\n\n    .pricing-plan__features {\n        list-style: none;\n        padding: 0;\n    }\n\n    .button {\n        display: block;\n        width: 100%;\n        /* Make buttons take full width on mobile */\n        /* text-align: center; */\n    }\n}\n\n\n@media screen and (min-width:640px) {\n    .pad-viewport {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .pad-viewport {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n.pad-viewport-2x {\n    padding-left: 2rem;\n    padding-right: 2rem\n}\n\n@media screen and (min-width:640px) {\n    .pad-viewport-2x {\n        padding-left: 3rem;\n        padding-right: 3rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .pad-viewport-2x {\n        padding-left: 4rem;\n        padding-right: 4rem\n    }\n}\n\n.form-input,\n.form-select {\n    -webkit-appearance: none;\n    appearance: none;\n    border: 0;\n    border-radius: 6px;\n    line-height: 1.5;\n    min-height: 3rem;\n    padding: .75rem .875rem\n}\n\n.form-input:enabled,\n.form-select:enabled {\n    background-color: #f9f9f9;\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .0625rem #0000001a;\n    color: #000\n}\n\n.form-input:focus,\n.form-select:focus {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: #fff;\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #ff7843;\n    outline: none\n}\n\n.form-input.is-invalid,\n.form-select.is-invalid,\n.is-invalid .form-input,\n.is-invalid .form-select {\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00\n}\n\n.form-input.is-invalid::selection,\n.form-select.is-invalid::selection,\n.is-invalid .form-input::selection,\n.is-invalid .form-select::selection {\n    background-color: #cc000059\n}\n\n.form-input.is-successful,\n.form-select.is-successful,\n.is-successful .form-input,\n.is-successful .form-select {\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #13bf3e\n}\n\n.form-input.is-successful::selection,\n.form-select.is-successful::selection,\n.is-successful .form-input::selection,\n.is-successful .form-select::selection {\n    background-color: #13bf3e59\n}\n\n.form-input:disabled,\n.form-select:disabled {\n    background-color: #f9f9f9;\n    box-shadow: 0 0 0 .0625rem #0000001a;\n    color: #0000008c;\n    cursor: not-allowed\n}\n\n.form-input--file__label.is-invalid .form-input--file {\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00\n}\n\n.form-input--file__label.is-disabled {\n    outline: none;\n    pointer-events: none\n}\n\n.form-input--file__label.is-disabled .form-input--file {\n    background-color: #f9f9f9;\n    box-shadow: 0 0 0 .0625rem #0000001a;\n    color: #0000008c;\n    cursor: not-allowed;\n    pointer-events: none\n}\n\n.form-input--file__label:focus:not(.is-disabled) {\n    outline: none\n}\n\n.form-input--file__label:focus:not(.is-disabled) .form-input--file {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: #fff;\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #ff7843;\n    outline: none\n}\n\n.form-input--file {\n    align-items: center;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: #fff;\n    border: 1px solid #0000001a;\n    border-radius: 6px;\n    color: #000000d9;\n    cursor: pointer;\n    display: inline-flex;\n    font-size: .875rem;\n    min-height: auto;\n    outline: none;\n    width: auto\n}\n\n.form-input--file:hover {\n    background-color: #f9f9f9;\n    color: #000\n}\n\n.form-input--file:focus {\n    border-color: #0000;\n    box-shadow: 0 0 0 .125rem #0000001a;\n    outline: none\n}\n\n.form-input--file:active {\n    background-color: #e6e6e6;\n    border-color: #0000001a;\n    box-shadow: 0 1px 2px #0000001a\n}\n\n.form-input::placeholder {\n    color: #0000007a;\n    opacity: 1\n}\n\n.form-select {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' color='rgba(0, 0, 0, 0.55)'%3E%3Cpath d='m9 14 3 3 3-3m-6-4 3-3 3 3' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentcolor' stroke-width='1.5'/%3E%3C/svg%3E\");\n    background-position: right .75rem top 50%;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    cursor: pointer;\n    padding-right: 3.125rem\n}\n\n.form-input--wide,\n.form-select--wide {\n    width: 100%\n}\n\n.form-input--compact,\n.form-select--compact {\n    font-weight: 400;\n    min-height: 2.5rem;\n    padding: .375rem .875rem\n}\n\n.form-input--in-group,\n.form-select--in-group {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n    min-width: 0\n}\n\n.form-input--textarea {\n    resize: vertical\n}\n\n.form-input--search {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg' color='rgba(0, 0, 0, 0.55)'%3E%3Cg fill='none' fill-rule='evenodd' stroke-width='1.5' stroke='currentcolor'%3E%3Ccircle cx='11' cy='11' r='5.25'/%3E%3Cpath d='M18.25 18.25 15 15' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E\");\n    background-position: .5rem;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    padding-left: 2.25rem\n}\n\n.form-input--search::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' color='%23212123' fill='rgba(0, 0, 0, 0.15)'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM9.53 8.47a.75.75 0 0 0-1.06 1.06L10.939 12l-2.47 2.47a.75.75 0 0 0 1.061 1.06L12 13.061l2.47 2.47a.75.75 0 0 0 1.06-1.061L13.061 12l2.47-2.47a.75.75 0 0 0-1.061-1.06L12 10.939Z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    cursor: default;\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n.form-input--search:placeholder-shown::-webkit-search-cancel-button {\n    display: none\n}\n\n.form-checkbox {\n    -webkit-appearance: none;\n    appearance: none;\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #0000001a;\n    border-radius: .1875rem;\n    box-shadow: 0 .0625rem .125rem 0 #0000001a;\n    cursor: pointer;\n    flex: none;\n    height: 1rem;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    width: 1rem\n}\n\n.form-checkbox:active {\n    background-color: #e6e6e6\n}\n\n.form-checkbox:checked {\n    background-color: #ff7843;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg' color='%23FFF'%3E%3Cpath stroke='currentcolor' stroke-width='1.5' d='M4 8.8 6.4 12 12 4' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-size: 1rem;\n    border-color: #ff7843\n}\n\n.form-checkbox:checked:active {\n    background-color: #0000008c;\n    border-color: #0000008c\n}\n\n.form-checkbox.is-invalid,\n.is-invalid .form-checkbox {\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00\n}\n\n.form-checkbox:disabled {\n    cursor: not-allowed\n}\n\n.form-checkbox:disabled,\n.form-checkbox:disabled:active {\n    background-color: #f9f9f9;\n    border-color: #000\n}\n\n.form-checkbox:disabled:checked {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg' color='rgba(0, 0, 0, 0.3)'%3E%3Cpath stroke='currentcolor' stroke-width='1.5' d='M4 8.8 6.4 12 12 4' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-size: 1rem\n}\n\n.form-radio {\n    -webkit-appearance: none;\n    appearance: none;\n    background-clip: padding-box;\n    border: 1px solid #0000001a;\n    border-radius: 9999px;\n    box-shadow: 0 .0625rem .125rem 0 #0000001a;\n    cursor: pointer;\n    flex: none;\n    height: 1rem;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    width: 1rem\n}\n\n.form-radio,\n.form-radio:active {\n    background-color: #fff\n}\n\n.form-radio:checked {\n    background-color: #ff7843;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg' fill='%23fff'%3E%3Ccircle cx='8' cy='8' fill-rule='evenodd' r='3'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-size: 1rem;\n    border-color: #ff7843\n}\n\n.form-radio:checked:before {\n    content: none\n}\n\n.form-radio:checked:active {\n    background-color: #0000008c;\n    border-color: #0000008c\n}\n\n.form-radio.is-invalid,\n.is-invalid .form-radio {\n    box-shadow: inset 0 0 .0625rem 0 #0000001a, 0 0 0 .125rem #c00\n}\n\n.form-radio:disabled {\n    cursor: not-allowed\n}\n\n.form-radio:disabled,\n.form-radio:disabled:active {\n    background-color: #f9f9f9;\n    border-color: #0000001a\n}\n\n.form-radio:disabled:checked {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg' fill='rgba(0, 0, 0, 0.3)'%3E%3Ccircle cx='8' cy='8' fill-rule='evenodd' r='3'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-size: 1rem\n}\n\n.form-field {\n    margin-bottom: 1.5rem\n}\n\n.form-label,\n.form-option-label {\n    color: #212123;\n    display: block;\n    font-size: .875rem;\n    font-weight: 300;\n    font-weight: 500;\n    line-height: 1.3125rem;\n    line-height: 1.25\n}\n\n@media screen and (min-width:640px) {\n\n    .form-label,\n    .form-option-label {\n        font-size: 1rem;\n        font-weight: 500;\n        line-height: 1.5rem\n    }\n}\n\n.form-option-label {\n    margin-left: .5rem\n}\n\n.form-option-label--small {\n    font-size: .875rem;\n    font-weight: 300;\n    line-height: 1.3125rem\n}\n\n.form-label {\n    margin-bottom: .5rem\n}\n\n.form-label__small {\n    color: #0000008c;\n    font-weight: 300;\n    font-weight: 400\n}\n\n.form-label__small,\n.form-note {\n    font-size: .875rem;\n    line-height: 1.3125rem\n}\n\n.form-note {\n    color: #212123;\n    display: block;\n    font-weight: 300\n}\n\n.form-note:not(:empty) {\n    margin-top: .375rem\n}\n\n.form-option-label+.form-note {\n    margin-top: .125rem\n}\n\n.form-note--constraint.is-invalid,\n.is-invalid .form-note--constraint,\n.is-invalid+.form-note--constraint {\n    color: #c00\n}\n\n.form-note--constraint.is-successful,\n.is-successful .form-note--constraint {\n    color: #13bf3e\n}\n\n.form-option {\n    align-items: flex-start;\n    display: flex\n}\n\n.form-option .form-checkbox,\n.form-option .form-radio {\n    margin-top: .125rem\n}\n\n.button {\n    align-items: center;\n    background-color: initial;\n    border: 1px solid #0000;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px #0000001a;\n    display: inline-flex;\n    font-weight: 600;\n    justify-content: center;\n    line-height: 1.5;\n    min-height: 3rem;\n    padding: .6875rem .9375rem;\n    position: relative;\n    transition: all 125ms ease;\n    width: auto\n}\n\n.button[disabled] {\n    opacity: .4;\n    pointer-events: none\n}\n\n.button__icon {\n    flex: none;\n    margin-left: .5rem\n}\n\n.button__icon:not(.button__icon--has-colors) [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.button__icon:not(.button__icon--has-colors)[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: currentColor\n}\n\n.button__icon:not(.button__icon--has-colors) [fill]:not([fill=none]):not([fill=currentcolor]),\n.button__icon:not(.button__icon--has-colors)[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: currentColor\n}\n\n.button__icon:not(.button__icon--has-colors) [color],\n.button__icon:not(.button__icon--has-colors)[color] {\n    color: currentColor\n}\n\n.button__icon--pre {\n    margin-left: 0;\n    margin-right: .25rem\n}\n\n.button--primary {\n    background-color: #000;\n    color: #fff\n}\n\n.button--primary:hover {\n    background-color: #000000d9\n}\n\n.button--primary:focus {\n    background-color: #000000b3;\n    box-shadow: 0 0 0 .125rem #0000001a;\n    outline: none\n}\n\n.button--primary:active {\n    background-color: #000;\n    box-shadow: 0 1px 2px #0000001a;\n    color: #ffffffb3\n}\n\n.page--inverted .button--primary {\n    background-color: #fff;\n    color: #000\n}\n\n.page--inverted .button--primary:hover {\n    background-color: #fffc\n}\n\n.page--inverted .button--primary:focus {\n    background-color: #ffffffa3\n}\n\n.page--inverted .button--primary:active {\n    color: #000c\n}\n\n.button--secondary {\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #00000014;\n    color: #000000d9\n}\n\n.button--secondary:hover {\n    background-color: #f9f9f9;\n    color: #000\n}\n\n.button--secondary:focus {\n    border-color: #0000;\n    box-shadow: 0 0 0 .125rem #0000001a;\n    outline: none\n}\n\n.button--secondary:active {\n    background-color: #e6e6e6;\n    border-color: #0000001a;\n    box-shadow: 0 1px 2px #0000001a\n}\n\n.page--inverted .button--secondary {\n    background-color: #000c;\n    border-color: #fff3;\n    color: #fff\n}\n\n.page--inverted .button--secondary:hover {\n    background-color: #00000014\n}\n\n.button--tertiary {\n    background-color: #0000000a;\n    box-shadow: none;\n    color: #000\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .button--tertiary {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px)\n    }\n}\n\n.button--tertiary:hover {\n    background-color: #0000001a\n}\n\n.button--tertiary:focus {\n    box-shadow: 0 0 0 .125rem #0000001a;\n    outline: none\n}\n\n.button--tertiary:active {\n    background-color: #0000004d\n}\n\n.page--inverted .button--tertiary {\n    background-color: #ffffff1f;\n    color: #fff\n}\n\n.page--inverted .button--tertiary:hover {\n    background-color: #fff3\n}\n\n.page--inverted .button--tertiary:active {\n    background-color: #ffffff52\n}\n\n.button--download {\n    align-items: center;\n    display: flex;\n    padding: .75rem 1rem .75rem .75rem\n}\n\n.button--download img {\n    height: auto;\n    margin-right: .5rem;\n    max-width: 1.5rem\n}\n\n.button--download.button--primary img {\n    border: 1.5px solid #ffffff52;\n    border-radius: 6px\n}\n\n.button--plain {\n    background-color: initial;\n    border-bottom: 1.5px solid #0003;\n    border-radius: 0;\n    box-shadow: none;\n    color: #000;\n    color: #212123;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    min-height: auto;\n    padding: 0;\n    text-decoration: none;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .button--plain {\n        transition-duration: 1ms\n    }\n}\n\n.button--plain:active,\n.button--plain:hover {\n    color: #0000007a\n}\n\n.button--negative {\n    background-color: #c00;\n    color: #fff\n}\n\n.button--compact {\n    line-height: 1.25rem\n}\n\n.button--compact,\n.button--medium {\n    font-size: .875rem;\n    min-height: 2.5rem;\n    padding: .5625rem .6875rem\n}\n\n.button--medium,\n.button--small {\n    font-weight: 600;\n    line-height: 1.25\n}\n\n.button--small {\n    font-size: .8125rem;\n    min-height: 2rem;\n    padding: .3125rem .6875rem\n}\n\n.button--large {\n    border-radius: .34375rem;\n    font-size: 1.25rem;\n    line-height: 1.625rem;\n    padding: 1.125rem 1.8125rem\n}\n\n.button--wide {\n    display: flex;\n    width: 100%\n}\n\n.button--no-shadow,\n.button--no-shadow:active,\n.button--no-shadow:focus,\n.button--no-shadow:hover {\n    box-shadow: none\n}\n\n.button--no-transforms:active,\n.button--no-transforms:hover {\n    transform: none\n}\n\n.button--label-left {\n    justify-content: flex-start\n}\n\n.button--space-between {\n    justify-content: space-between\n}\n\n.button--icon-only {\n    width: 0\n}\n\n.button--icon-only .button__icon {\n    margin: 0\n}\n\n.button--in-group {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0\n}\n\n.button:before {\n    background-position: 50%;\n    content: \"\";\n    height: 1.5rem;\n    left: calc(50% - .75rem);\n    opacity: 0;\n    position: absolute;\n    top: calc(50% - .75rem);\n    transition: opacity .25s ease;\n    width: 1.5rem\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .button:before {\n        transition-duration: 1ms\n    }\n}\n\n.button.is-waiting {\n    background-color: #000;\n    border-color: #0000;\n    color: #0000;\n    opacity: 1;\n    pointer-events: none\n}\n\n.button.is-waiting:before {\n    animation: spin .5s linear infinite;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3CradialGradient id='a' cx='97.483%25' cy='28.573%25' r='168.336%25' fx='97.483%25' fy='28.573%25' gradientTransform='matrix(.9983 -.05822 .02352 .40335 -.005 .227)'%3E%3Cstop stop-color='%23FFF' offset='0%25'/%3E%3Cstop stop-color='%23FFF' stop-opacity='.816' offset='18.426%25'/%3E%3Cstop stop-color='%23FFF' stop-opacity='0' offset='100%25'/%3E%3C/radialGradient%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3Cpath stroke='url(%23a)' stroke-width='2' d='M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11z' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='48.33 69.117'/%3E%3C/g%3E%3C/svg%3E\");\n    opacity: 1\n}\n\n.button.is-invalid,\n.is-invalid .button {\n    animation: shake .5s linear;\n    background-color: #c00;\n    border-color: #0000;\n    color: #0000;\n    opacity: 1;\n    pointer-events: none\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n\n    .button.is-invalid,\n    .is-invalid .button {\n        animation: none\n    }\n}\n\n.button.is-invalid:before,\n.is-invalid .button:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFF'%3E%3Cpath d='M12.5 11.086 6.457 5.043a1 1 0 0 0-1.414 1.414l6.043 6.043-6.043 6.043a1 1 0 0 0 1.414 1.414l6.043-6.043 6.043 6.043a1 1 0 0 0 1.414-1.414L13.914 12.5l6.043-6.043a1 1 0 0 0-1.414-1.414L12.5 11.086z'/%3E%3C/svg%3E\");\n    opacity: 1\n}\n\n.button.is-successful,\n.is-successful .button {\n    background-color: #13bf3e;\n    border-color: #0000;\n    color: #0000;\n    opacity: 1;\n    pointer-events: none\n}\n\n.button.is-successful:focus,\n.is-successful .button:focus {\n    box-shadow: 0 0 0 .125rem #13bf3e80\n}\n\n.button.is-successful:before,\n.is-successful .button:before {\n    animation: flash 1s linear;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFF'%3E%3Cpath d='M3.707 11.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l12-12a1 1 0 0 0-1.414-1.414L9 16.586l-5.293-5.293z'/%3E%3C/svg%3E\");\n    opacity: 1\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n\n    .button.is-successful:before,\n    .is-successful .button:before {\n        animation: none\n    }\n}\n\n.pill {\n    background-color: #00000014;\n    border-radius: 6px;\n    color: #000000b3;\n    display: inline-block;\n    font-size: .6875rem;\n    font-weight: 600;\n    line-height: 0;\n    padding: .75rem .5rem;\n    text-transform: uppercase\n}\n\n.pill.pill--yellow {\n    background-color: #f5a925;\n    color: #000c\n}\n\n.pill.pill--feature {\n    margin-left: .25rem;\n    position: relative;\n    top: -.1875rem\n}\n\n.pill.pill--orange {\n    background-color: #f26725;\n    color: #fff\n}\n\n.pill--secondary {\n    background-color: #ebebeb;\n    color: #000000a3\n}\n\n.pill--rainbow {\n    background: linear-gradient(90deg, #e8b8fc, #e7db8f 35%, #a6f1e8 69%, #88fccf);\n    color: #212123;\n    text-transform: uppercase\n}\n\n.pill--round {\n    background-color: #00000014;\n    border-radius: 6px;\n    border-radius: 9999px;\n    color: #000000b3;\n    font-size: .6875rem;\n    font-weight: 600;\n    line-height: 0;\n    min-width: 1.25rem;\n    padding: .625rem .375rem;\n    text-transform: uppercase\n}\n\n.pill--round,\n.pill-link {\n    display: inline-block\n}\n\n.pill-link:hover .pill {\n    color: #212123\n}\n\n.main-nav__subnav__mega-menu {\n    background-repeat: no-repeat;\n    background-size: 2.5rem 100%;\n    min-height: 12rem;\n    transition: background-image 80ms linear\n}\n\n.main-nav__subnav__column__title {\n    color: #0000007a;\n    font-size: .6875rem;\n    font-weight: 600;\n    line-height: 1rem;\n    margin-top: 0;\n    padding: .625rem .875rem .5rem .75rem;\n    text-transform: uppercase\n}\n\n.main-nav__subnav__column {\n    display: flex;\n    flex-direction: column;\n    padding: .5rem;\n    position: relative\n}\n\n.main-nav__subnav__column+.main-nav__subnav__column {\n    border-left: 1px solid #00000014\n}\n\n.main-nav__subnav__column--color:before {\n    background: #00000014;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: -1px;\n    position: absolute;\n    top: 0;\n    width: .0625rem\n}\n\n.main-nav__subnav__column--color:first-of-type {\n    margin-left: 2.5rem\n}\n\n.main-nav__subnav__column--updates {\n    padding: 0\n}\n\n.main-nav__subnav__mega-menu__updates-wrapper {\n    background-color: #fafafa;\n    padding: .5rem .5rem 1.5rem\n}\n\n.main-nav__subnav__mega-menu--content {\n    max-width: 19.75rem;\n    min-width: 19.75rem;\n    padding: .4375rem .75rem;\n    width: 100%\n}\n\n@media screen and (min-width:1024px) {\n\n    .main-nav__subnav__mega-menu--content:active,\n    .main-nav__subnav__mega-menu--content:hover {\n        background-color: #f5f5f5;\n        border-radius: 6px;\n        cursor: pointer;\n        transition: background-color 125ms linear\n    }\n\n    .main-nav__subnav__mega-menu--content:active .main-nav__subnav__mega-menu--whats-new-date,\n    .main-nav__subnav__mega-menu--content:hover .main-nav__subnav__mega-menu--whats-new-date {\n        display: block\n    }\n\n    .main-nav__subnav__mega-menu--content:active .main-nav__subnav__mega-menu--whats-new-item:before,\n    .main-nav__subnav__mega-menu--content:hover .main-nav__subnav__mega-menu--whats-new-item:before {\n        box-shadow: 0 0 0 4px #f5f5f5;\n        transition: all 125ms ease\n    }\n}\n\n.main-nav__subnav__mega-menu__updates {\n    position: relative\n}\n\n.main-nav__subnav__mega-menu__updates:before {\n    background-color: #00000014;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 1.3125rem;\n    position: absolute;\n    top: 1.5rem;\n    width: 1px\n}\n\n.main-nav__subnav__mega-menu--whats-new-item {\n    color: #212123;\n    display: flex;\n    font-size: .9375rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    margin-bottom: .125rem;\n    margin-left: 1.875rem;\n    margin-top: .125rem;\n    position: relative\n}\n\n.main-nav__subnav__mega-menu--whats-new-item:before {\n    background-color: #f26725;\n    border: 4px solid #ffe8db;\n    border-radius: 9999px;\n    box-shadow: 0 0 0 4px #fafafa;\n    content: \"\";\n    height: .9375rem;\n    left: -1.75rem;\n    position: absolute;\n    top: .25rem;\n    width: .9375rem;\n    z-index: 10\n}\n\n@media screen and (max-width:767px) {\n    .main-nav__subnav__mega-menu--whats-new-item {\n        flex-direction: column\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav__subnav__mega-menu--whats-new-item {\n        align-items: center\n    }\n}\n\n.main-nav__subnav__mega-menu--whats-new-title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    word-break: break-all\n}\n\n@media screen and (max-width:767px) {\n    .main-nav__subnav__mega-menu--whats-new-title {\n        margin-bottom: .25rem\n    }\n}\n\n@media screen and (min-width:768px) {\n    .main-nav__subnav__mega-menu--whats-new-title {\n        width: 16.25rem\n    }\n}\n\n.main-nav__subnav__mega-menu--whats-new-date {\n    text-wrap: nowrap;\n    color: #0000007a;\n    font-size: .6875rem;\n    font-weight: 600;\n    line-height: 1rem;\n    padding-left: .25rem;\n    text-transform: uppercase;\n    white-space: nowrap\n}\n\n@media screen and (min-width:768px) {\n    .main-nav__subnav__mega-menu--whats-new-date {\n        margin-left: auto\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav__subnav__mega-menu--whats-new-date {\n        display: none\n    }\n}\n\n.main-nav__subnav__mega-menu--link-wrapper {\n    background-color: #fff;\n    padding: .5rem;\n    position: relative;\n    text-align: center;\n    z-index: 1\n}\n\n.main-nav__subnav__mega-menu--link-wrapper:before {\n    background-color: #ebebeb;\n    content: \"\";\n    height: .0625rem;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%\n}\n\n.main-nav__subnav__mega-menu--link {\n    color: #212123;\n    display: block;\n    font-size: .9375rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    padding: .5rem .625rem;\n    width: 100%\n}\n\n.main-nav__subnav__mega-menu--link:hover {\n    background-color: #0000000a;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 125ms linear\n}\n\n\n.mobile-nav {\n    background-clip: padding-box;\n    background-color: #fff;\n    background-repeat: no-repeat;\n    background-size: 1rem;\n    border-right: .0625rem solid #00000014;\n    height: calc(100% + 1px);\n    left: 0;\n    overflow-y: scroll;\n    overscroll-behavior: contain;\n    pointer-events: none;\n    position: fixed;\n    top: -1px;\n    transform: translateX(-100%);\n    transition: transform .25s cubic-bezier(.19, 1, .22, 1), visibility 0s linear .25s;\n    visibility: hidden;\n    width: 83vw\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .mobile-nav {\n        transition-duration: 1ms\n    }\n}\n\nbody.is-loading .mobile-nav {\n    transition-duration: 0s\n}\n\n.main-nav.is-safari .mobile-nav {\n    bottom: 0;\n    height: 100dvh\n}\n\n@media screen and (min-width:768px) {\n    .mobile-nav {\n        width: 57vw\n    }\n}\n\n.main-nav.is-active .mobile-nav {\n    pointer-events: auto;\n    transform: translateX(0);\n    transition: transform .4s cubic-bezier(.19, 1, .22, 1), visibility 0s linear;\n    visibility: visible\n}\n\n.mobile-nav__wrapper {\n    padding: 0 1rem env(safe-area-inset-bottom) 2rem\n}\n\n@media screen and (max-width:1023px) {\n    .main-nav__heading {\n        color: #0000007a;\n        font-size: .6875rem;\n        font-weight: 600;\n        line-height: 1rem;\n        margin-top: 0;\n        text-transform: uppercase\n    }\n\n    .main-nav__heading.main-nav__heading--icon {\n        align-items: center;\n        display: flex\n    }\n\n    .main-nav__heading.main-nav__heading--icon .icon {\n        color: #000;\n        margin-left: .125rem\n    }\n}\n\n.mobile-nav__links .main-nav__item-group {\n    border-bottom: 1px solid #00000014;\n    padding: 1.5rem .5rem\n}\n\n.mobile-nav__links .main-nav__item-group:last-child {\n    border-bottom: none\n}\n\n.mobile-nav__links .main-nav__menu__pages,\n.mobile-nav__links .main-nav__menu__pages>li>ul {\n    list-style: none;\n    padding-left: 0\n}\n\n.mobile-nav__links .main-nav__menu__pages>.main-nav__item-group:first-child {\n    padding-top: 0\n}\n\n.mobile-nav__links .main-nav__menu__pages>.main-nav__item-group:last-child {\n    padding-bottom: 2.5rem\n}\n\n.mobile-nav__links .main-nav__subnav__mega-menu--link-wrapper:before {\n    display: none\n}\n\n.mobile-nav__links .main-nav__subnav__item {\n    height: auto;\n    margin-top: .75rem;\n    padding: 0\n}\n\n.mobile-nav__links .main-nav__subnav__link {\n    line-height: 1.5rem;\n    padding: 0\n}\n\n.mobile-nav__links .main-nav__subnav__mega-menu--link {\n    background-color: #f5f5f5;\n    border-radius: 6px;\n    font-size: .875rem;\n    font-weight: 500;\n    line-height: 1.5rem\n}\n\n.mobile-nav__actions {\n    align-items: center;\n    background-image: linear-gradient(180deg, #fff 65%, #fff0);\n    display: flex;\n    height: 4rem;\n    justify-content: space-between;\n    padding-right: .5rem;\n    position: sticky;\n    top: 0;\n    z-index: 100\n}\n\n.mobile-nav__close {\n    background-color: initial;\n    border: none;\n    display: block;\n    padding: .5rem\n}\n\n.mobile-nav__close-icon {\n    color: #0000007a;\n    display: block;\n    height: auto;\n    width: inherit\n}\n\n.mobile-nav__link {\n    color: #000;\n    font-size: .9375rem;\n    font-weight: 500\n}\n\n.mobile-nav__dev-actions {\n    display: flex;\n    justify-content: center;\n    margin-bottom: .5rem;\n    padding-right: 1rem\n}\n\n.mobile-nav__toggle-layout {\n    align-self: center;\n    border: 0;\n    color: #858585;\n    font-weight: 500;\n    min-height: auto;\n    padding: 0;\n    transition: color 125ms ease-out\n}\n\n.mobile-nav__toggle-layout:hover {\n    color: #212123\n}\n\n.mobile-nav__get-started {\n    background-image: linear-gradient(180deg, #fff0, #fff 33%);\n    bottom: 0;\n    padding: 1.5rem .5rem;\n    position: sticky;\n    z-index: 1000\n}\n\n.mobile-nav__links+.mobile-nav__get-started.is-hidden {\n    padding-bottom: 0;\n    padding-top: 1.5rem\n}\n\n.mobile-nav__get-started.is-hidden {\n    display: block;\n    padding-bottom: 0;\n    padding-top: 3.5rem\n}\n\n.mobile-nav__get-started.is-hidden .main-nav__items {\n    display: none\n}\n\n.mobile-nav__get-started .button {\n    width: 100%\n}\n\n.mobile-nav .mobile-nav__get-started .main-nav__item--cta {\n    display: block\n}\n\n.add-top-margin {\n    margin-top: 2.5rem\n}\n\n.button--dark-icon .button__icon--pre,\n.button--light-icon .button__icon--pre {\n    display: block\n}\n\n.button--dark-icon {\n    display: none\n}\n\n@media screen and (prefers-color-scheme:dark) and (max-width:1023px) {\n    .mobile-nav {\n        background-color: #212123\n    }\n\n    .mobile-nav .main-nav__heading {\n        color: #ffffff7a\n    }\n\n    .mobile-nav__links .main-nav__subnav__link {\n        color: #ccc\n    }\n\n    .mobile-nav__links .main-nav__subnav__link:active,\n    .mobile-nav__links .main-nav__subnav__link:hover {\n        color: #858585\n    }\n\n    .mobile-nav__actions {\n        background-image: linear-gradient(180deg, #212123 65%, #21212300)\n    }\n\n    .mobile-nav__link {\n        color: #ebebeb\n    }\n\n    .mobile-nav__get-started {\n        background-image: linear-gradient(180deg, #21212300, #212123 33%)\n    }\n\n    .mobile-nav__toggle-layout:active,\n    .mobile-nav__toggle-layout:hover {\n        color: #ccc\n    }\n\n    .mobile-nav__close-icon {\n        color: #858585\n    }\n\n    .mobile-nav__links .main-nav__item-group {\n        border-color: #ffffff14\n    }\n\n    .mobile-nav__get-started .button {\n        background-color: #fff;\n        color: #000\n    }\n\n    .mobile-nav .main-nav__item__badge:after {\n        background-color: #ffffff14;\n        color: #ffffff7a\n    }\n\n    .button--dark-icon {\n        display: block\n    }\n\n    .button--light-icon {\n        display: none\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .page--inverted .mobile-nav {\n        background-color: #212123\n    }\n\n    .page--inverted .mobile-nav .main-nav__heading {\n        color: #ffffff7a\n    }\n\n    .page--inverted .mobile-nav__links .main-nav__subnav__link {\n        color: #ccc\n    }\n\n    .page--inverted .mobile-nav__links .main-nav__subnav__link:active,\n    .page--inverted .mobile-nav__links .main-nav__subnav__link:hover {\n        color: #858585\n    }\n\n    .page--inverted .mobile-nav__actions {\n        background-image: linear-gradient(180deg, #212123 65%, #21212300)\n    }\n\n    .page--inverted .mobile-nav__link {\n        color: #ebebeb\n    }\n\n    .page--inverted .mobile-nav__get-started {\n        background-image: linear-gradient(180deg, #21212300, #212123 33%)\n    }\n\n    .page--inverted .mobile-nav__toggle-layout:active,\n    .page--inverted .mobile-nav__toggle-layout:hover {\n        color: #ccc\n    }\n\n    .page--inverted .mobile-nav__close-icon {\n        color: #858585\n    }\n\n    .page--inverted .mobile-nav__links .main-nav__item-group {\n        border-color: #ffffff14\n    }\n\n    .page--inverted .mobile-nav__get-started .button {\n        background-color: #fff;\n        color: #000\n    }\n\n    .page--inverted .mobile-nav .main-nav__item__badge:after {\n        background-color: #ffffff14;\n        color: #ffffff7a\n    }\n\n    .page--inverted .button--dark-icon {\n        display: block\n    }\n\n    .page--inverted .button--light-icon {\n        display: none\n    }\n}\n\n.extra-surprises .open-homepage-switcher-link,\n.extra-surprises .toggle-grid-layout-link {\n    align-items: center;\n    display: flex;\n    justify-content: space-between\n}\n\n.extra-surprises .open-homepage-switcher-link__icon {\n    color: #adadad\n}\n\n.extra-surprises .toggle-grid-layout-link .switch {\n    display: inline-block;\n    height: 1.25rem;\n    pointer-events: none;\n    position: relative;\n    width: 2.25rem\n}\n\n.extra-surprises .toggle-grid-layout-link .switch input {\n    height: 0;\n    opacity: 0;\n    width: 0\n}\n\n.extra-surprises .toggle-grid-layout-link .slider {\n    background-color: #adadad;\n    bottom: 0;\n    cursor: pointer;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    transition: background-color .4s ease-in-out\n}\n\n.extra-surprises .toggle-grid-layout-link .slider:before {\n    background-color: #fff;\n    bottom: .125rem;\n    content: \"\";\n    height: 1rem;\n    left: .125rem;\n    position: absolute;\n    transition: transform .4s ease-in-out;\n    width: 1rem\n}\n\n.extra-surprises .toggle-grid-layout-link input:checked+.slider {\n    background-color: #f26725\n}\n\n.extra-surprises .toggle-grid-layout-link input:focus+.slider {\n    box-shadow: 0 0 1px #f26725\n}\n\n.extra-surprises .toggle-grid-layout-link input:checked+.slider:before {\n    transform: translateX(16px)\n}\n\n.extra-surprises .toggle-grid-layout-link .slider.round,\n.extra-surprises .toggle-grid-layout-link .slider.round:before {\n    border-radius: 9999px\n}\n\n.tooltip {\n    position: relative\n}\n\nabbr.tooltip {\n    border-bottom: 1px dotted;\n    cursor: help;\n    text-decoration: none\n}\n\n.tooltip:after,\n.tooltip:before {\n    bottom: 100%;\n    left: 50%;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    transform: translate(-50%, -.5rem);\n    transition-duration: .15s;\n    transition-property: transform, opacity;\n    transition-timing-function: cubic-bezier(.215, .61, .355, 1);\n    z-index: 10\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .tooltip:after,\n    .tooltip:before {\n        transition-duration: 1ms\n    }\n}\n\n.tooltip:hover:after,\n.tooltip:hover:before {\n    opacity: 1;\n    transform: translate(-50%)\n}\n\n.tooltip--left:before {\n    left: -.5em;\n    transform: translateY(-.5rem)\n}\n\n.tooltip--left:focus:before,\n.tooltip--left:hover:before {\n    transform: translate(0)\n}\n\n.tooltip--right:before {\n    left: auto;\n    right: -.5em;\n    transform: translateY(-.5rem)\n}\n\n.tooltip--right:focus:before,\n.tooltip--right:hover:before {\n    transform: translate(0)\n}\n\n.tooltip:before {\n    background-color: #000;\n    border-radius: 8px;\n    color: #fff;\n    content: attr(aria-label);\n    font-size: .875rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.25rem;\n    margin-bottom: calc(.25rem + 6px);\n    padding: .75rem 1rem;\n    text-align: left;\n    text-transform: none;\n    white-space: nowrap\n}\n\n.tooltip:after {\n    border-left: 6px solid #0000;\n    border-right: 6px solid #0000;\n    border-top: 6px solid #000;\n    content: \"\";\n    height: 0;\n    margin-bottom: .25rem;\n    width: 0\n}\n\n.tooltip.tooltip--wide:before {\n    min-width: 14rem;\n    white-space: normal\n}\n\n.tooltip.tooltip--new:before {\n    background: #000000a3;\n    font-size: .875rem;\n    line-height: 1.25rem;\n    margin-bottom: .25rem;\n    padding: .625rem .75rem;\n    transform: translate(-50%, .5rem);\n    transition: transform 125ms cubic-bezier(.455, .03, .515, .955), opacity 60ms cubic-bezier(.455, .03, .515, .955);\n    transition-delay: 0s\n}\n\n@media screen and (min-width:1440px) {\n    .tooltip.tooltip--new:before {\n        transform: translate(-50%, -.125rem)\n    }\n}\n\n.tooltip.tooltip--new:hover:before {\n    transform: translate(-50%, -.125rem);\n    transition-delay: 125ms\n}\n\n@media screen and (min-width:1440px) {\n    .tooltip.tooltip--new:hover:before {\n        transform: translate(-50%, -.125rem)\n    }\n}\n\n.tooltip.tooltip--new:after {\n    content: none\n}\n\n@keyframes slide-down {\n    0% {\n        opacity: 0;\n        transform: translateY(-5px)\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0)\n    }\n}\n\nbody {\n    --main-nav-height: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    body {\n        --main-nav-height: 5rem\n    }\n}\n\n.main-nav__inner {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 75rem\n}\n\n.main-nav__bar {\n    display: flex;\n    flex-direction: row;\n    height: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav__bar {\n        height: 5rem\n    }\n}\n\n.main-nav__controls {\n    display: flex\n}\n\n.main-nav__toggle {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    border: 0;\n    border-radius: 0;\n    display: block;\n    line-height: normal;\n    margin: 0;\n    padding: 0\n}\n\n.main-nav__logo {\n    height: 100%\n}\n\n.main-nav__logo__link {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    position: relative\n}\n\n.main-nav__logo__link:before {\n    background-color: initial;\n    bottom: 0;\n    content: \"\";\n    display: block;\n    left: -1rem;\n    position: absolute;\n    right: -1rem;\n    top: 0\n}\n\n.main-nav__logo__link:active {\n    opacity: .64\n}\n\n.main-nav__logo__link:hover .main-nav__logo__shape {\n    opacity: .48;\n    transition: opacity 125ms ease-out\n}\n\n.main-nav__logo__shape {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='32' height='32' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a.8.8 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272z' fill='currentcolor' fill-rule='evenodd'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: block;\n    height: 2rem;\n    width: 2rem\n}\n\n@media screen and (min-width:1024px) {\n    .page--inverted .main-nav__logo__shape {\n        filter: invert(100%)\n    }\n}\n\n@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {\n\n    .main-nav.is-sticky .main-nav__logo__shape,\n    .main-nav:not(.main-nav--blurred) .main-nav__logo__shape {\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='32' height='32' xmlns='http://www.w3.org/2000/svg' color='%23EBEBEB'%3E%3Cpath d='m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a.8.8 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272z' fill='currentcolor' fill-rule='evenodd'/%3E%3C/svg%3E\")\n    }\n}\n\n@media screen and (max-width:1023px) {\n\n    .page--inverted .main-nav.is-sticky .main-nav__logo__shape,\n    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__logo__shape {\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='32' height='32' xmlns='http://www.w3.org/2000/svg' color='%23EBEBEB'%3E%3Cpath d='m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a.8.8 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272z' fill='currentcolor' fill-rule='evenodd'/%3E%3C/svg%3E\")\n    }\n}\n\n.main-nav__logo__name {\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    overflow: hidden;\n    position: absolute !important;\n    white-space: nowrap;\n    width: 1px\n}\n\n.main-nav__item {\n    display: flex;\n    position: relative\n}\n\n.main-nav__item--cta {\n    align-items: center\n}\n\n@media screen and (max-width:1439px) {\n    .main-nav__item--cta .button--primary {\n        font-size: .875rem;\n        line-height: 1.25rem;\n        min-height: auto;\n        padding: .5625rem .6875rem\n    }\n}\n\n.main-nav__download-wrapper {\n    display: none\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav__download-wrapper.operation-system-is-mac {\n        align-items: center;\n        display: flex;\n        justify-content: flex-end\n    }\n}\n\n.main-nav__download-wrapper .download {\n    height: 2.5rem;\n    padding: .5625rem .6875rem .5625rem .5625rem\n}\n\n.main-nav__download-wrapper .download.tooltip.tooltip--new:before {\n    display: none;\n    height: auto;\n    top: unset;\n    transform: translate(-50%, 5.3125rem);\n    width: auto\n}\n\n@media screen and (min-width:1024px) and (max-width:1139px) {\n    .main-nav__download-wrapper .download.tooltip.tooltip--new:before {\n        display: block\n    }\n}\n\n.main-nav__download-wrapper .download.tooltip.tooltip--new:hover:before {\n    transform: translate(-50%, 5.625rem)\n}\n\n@media screen and (min-width:1024px) and (max-width:1139px) {\n    .main-nav__download-wrapper .download {\n        background: #0000;\n        border: none;\n        box-shadow: none;\n        padding: 0\n    }\n}\n\n.main-nav__download-wrapper .download .download__icon {\n    height: 1.5rem;\n    margin-right: .5rem;\n    width: 1.5rem\n}\n\n@media screen and (min-width:1024px) and (max-width:1139px) {\n    .main-nav__download-wrapper .download .download__icon {\n        height: 2rem;\n        margin-right: 0;\n        width: 2rem\n    }\n\n    .main-nav__download-wrapper .download .download__label {\n        display: none\n    }\n}\n\n.main-nav--inverted .main-nav__download-wrapper .download {\n    background-color: #000c;\n    border-color: #fff3;\n    color: #fff\n}\n\n.main-nav--inverted .main-nav__download-wrapper .download:hover {\n    background-color: #00000014\n}\n\n@media screen and (min-width:1024px) and (max-width:1139px) {\n    .main-nav--inverted .main-nav__download-wrapper .download {\n        background-color: initial;\n        border-color: #0000\n    }\n\n    .main-nav--inverted .main-nav__download-wrapper .download:hover {\n        background-color: initial\n    }\n\n    .main-nav__download-wrapper .main-nav__menu__divider {\n        margin-left: 1.5rem\n    }\n}\n\n.main-nav--inverted .main-nav__download-wrapper .main-nav__menu__divider {\n    border-right-color: #fff3\n}\n\n.main-nav__subnav__toggle:hover {\n    cursor: pointer\n}\n\n.main-nav__item__action--icon {\n    margin-top: -.1rem;\n    opacity: .32;\n    vertical-align: inherit\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav__item__action--icon {\n        position: absolute\n    }\n}\n\n.main-nav__item__badge:after {\n    background-color: #ebebeb;\n    border-radius: 9999px;\n    color: #000000a3;\n    content: attr(data-badge-label);\n    display: inline-block;\n    font-size: .6875rem;\n    font-weight: weight-medium;\n    line-height: .75rem;\n    margin-left: .5rem;\n    min-width: 1.25rem;\n    padding: .1875rem .375rem;\n    text-align: center;\n    text-transform: uppercase\n}\n\n@media screen and (max-width:1023px) {\n    .main-nav__logo__shape {\n        height: 1.625rem;\n        width: 1.75rem\n    }\n\n    .main-nav {\n        max-height: 100vh;\n        position: sticky;\n        top: -.03125rem\n    }\n\n    .main-nav__menu__auth {\n        background-color: #fff;\n        position: sticky;\n        z-index: 10\n    }\n\n    .main-nav__bar {\n        flex: 1;\n        justify-content: space-between\n    }\n\n    .main-nav__controls,\n    .main-nav__persistent {\n        flex: 1 0 0\n    }\n\n    .main-nav__persistent,\n    .main-nav__persistent__actions {\n        display: flex;\n        justify-content: flex-end\n    }\n\n    .main-nav__persistent__profile {\n        align-items: center;\n        display: flex;\n        max-width: 1.75rem\n    }\n\n    .main-nav__persistent .main-nav__link {\n        font-size: .9375rem;\n        padding-left: 1rem;\n        padding-right: 1rem\n    }\n\n    .main-nav__persistent .main-nav__item:not(.main-nav__item--cta):last-child {\n        margin-right: -1rem\n    }\n\n    .main-nav__menu {\n        display: none\n    }\n\n    .main-nav.is-active {\n        -webkit-backdrop-filter: none;\n        backdrop-filter: none;\n        background: #0000;\n        box-shadow: none;\n        z-index: 10000\n    }\n\n    .main-nav.is-active nav.main-nav__inner {\n        transform: translateY(-100%);\n        transition: transform .25s cubic-bezier(.19, 1, .22, 1)\n    }\n}\n\n@media screen and (max-width:1023px) and (prefers-reduced-motion:reduce) {\n    .main-nav.is-active nav.main-nav__inner {\n        transition-duration: 1ms\n    }\n}\n\n@media screen and (max-width:1023px) {\n\n    .main-nav__menu .main-nav__item--persistent,\n    .main-nav__menu__auth__profile {\n        display: none\n    }\n\n    .main-nav__item.main-nav__subnav {\n        flex-flow: column\n    }\n\n    .main-nav__subnav.is-active {\n        opacity: 1;\n        pointer-events: auto;\n        visibility: visible\n    }\n\n    .main-nav__subnav__dropdown {\n        margin-bottom: .625rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav {\n        position: relative\n    }\n\n    .main-nav__logo {\n        margin-right: 1.5rem\n    }\n\n    .main-nav__inner {\n        display: flex\n    }\n\n    .main-nav__controls,\n    .main-nav__persistent {\n        display: none\n    }\n\n    .main-nav__bar,\n    .main-nav__menu__auth {\n        flex: 0 1 auto\n    }\n\n    .main-nav__menu,\n    .main-nav__menu__auth__actions,\n    .main-nav__menu__pages {\n        display: flex;\n        flex-flow: row nowrap\n    }\n\n    .main-nav__menu,\n    .main-nav__menu__pages {\n        flex: 1\n    }\n\n    .main-nav__menu__pages {\n        justify-content: flex-start\n    }\n\n    .main-nav__menu__auth {\n        align-items: center;\n        display: flex;\n        justify-content: flex-end\n    }\n\n    .main-nav__item {\n        margin: .875rem 0\n    }\n\n    .main-nav__link {\n        padding-left: 1rem;\n        padding-right: 1rem\n    }\n\n    .main-nav__menu__divider {\n        border-right: 1px solid #00000014;\n        height: 1.5rem;\n        margin-left: 2rem\n    }\n\n    .main-nav__link__icon {\n        color: #00000052\n    }\n\n    .main-nav__link--action {\n        padding: 0 2rem 0 1.5rem\n    }\n\n    .main-nav__subnav {\n        position: relative\n    }\n\n    .main-nav__subnav:hover .main-nav__subnav__dropdown {\n        animation: slide-down .3s cubic-bezier(.19, 1, .22, 1);\n        display: flex;\n        flex-direction: column;\n        opacity: 1;\n        pointer-events: auto;\n        visibility: visible\n    }\n\n    .main-nav__subnav:hover .main-nav__subnav__mega-menu {\n        flex-direction: row;\n        justify-content: space-between\n    }\n\n    .main-nav__subnav__dropdown {\n        background-clip: padding-box;\n        background-color: #fff;\n        border: 1px solid #00000014;\n        border-radius: 12px;\n        box-shadow: 0 4px 8px #00000014;\n        display: none;\n        margin-left: -.25rem;\n        max-height: calc(100vh - 5rem);\n        opacity: 0;\n        overflow: hidden;\n        position: absolute;\n        top: 3.25rem;\n        visibility: hidden;\n        z-index: 1\n    }\n\n    .main-nav__subnav__item .main-nav__subnav__link {\n        display: block;\n        font-size: .9375rem;\n        line-height: 1.25rem;\n        min-width: 15.75rem;\n        padding: .625rem .75rem;\n        width: 100%\n    }\n\n    .main-nav__subnav__item .main-nav__subnav__link:hover {\n        color: #212123\n    }\n\n    .main-nav__subnav__item:hover {\n        background-color: #f5f5f5;\n        border-radius: 6px;\n        transition: background-color 125ms linear\n    }\n\n    .main-nav__subnav__link {\n        display: block;\n        font-size: .9375rem;\n        line-height: 1.25rem;\n        padding: .625rem .75rem;\n        width: 100%\n    }\n\n    .main-nav__subnav__link:hover {\n        color: #212123\n    }\n\n    .main-nav__divider {\n        border-bottom: 1px solid #00000014;\n        margin: .5rem -2rem;\n        padding: 0 .25rem\n    }\n\n    .main-nav__menu__auth__profile {\n        margin-left: 2rem\n    }\n}\n\n.main-nav {\n    background-color: #fff;\n    box-shadow: 0 0 0 .0625rem #00000014;\n    color: #212123;\n    flex: none;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    z-index: 1000\n}\n\n@media screen and (min-width:640px) {\n    .main-nav {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .main-nav {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .main-nav {\n        background-color: #fff\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .main-nav {\n            -webkit-backdrop-filter: blur(40px);\n            backdrop-filter: blur(40px);\n            background-color: #fffc\n        }\n    }\n}\n\n@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {\n    .main-nav {\n        background-color: #212123;\n        box-shadow: 0 0 0 1px #000\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .main-nav {\n            background-color: #000c\n        }\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .page--inverted .main-nav {\n        background-color: #212123;\n        box-shadow: 0 0 0 1px #000\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .page--inverted .main-nav {\n            background-color: #000c\n        }\n    }\n}\n\n.main-nav {\n    transition-duration: 125ms;\n    transition-property: background-color, opacity, visibility;\n    transition-timing-function: cubic-bezier(.455, .03, .515, .955)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-nav {\n        transition-duration: 1ms\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav--inverted {\n        background-color: #212123;\n        box-shadow: none\n    }\n\n    .main-nav--transparent {\n        background-color: initial;\n        box-shadow: none\n    }\n\n    .main-nav--translucent {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        background-color: #fffc;\n        border-bottom: 1px solid #0000001a;\n        box-shadow: none\n    }\n}\n\n.main-nav.main-nav--blurred {\n    background-color: initial;\n    box-shadow: none\n}\n\n@media screen and (max-width:1023px) {\n    .main-nav.main-nav--blurred {\n        position: relative\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-nav.main-nav--blurred {\n        position: relative\n    }\n\n    .main-nav.main-nav--blurred.main-nav--small-blur:before {\n        height: 6rem\n    }\n\n    .main-nav.main-nav--blurred.main-nav--grey-blur:before {\n        background-color: #fafafacc\n    }\n\n    .main-nav.main-nav--blurred:before {\n        -webkit-backdrop-filter: blur(50px);\n        backdrop-filter: blur(50px);\n        bottom: 0;\n        content: \"\";\n        height: 8rem;\n        left: 0;\n        -webkit-mask: linear-gradient(180deg, #000 0, #0000);\n        mask: linear-gradient(180deg, #000 0, #0000);\n        pointer-events: none;\n        position: absolute;\n        right: 0;\n        top: 0\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .main-nav.main-nav--blurred.is-sticky {\n        animation: slideDownNav .4s cubic-bezier(1, 0, 0, 1) forwards;\n        background-color: #fff;\n        box-shadow: 0 0 0 .0625rem #0000001a;\n        opacity: 0;\n        position: sticky;\n        top: -100%\n    }\n\n    @keyframes slideDownNav {\n        0% {\n            opacity: 0;\n            top: -100%\n        }\n\n        to {\n            opacity: 1;\n            top: 0\n        }\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .main-nav.main-nav--blurred.is-sticky {\n            -webkit-backdrop-filter: blur(10px);\n            backdrop-filter: blur(10px);\n            background-color: #fffc\n        }\n    }\n}\n\n@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {\n    .main-nav.main-nav--blurred.is-sticky {\n        background-color: #000c;\n        box-shadow: 0 0 0 1px #000\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .page--inverted .main-nav.main-nav--blurred.is-sticky {\n        background-color: #000c;\n        box-shadow: 0 0 0 1px #000\n    }\n\n    .main-nav.main-nav--blurred.was-sticky {\n        animation: slideUpNav .4s cubic-bezier(1, 0, 0, 1) forwards;\n        opacity: 1;\n        position: sticky;\n        top: 0\n    }\n}\n\n@media screen and (max-width:1023px) {\n    @keyframes slideUpNav {\n        0% {\n            top: 0\n        }\n\n        to {\n            position: relative;\n            top: -100%\n        }\n    }\n}\n\n.main-nav.main-nav--blurred.is-sticky.is-active {\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    background-color: initial;\n    box-shadow: none\n}\n\n.main-nav__link {\n    align-items: center;\n    color: #000;\n    display: flex;\n    font-weight: 500;\n    justify-content: space-between;\n    transition: color 125ms ease-out;\n    width: 100%\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .main-nav__link {\n        transition-duration: 1ms\n    }\n}\n\n.main-nav__link:active,\n.main-nav__link:hover {\n    color: #0000007a\n}\n\n.main-nav--inverted .main-nav__link {\n    color: #fff\n}\n\n.main-nav--inverted .main-nav__link:hover {\n    color: #ffffffa3\n}\n\n.main-nav__subnav__link {\n    align-items: center;\n    color: #000;\n    display: inline-flex;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .main-nav__subnav__link {\n        transition-duration: 1ms\n    }\n}\n\n.main-nav__subnav__link:active,\n.main-nav__subnav__link:hover {\n    color: #0000007a\n}\n\n@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {\n\n    .main-nav.is-sticky .main-nav__link--action,\n    .main-nav:not(.main-nav--blurred) .main-nav__link--action {\n        color: #ebebeb\n    }\n}\n\n@media screen and (max-width:1023px) {\n\n    .page--inverted .main-nav.is-sticky .main-nav__link--action,\n    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__link--action {\n        color: #ebebeb\n    }\n}\n\n.main-nav__link__icon {\n    justify-self: flex-end;\n    margin-left: .25rem;\n    transition-duration: 125ms;\n    transition-property: stroke, fill, transform;\n    transition-timing-function: cubic-bezier(.455, .03, .515, .955)\n}\n\n.main-nav__link__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.main-nav__link__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: currentColor\n}\n\n.main-nav__link__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.main-nav__link__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: currentColor\n}\n\n.main-nav__link__icon [color],\n.main-nav__link__icon[color] {\n    color: currentColor\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-nav__link__icon {\n        transition-duration: 1ms\n    }\n}\n\n.main-nav--inverted .main-nav__link__icon {\n    color: #ffffff52\n}\n\n.main-nav__toggle {\n    color: #000;\n    margin-left: -1rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    transition: color 125ms cubic-bezier(.455, .03, .515, .955)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-nav__toggle {\n        transition-duration: 1ms\n    }\n}\n\n.main-nav__toggle:active {\n    opacity: .64\n}\n\n.main-nav__toggle__icon {\n    display: block;\n    height: 1.5rem;\n    position: relative;\n    width: 1.5rem\n}\n\n@media screen and (max-width:1023px) and (prefers-color-scheme:dark) {\n\n    .main-nav.is-sticky .main-nav__toggle__icon,\n    .main-nav:not(.main-nav--blurred) .main-nav__toggle__icon {\n        color: #ebebeb\n    }\n}\n\n@media screen and (max-width:1023px) {\n\n    .page--inverted .main-nav.is-sticky .main-nav__toggle__icon,\n    .page--inverted .main-nav:not(.main-nav--blurred) .main-nav__toggle__icon {\n        color: #ebebeb\n    }\n}\n\n.main-nav__toggle__icon__line {\n    background-color: currentColor;\n    border-radius: 9999px;\n    display: block;\n    height: .125rem;\n    left: .125rem;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    transition: all 125ms cubic-bezier(.25, .46, .45, .94);\n    width: 1.25rem\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-nav__toggle__icon__line {\n        transition-duration: 1ms\n    }\n}\n\n.main-nav__toggle__icon__line--top {\n    top: .4375rem\n}\n\n.main-nav__toggle__icon__line--bottom {\n    bottom: .4375rem\n}\n\n.main-nav-skip:not(:focus) {\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    overflow: hidden;\n    position: absolute !important;\n    white-space: nowrap;\n    width: 1px\n}\n\n.main-nav-skip:focus {\n    background-color: #fff;\n    border: 2px solid;\n    border-radius: 6px;\n    box-shadow: 0 0 0 .1875rem #0000001a;\n    color: #000;\n    display: inline-block;\n    font-size: 1rem;\n    font-weight: 600;\n    left: 1rem;\n    line-height: 1.25rem;\n    padding: .75rem 1rem;\n    position: absolute;\n    top: 1rem;\n    z-index: 10001\n}\n\n.main-footer {\n    color: #000000b3;\n    flex: none;\n    font-weight: 300;\n    line-height: 1.25;\n    margin-top: 5rem;\n    z-index: 1\n}\n\n.main-footer--no-margin {\n    margin: 0\n}\n\n.main-footer__footer {\n    background-color: #f9f9f9\n}\n\n.main-footer--inverted .main-footer__footer {\n    background-color: #212123\n}\n\n.main-footer--transparent .main-footer__footer {\n    background-color: initial\n}\n\n.main-footer--white .main-footer__footer {\n    background-color: #fff\n}\n\n.main-footer__nl {\n    padding: 2rem 0\n}\n\n.main-footer--white .main-footer__nl {\n    padding-top: 0\n}\n\n.main-footer__nav {\n    padding-bottom: 1.9375rem;\n    padding-top: 2.5rem\n}\n\n@media screen and (min-width:1024px) {\n    .main-footer__nav {\n        padding-bottom: .9375rem;\n        padding-top: 2.5rem\n    }\n}\n\n.main-footer__nl {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: 1fr\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__nl {\n        gap: 2rem;\n        grid-template-columns: repeat(2, 1fr)\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-footer__nl {\n        gap: 2rem;\n        grid-template-columns: 2fr 1fr\n    }\n}\n\n.main-footer__nl__text {\n    padding-top: .25rem\n}\n\n.page--inverted .main-footer__nl__form .form-input {\n    background-color: #ffffff0a;\n    border: 1px solid #ffffff52;\n    box-shadow: none;\n    color: #fff\n}\n\n.page--inverted .main-footer__nl__form .form-input::placeholder {\n    color: #ffffff52\n}\n\n.main-footer__nl__confirm {\n    margin-top: .5rem;\n    width: 100%\n}\n\n.page--inverted .main-footer__nl__confirm .form-option-label {\n    color: #fff\n}\n\n.main-footer__nl__form__button {\n    white-space: nowrap\n}\n\n.page--inverted .main-footer__nl__form__button {\n    background-color: #ffffff52;\n    color: #fff\n}\n\n.page--inverted .main-footer__nl__form__button:hover {\n    background-color: #ffffff0a\n}\n\n.main-footer__nl__heading {\n    color: #212123;\n    font-size: 1.0625rem;\n    font-weight: 600;\n    line-height: 1.5rem;\n    margin-bottom: .25rem\n}\n\n.main-footer--inverted .main-footer__nl__heading {\n    color: #fff\n}\n\n.main-footer__nl__blurb {\n    line-height: 1.5rem\n}\n\n.main-footer--inverted .main-footer__nl__blurb {\n    color: #ffffffa3\n}\n\n.main-footer__content {\n    border-top: 1px solid #0000001a\n}\n\n.main-footer--inverted .main-footer__content {\n    border-color: #ffffff14\n}\n\n.main-footer__nav {\n    column-gap: .75rem;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));\n    position: relative;\n    row-gap: 2rem\n}\n\n@media screen and (min-width:694px) {\n    .main-footer__nav {\n        column-gap: 2rem;\n        grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr))\n    }\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__nav {\n        column-gap: 1.5rem;\n        grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr))\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-footer__nav {\n        display: flex;\n        justify-content: space-between\n    }\n}\n\n.main-footer__nav__heading {\n    align-items: center;\n    color: #212123;\n    display: flex;\n    flex-direction: row;\n    font-weight: 600;\n    justify-content: flex-start\n}\n\n.main-footer--inverted .main-footer__nav__heading {\n    color: #fff\n}\n\n.main-footer__nav__heading__badge {\n    margin-left: .5rem\n}\n\n.main-footer__nav__item {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    border: 0;\n    border-radius: 0;\n    line-height: normal;\n    margin: 0;\n    padding: 0\n}\n\n.main-footer__nav__heading,\n.main-footer__nav__item {\n    line-height: 1.5rem;\n    margin-bottom: .5rem\n}\n\n.main-footer__nav__item {\n    color: #000000a3;\n    display: flex;\n    font-weight: 400;\n    transition: color 125ms cubic-bezier(.455, .03, .515, .955)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-footer__nav__item {\n        transition-duration: 1ms\n    }\n}\n\n.main-footer__nav__item:not([target=_blank]) {\n    align-items: center;\n    display: block\n}\n\n.main-footer__nav__item:active,\n.main-footer__nav__item:focus,\n.main-footer__nav__item:hover {\n    color: #000c\n}\n\n.main-footer__nav__item:active .main-footer__nav__item__action--icon,\n.main-footer__nav__item:focus .main-footer__nav__item__action--icon,\n.main-footer__nav__item:hover .main-footer__nav__item__action--icon {\n    opacity: .8\n}\n\n.main-footer--inverted .main-footer__nav__item {\n    color: #fffc\n}\n\n.main-footer__nav__item.main-footer__nav__item__badge {\n    white-space: nowrap\n}\n\n.main-footer__nav__item__icon {\n    fill: currentColor;\n    height: 1.25rem;\n    margin-right: .25rem;\n    opacity: .8;\n    -webkit-user-select: none;\n    user-select: none;\n    width: 1.25rem\n}\n\n.main-footer__nav__item__action {\n    font-weight: 500;\n    margin-left: .25rem\n}\n\n.main-footer__nav__item__action--icon {\n    margin-left: 0;\n    margin-right: -1.25rem;\n    opacity: .32;\n    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955);\n    vertical-align: bottom\n}\n\n.main-footer__nav__item__action--icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.main-footer__nav__item__action--icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #000\n}\n\n.main-footer__nav__item__action--icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.main-footer__nav__item__action--icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #000\n}\n\n.main-footer__nav__item__action--icon [color],\n.main-footer__nav__item__action--icon[color] {\n    color: #000\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .main-footer__nav__item__action--icon {\n        transition-duration: 1ms\n    }\n}\n\n.main-footer--inverted .main-footer__nav__item__action--icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.main-footer--inverted .main-footer__nav__item__action--icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #fff\n}\n\n.main-footer--inverted .main-footer__nav__item__action--icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.main-footer--inverted .main-footer__nav__item__action--icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #fff\n}\n\n.main-footer--inverted .main-footer__nav__item__action--icon [color],\n.main-footer--inverted .main-footer__nav__item__action--icon[color] {\n    color: #fff\n}\n\n.main-footer__notice {\n    color: #0000007a;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    text-align: center\n}\n\n.main-footer--inverted .main-footer__notice {\n    color: #ffffffa3\n}\n\n.main-footer__skpabloo {\n    align-items: center;\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: space-between;\n    padding-bottom: 2.625rem;\n    padding-top: 1.5625rem\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__skpabloo {\n        flex-direction: row;\n        padding-bottom: 2.5rem;\n        padding-top: 2.375rem\n    }\n}\n\n@media screen and (max-width:767px) {\n    .main-footer__logo {\n        display: none\n    }\n}\n\n.main-footer__logo__link {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='m.304 9.113 5.05-6.427a.6.6 0 0 1 .38-.222l6.175-.95a.6.6 0 0 1 .182 0l6.175.95a.6.6 0 0 1 .38.222l5.05 6.427a.6.6 0 0 1-.017.76L12.342 23.102a.45.45 0 0 1-.684 0L.321 9.874a.6.6 0 0 1-.017-.761zm13.272-5.158 4.334 4a.3.3 0 0 0 .501-.254l-.304-2.74a.15.15 0 0 1 .286-.077l1.464 3.294a.8.8 0 0 0 .478.434l1.788.596a.15.15 0 0 1-.047.292h-1.638a.8.8 0 0 0-.674.369l-6.438 10.059a.15.15 0 0 1-.261-.146l4.591-9.566a.5.5 0 0 0-.45-.716H6.794a.5.5 0 0 0-.451.716l4.591 9.566a.15.15 0 0 1-.261.146L4.236 9.868a.8.8 0 0 0-.674-.368H1.924a.15.15 0 0 1-.047-.292l1.788-.596a.8.8 0 0 0 .478-.434l1.464-3.294a.15.15 0 0 1 .286.078l-.304 2.74a.3.3 0 0 0 .501.253l4.334-4a.15.15 0 0 1 .218.205L7.9 7.51a.3.3 0 0 0 .232.49h7.734a.3.3 0 0 0 .232-.49l-2.74-3.35a.15.15 0 0 1 .217-.205z' fill='currentcolor' fill-rule='evenodd'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: block;\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n.main-footer--inverted .main-footer__logo__link {\n    filter: invert(100%)\n}\n\n.main-footer__social {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-bottom: 1.375rem\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__social {\n        margin-bottom: 0\n    }\n}\n\n.main-footer__social__item:not(:last-child) {\n    margin-right: 1.5rem\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__social__item:not(:last-child) {\n        margin-right: 1rem\n    }\n}\n\n.main-footer__social__icon {\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n@media screen and (min-width:768px) {\n    .main-footer__social__icon {\n        height: 1.25rem;\n        width: 1.25rem\n    }\n}\n\n.main-footer__logo__link,\n.main-footer__social__link {\n    color: #000;\n    opacity: .48;\n    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n\n    .main-footer__logo__link,\n    .main-footer__social__link {\n        transition-duration: 1ms\n    }\n}\n\n.main-footer__logo__link:hover,\n.main-footer__social__link:hover {\n    opacity: .8\n}\n\n.main-footer--inverted .main-footer__logo__link,\n.main-footer--inverted .main-footer__social__link {\n    color: #fff !important;\n    opacity: .64\n}\n\n.main-footer--inverted .main-footer__logo__link:hover,\n.main-footer--inverted .main-footer__social__link:hover {\n    opacity: .8\n}\n\n.main-footer__logo,\n.main-footer__notice,\n.main-footer__social {\n    flex: 1\n}\n\n@media screen and (max-width:1023px) {\n    .main-footer__nav__items .pill {\n        display: none\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .main-footer__nav__item__badge:after {\n        background-color: #ebebeb;\n        border-radius: 9999px;\n        color: #000000a3;\n        content: attr(data-badge-label);\n        display: inline-block;\n        font-size: .6875rem;\n        font-weight: 500;\n        line-height: .75rem;\n        margin-left: .25rem;\n        min-width: 1.25rem;\n        padding: .1875rem .375rem;\n        text-align: center;\n        text-transform: uppercase;\n        transform: translateY(-4%);\n        -webkit-user-select: none;\n        user-select: none;\n        vertical-align: middle\n    }\n}\n\n@media screen and (min-width:1024px) and (min-width:1024px) {\n    .main-footer__nav__item__badge:after {\n        margin-left: .25rem\n    }\n}\n\n.overlay {\n    background-color: #ffffffeb;\n    bottom: 0;\n    height: 100%;\n    height: 100vh;\n    left: 0;\n    opacity: 0;\n    overflow-y: scroll;\n    padding: 0;\n    pointer-events: none;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity .25s ease-out, visibility 0s linear .25s;\n    visibility: hidden;\n    width: 100%;\n    will-change: opacity;\n    z-index: 100\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .overlay {\n        transition-duration: 1ms\n    }\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .overlay {\n        -webkit-backdrop-filter: blur(24px);\n        backdrop-filter: blur(24px);\n        background-color: #ffffffa3\n    }\n}\n\n.overlay--transparent {\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    background-color: initial\n}\n\n.overlay--dark {\n    background-color: #000000a3\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .overlay--dark {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        background-color: #00000052\n    }\n}\n\n.overlay--navigation {\n    background-color: #0003;\n    z-index: 9999\n}\n\n@media (prefers-color-scheme:dark) {\n    .overlay--navigation {\n        background-color: #000000a3\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .overlay--navigation.is-active {\n        background-color: #0003\n    }\n}\n\n.overlay--cover-all {\n    z-index: 100000\n}\n\n.overlay.is-active {\n    opacity: 1;\n    pointer-events: all;\n    transition: opacity .25s ease-out, visibility 0s linear;\n    visibility: visible\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .overlay.is-active {\n        transition-duration: 1ms\n    }\n}\n\n.overlay__wrapper {\n    align-items: center;\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: center;\n    min-height: 100%;\n    padding: 1rem\n}\n\n.overlay__sticky-navigation {\n    left: 0;\n    position: sticky;\n    top: 0;\n    width: 100%;\n    z-index: 100\n}\n\n.overlay__hide {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 1.5rem;\n    border: 0;\n    border-radius: 0;\n    height: 2.5rem;\n    line-height: normal;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    right: 1.5rem;\n    top: 1.5rem;\n    width: 2.5rem\n}\n\n.overlay--prism .overlay__hide {\n    background-color: #000;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' color='%23FFF'%3E%3Cg stroke='currentColor'%3E%3Cpath d='m6 6 12 12M18 6 6 18'/%3E%3C/g%3E%3C/svg%3E\");\n    border-radius: 9999px\n}\n\n.overlay--prism .overlay__hide:focus,\n.overlay--prism .overlay__hide:hover {\n    background-color: #000000d9\n}\n\n.activatable.is-active .activatable\\@active__hidden,\n.activatable.is-inactive .activatable\\@inactive__hidden,\n.activatable:not(.is-active):not(.is-inactive) .activatable\\@failed__hidden {\n    display: none\n}\n\n.back-nav--floating {\n    position: absolute;\n    width: 100%;\n    z-index: 10\n}\n\n.back-nav__content {\n    align-items: stretch;\n    display: flex;\n    height: 4rem\n}\n\n.back-nav__link {\n    align-items: center;\n    color: #0000007a;\n    display: flex;\n    font-size: 1.0625rem;\n    font-weight: 300;\n    font-weight: 600;\n    line-height: 1.5rem;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .back-nav__link {\n        transition-duration: 1ms\n    }\n}\n\n.back-nav__link:active,\n.back-nav__link:hover {\n    color: #000000d9\n}\n\n.back-nav__link:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' color='rgba(0, 0, 0, 0.48)'%3E%3Cg stroke='currentColor' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m9 8-4 4 4 4M6.5 12h9'/%3E%3C/g%3E%3C/svg%3E\");\n    content: \"\";\n    display: inline-block;\n    flex: 0 0 auto;\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n.banner {\n    bottom: 0;\n    max-width: 40.875rem;\n    padding: 1rem;\n    position: fixed;\n    right: 0;\n    transition: opacity .25s ease-out, transform .8s cubic-bezier(.19, 1, .22, 1), visibility 0s linear;\n    -webkit-user-select: none;\n    user-select: none;\n    z-index: 1000\n}\n\n@media screen and (min-width:640px) {\n    .banner {\n        padding: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .banner {\n        padding: 2rem\n    }\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .banner {\n        transition-duration: 1ms\n    }\n}\n\n.banner.js-visibility-hidden {\n    opacity: 0;\n    transform: translateY(2rem);\n    transition: opacity 125ms ease-out, transform 125ms cubic-bezier(.19, 1, .22, 1), visibility 0s linear 125ms;\n    visibility: hidden\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .banner.js-visibility-hidden {\n        transition-duration: 1ms\n    }\n}\n\n.banner__wrapper {\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #0000001a;\n    border-radius: 12px;\n    box-shadow: 0 8px 16px 0 #0000001a;\n    min-height: 7.5rem;\n    overflow: hidden;\n    padding: 1rem;\n    position: relative\n}\n\n@media screen and (max-width:639px) {\n    .banner__wrapper>:not(:last-child) {\n        margin-bottom: 1rem\n    }\n}\n\n@media screen and (min-width:640px) {\n    .banner__wrapper {\n        grid-gap: 1rem;\n        align-items: center;\n        display: grid;\n        grid-template-columns: 4rem auto 7.5rem;\n        padding-left: 1.5rem\n    }\n}\n\n.banner__badge {\n    background: #fff;\n    border: 3px solid #ff1e00;\n    border-radius: 9999px;\n    display: inline-block;\n    padding: .1875rem;\n    position: relative\n}\n\n.banner__badge:after {\n    background-color: #ffb387;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23212123'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2.025 9.429 6.32 3.674a.129.129 0 0 1 .088-.05L11.986 3a.129.129 0 0 1 .028 0l5.577.622a.129.129 0 0 1 .088.051l4.296 5.755a.129.129 0 0 1-.006.161l-9.872 11.365a.129.129 0 0 1-.194 0L2.03 9.59a.129.129 0 0 1-.006-.161Zm11.108-5.193 3.943 3.78a.129.129 0 0 0 .217-.092V4.826a.088.088 0 0 1 .174-.023l.984 3.644a.129.129 0 0 0 .088.09l2.289.677a.088.088 0 0 1-.025.173h-2.188a.257.257 0 0 0-.22.124l-5.542 9.2a.088.088 0 0 1-.156-.083l4.132-8.875a.257.257 0 0 0-.233-.366H7.402a.257.257 0 0 0-.233.366l4.132 8.875a.088.088 0 0 1-.156.083l-5.542-9.2a.257.257 0 0 0-.22-.124H3.195a.088.088 0 0 1-.025-.173l2.29-.678a.129.129 0 0 0 .087-.09l.984-3.643a.088.088 0 0 1 .174.023v3.098a.129.129 0 0 0 .217.093l3.944-3.78a.088.088 0 0 1 .13.118L8.05 8.016a.129.129 0 0 0 .1.21h7.698a.129.129 0 0 0 .1-.21l-2.944-3.66a.088.088 0 0 1 .13-.12Z'/%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: .75rem;\n    border: 2.5px solid #fff;\n    border-radius: .625rem;\n    content: \"\";\n    display: block;\n    height: 1.5rem;\n    position: absolute;\n    right: -.375rem;\n    top: -.375rem;\n    width: 1.5rem\n}\n\n@media screen and (max-width:639px) {\n    .banner__badge {\n        display: none\n    }\n}\n\n.banner__avatar {\n    border-radius: 9999px;\n    display: block;\n    height: auto;\n    width: 100%\n}\n\n@media screen and (max-width:639px) {\n    .banner__actions {\n        grid-gap: .5rem;\n        display: grid;\n        grid-template-columns: 1fr 1fr\n    }\n}\n\n@media screen and (min-width:640px) {\n    .banner__actions {\n        margin-left: .5rem\n    }\n\n    .banner__actions>:not(:last-child) {\n        margin-bottom: .5rem\n    }\n}\n\n.banner__title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.5rem\n}\n\n.banner__blurb {\n    color: #212123b3;\n    font-size: .875rem;\n    font-weight: 300;\n    line-height: 1.3125rem;\n    margin-top: .25rem\n}\n\n.banner__blurb strong {\n    font-weight: 600\n}\n\n.dialog--full,\n.dialog--media {\n    width: 100%\n}\n\n.dialog__video {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 100%\n}\n\n.entrance {\n    --entrance-animation-delay: 0ms\n}\n\n.entrance--drop.was-shown:not([data-entrance-split-value]),\n.entrance--drop.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--drop.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--drop:not([data-entrance-split-value]),\n.no-js .entrance--drop[data-entrance-split-value~=lines] .word,\n.no-js .entrance--drop[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: dropIn\n}\n\n.entrance--fade.was-shown:not([data-entrance-split-value]),\n.entrance--fade.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--fade.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--fade:not([data-entrance-split-value]),\n.no-js .entrance--fade[data-entrance-split-value~=lines] .word,\n.no-js .entrance--fade[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: fadeIn\n}\n\n.entrance--fadeDown.was-shown:not([data-entrance-split-value]),\n.entrance--fadeDown.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--fadeDown.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--fadeDown:not([data-entrance-split-value]),\n.no-js .entrance--fadeDown[data-entrance-split-value~=lines] .word,\n.no-js .entrance--fadeDown[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: fadeInDown\n}\n\n.entrance--fadeUp.was-shown:not([data-entrance-split-value]),\n.entrance--fadeUp.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--fadeUp.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--fadeUp:not([data-entrance-split-value]),\n.no-js .entrance--fadeUp[data-entrance-split-value~=lines] .word,\n.no-js .entrance--fadeUp[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: fadeInUp\n}\n\n.entrance--lay.was-shown:not([data-entrance-split-value]),\n.entrance--lay.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--lay.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--lay:not([data-entrance-split-value]),\n.no-js .entrance--lay[data-entrance-split-value~=lines] .word,\n.no-js .entrance--lay[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: layIn\n}\n\n.entrance--scaleDown.was-shown:not([data-entrance-split-value]),\n.entrance--scaleDown.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--scaleDown.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--scaleDown:not([data-entrance-split-value]),\n.no-js .entrance--scaleDown[data-entrance-split-value~=lines] .word,\n.no-js .entrance--scaleDown[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: scaleInDown\n}\n\n.entrance--zoom.was-shown:not([data-entrance-split-value]),\n.entrance--zoom.was-shown[data-entrance-split-value~=lines] .word,\n.entrance--zoom.was-shown[data-entrance-split-value~=words] .word,\n.no-js .entrance--zoom:not([data-entrance-split-value]),\n.no-js .entrance--zoom[data-entrance-split-value~=lines] .word,\n.no-js .entrance--zoom[data-entrance-split-value~=words] .word {\n    animation-fill-mode: both;\n    animation-name: zoomIn\n}\n\n.entrance:not([data-entrance-split-value]) {\n    animation-delay: var(--entrance-animation-delay);\n    animation-duration: .8s;\n    animation-fill-mode: both;\n    animation-timing-function: cubic-bezier(.19, 1, .22, 1)\n}\n\n.entrance[data-entrance-split-value~=words] .word {\n    animation-delay: calc(var(--entrance-animation-delay) + var(--word-index)*.1s);\n    animation-duration: .8s;\n    animation-timing-function: cubic-bezier(.19, 1, .22, 1);\n    display: inline-block\n}\n\n.entrance[data-entrance-split-value~=lines] .word {\n    animation-delay: calc(var(--entrance-animation-delay) + var(--line-index)*.2s);\n    animation-duration: .8s;\n    animation-timing-function: cubic-bezier(.19, 1, .22, 1);\n    display: inline-block\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n\n    .entrance:not([data-entrance-split-value]),\n    .entrance[data-entrance-split-value~=lines] .word,\n    .entrance[data-entrance-split-value~=words] .word {\n        animation-delay: 0ms;\n        animation-duration: 1ms\n    }\n}\n\n.grid-layout {\n    bottom: 0;\n    left: 0;\n    margin: 0 auto;\n    opacity: 0;\n    pointer-events: none;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity .6s cubic-bezier(.19, 1, .22, 1);\n    -webkit-user-select: none;\n    user-select: none;\n    z-index: 100000\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .grid-layout {\n        transition-duration: 1ms\n    }\n}\n\nbody.is-loading .grid-layout {\n    transition-duration: 0s\n}\n\n.grid-layout.is-visible {\n    opacity: 1\n}\n\n.grid-layout__pad {\n    height: 100%;\n    position: relative\n}\n\n.grid-layout__wrapper {\n    column-gap: 1.5rem;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    height: 100%\n}\n\n@media screen and (min-width:640px) {\n    .grid-layout__wrapper {\n        grid-template-columns: repeat(6, 1fr)\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .grid-layout__wrapper {\n        grid-template-columns: repeat(12, 1fr)\n    }\n}\n\n.grid-layout__col {\n    background-color: #ff784333\n}\n\n.grid-layout__guides {\n    height: 100%;\n    position: relative;\n    transform: translateY(-100%)\n}\n\n.grid-layout__guide {\n    background-color: red;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    width: 1px\n}\n\n.grid-layout__guide:nth-child(2) {\n    left: 1.25rem\n}\n\n@media screen and (min-width:768px) {\n    .grid-layout__guide:nth-child(2) {\n        left: 2rem\n    }\n}\n\n.grid-layout__guide:nth-child(3) {\n    left: calc(50% - 2rem)\n}\n\n@media screen and (min-width:768px) {\n    .grid-layout__guide:nth-child(3) {\n        left: calc(50% - 2.75rem)\n    }\n}\n\n.grid-layout__guide:nth-child(4) {\n    left: calc(50% - .75rem)\n}\n\n.grid-layout__guide:nth-child(5) {\n    left: 50%\n}\n\n.grid-layout__guide:nth-child(6) {\n    left: calc(50% + .75rem)\n}\n\n.grid-layout__guide:nth-child(7) {\n    left: calc(50% + 2rem)\n}\n\n@media screen and (min-width:768px) {\n    .grid-layout__guide:nth-child(7) {\n        left: calc(50% + 2.75rem)\n    }\n}\n\n.grid-layout__guide:nth-child(8) {\n    right: 1.25rem\n}\n\n@media screen and (min-width:768px) {\n    .grid-layout__guide:nth-child(8) {\n        right: 2rem\n    }\n}\n\n.grid-layout__guide:nth-child(9) {\n    right: 0\n}\n\n.grid-layout__res {\n    background-color: #000000d9;\n    border-radius: 9999px;\n    bottom: 1rem;\n    color: #fff;\n    font-size: .75rem;\n    font-weight: 600;\n    left: 50%;\n    padding: .375rem .75rem;\n    position: fixed;\n    transform: translateX(-50%);\n    z-index: 100000\n}\n\n.home-nav {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    position: relative;\n    z-index: 1000\n}\n\n@media screen and (min-width:640px) {\n    .home-nav {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .home-nav {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n.home-nav__inner {\n    align-items: center;\n    display: flex;\n    height: 4rem;\n    justify-content: space-between\n}\n\n.home-nav__link {\n    color: #000;\n    font-weight: 600;\n    transition: color 125ms ease-out\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .home-nav__link {\n        transition-duration: 1ms\n    }\n}\n\n.home-nav__link:hover {\n    color: #000000d9\n}\n\n.home-nav__link__icon {\n    color: #0000004d;\n    display: inline-block;\n    transition: color 125ms ease-out;\n    vertical-align: middle\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .home-nav__link__icon {\n        transition-duration: 1ms\n    }\n}\n\n.home-nav__link:hover .home-nav__link__icon {\n    color: #000000d9\n}\n\n.icon-text-card {\n    background-color: #0000000a;\n    border-radius: 8px;\n    padding: 1.25rem 1.25rem 2rem;\n    text-align: left\n}\n\n.icon-text-card__icon {\n    margin-bottom: .5rem\n}\n\n.icon-text-card__text {\n    font-size: 1rem;\n    font-weight: 300;\n    font-weight: 400;\n    line-height: 1.5rem\n}\n\n.icon-text-card__text a {\n    color: #212123;\n    font-weight: 500;\n    text-decoration-color: #0003;\n    text-decoration-line: underline;\n    text-decoration-thickness: 1.5px;\n    text-underline-offset: 4px;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .icon-text-card__text a {\n        transition-duration: 1ms\n    }\n}\n\n.icon-text-card__text a:active,\n.icon-text-card__text a:hover {\n    color: #0000007a\n}\n\n.icon-text-card__text strong {\n    font-weight: 600\n}\n\n.icon-text-card__title {\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin-bottom: .5rem\n}\n\n@media screen and (min-width:768px) {\n    .icon-text-card__title {\n        font-size: 1.25rem\n    }\n}\n\n.icon-text-card--white-bg {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005\n}\n\nimg[data-controller~=lazyload] {\n    opacity: 0;\n    transition: opacity .25s ease-out\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    img[data-controller~=lazyload] {\n        transition-duration: 1ms\n    }\n}\n\nimg[data-controller~=lazyload].is-failed-loading,\nimg[data-controller~=lazyload].is-loaded {\n    opacity: 1\n}\n\n.video-player {\n    aspect-ratio: 16/9;\n    border-radius: 12px;\n    box-shadow: 0 0 4px #00000014, 0 4px 8px #00000005, 0 1px 2px #00000014;\n    overflow: hidden;\n    position: relative;\n    z-index: 1\n}\n\n.btc-blog-post .video-player {\n    border: 2px solid #fff;\n    border-radius: 0\n}\n\n.video-player[aspect-ratio=auto] {\n    aspect-ratio: auto\n}\n\n[slot=end-screen] {\n    height: 100%;\n    width: 100%\n}\n\n[slot=end-screen] .end-screen {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center\n}\n\n[slot=end-screen] .end-screen__button {\n    align-items: center;\n    background-color: #0000007a;\n    border-radius: 8px;\n    color: #fff;\n    display: flex;\n    height: 3rem;\n    justify-content: center;\n    transition: background-color .4s cubic-bezier(.645, .045, .355, 1);\n    width: 3rem\n}\n\n[slot=end-screen] .end-screen__button:hover {\n    background-color: #000c\n}\n\n[slot=end-screen] .end-screen__icon {\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n.page-nav-prism__nav {\n    background-color: #fff;\n    box-shadow: 0 0 1px 1px #0000001a;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: -4rem;\n    transition: top .4s cubic-bezier(.19, 1, .22, 1);\n    z-index: 10\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .page-nav-prism__nav {\n        transition-duration: 1ms\n    }\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .page-nav-prism__nav {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        background-color: #ffffffd9\n    }\n}\n\n.page-nav-prism__nav.is-visible {\n    top: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    .page-nav-prism__nav.is-visible {\n        top: 0\n    }\n}\n\n.page-nav-prism__items {\n    -webkit-overflow-scrolling: touch;\n    display: flex;\n    flex-flow: row nowrap;\n    -webkit-mask-image: linear-gradient(90deg, #0000 0, #000 4%, #000 96%, #0000);\n    mask-image: linear-gradient(90deg, #0000 0, #000 4%, #000 96%, #0000);\n    min-height: 4rem;\n    overflow: auto;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    position: relative;\n    -webkit-scrollbar-width: none;\n    scrollbar-width: none;\n    width: 100%\n}\n\n.page-nav-prism__items>:not(:last-child) {\n    margin-right: 2rem\n}\n\n@media screen and (min-width:640px) {\n    .page-nav-prism__items {\n        padding-left: 3rem;\n        padding-right: 3rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .page-nav-prism__items {\n        padding-left: 4rem;\n        padding-right: 4rem\n    }\n}\n\n.page-nav-prism__items::-webkit-scrollbar {\n    display: none\n}\n\n@media screen and (max-width:767px) {\n    .page-nav-prism__items {\n        padding-left: 1rem;\n        padding-right: 1rem\n    }\n}\n\n@media screen and (max-width:767px) and (min-width:640px) {\n    .page-nav-prism__items {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n}\n\n@media screen and (max-width:767px) and (min-width:1220px) {\n    .page-nav-prism__items {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .page-nav-prism__items {\n        padding-left: 1rem;\n        padding-right: 1rem\n    }\n}\n\n@media screen and (min-width:1220px) and (min-width:640px) {\n    .page-nav-prism__items {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) and (min-width:1220px) {\n    .page-nav-prism__items {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n.page-nav-prism__item {\n    display: flex;\n    flex-wrap: nowrap\n}\n\n.page-nav-prism__item:last-child:after {\n    content: \"\";\n    display: block;\n    margin-right: 1rem\n}\n\n@media screen and (min-width:640px) {\n    .page-nav-prism__item:last-child:after {\n        margin-right: 1.5rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .page-nav-prism__item:last-child:after {\n        margin-right: 2rem\n    }\n}\n\n.page-nav-prism__link {\n    align-items: center;\n    color: #212123;\n    display: flex;\n    font-weight: 600;\n    font-weight: 500;\n    text-decoration: none;\n    transition: color 125ms ease-out;\n    white-space: nowrap\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .page-nav-prism__link {\n        transition-duration: 1ms\n    }\n}\n\n.page-nav-prism__link:active,\n.page-nav-prism__link:hover {\n    color: #0000007a\n}\n\n[data-controller=parallax] {\n    --parallax-x: 0;\n    --parallax-y: 0;\n    transform: translate(var(--parallax-x), var(--parallax-y));\n    will-change: transform\n}\n\n.release--no-sticky-bars .release__infos {\n    top: 4rem\n}\n\n.release--hidden-cta .release__date {\n    margin-bottom: 0\n}\n\n.release--hidden-cta .release__card .button,\n.release--hidden-requirements .release__requirements {\n    display: none\n}\n\n@media screen and (min-width:1024px) {\n    .release__wrapper {\n        align-items: flex-start;\n        column-gap: 1.5rem;\n        display: grid;\n        grid-template-columns: repeat(12, 1fr)\n    }\n}\n\n.release__infos {\n    margin-bottom: 4rem\n}\n\n@media screen and (min-width:768px) {\n    .release__infos {\n        margin: 0 auto 4rem;\n        max-width: 21.5rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .release__infos {\n        grid-column: 1/span 5;\n        margin: 0;\n        max-width: none;\n        padding-left: 2rem;\n        padding-right: 2rem;\n        position: sticky;\n        top: 8rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .release__infos {\n        grid-column: 1/span 4;\n        padding-left: 0;\n        padding-right: 2.6875rem\n    }\n}\n\n.release__card {\n    background-color: #fff;\n    border: 1px solid #00000014;\n    border-radius: 12px;\n    box-shadow: 0 4px 8px #00000014;\n    margin-bottom: 1rem;\n    padding: 1.25rem\n}\n\n@media screen and (min-width:1024px) {\n    .release__card {\n        padding: 1.5rem\n    }\n}\n\n.release__version-wrapper {\n    align-items: center;\n    border-bottom: 1px solid #00000014;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: .75rem;\n    padding-bottom: .9375rem\n}\n\n.release__version-link {\n    align-items: baseline;\n    color: #212123;\n    display: flex;\n    font-size: 2rem;\n    font-weight: 900;\n    letter-spacing: -.5px;\n    line-height: 2.125rem\n}\n\n.release__version-link:hover {\n    color: #0000007a\n}\n\n.release__version-link:hover:after {\n    content: \"#\";\n    font-weight: 500;\n    margin-left: .375rem\n}\n\n.release__badge {\n    transform: translateY(-.125rem)\n}\n\n.release__date {\n    color: #212123;\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5;\n    margin-bottom: 1.25rem\n}\n\n@media screen and (min-width:1220px) {\n    .release__date {\n        margin-bottom: 1.5625rem\n    }\n}\n\n.release__time {\n    font-weight: 600\n}\n\n.release__requirements {\n    color: #0000007a;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    text-align: center\n}\n\n@media screen and (min-width:768px) {\n    .release__content {\n        margin: 0 auto;\n        max-width: 43.1875rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .release__content {\n        grid-column: 6/span 7;\n        margin: 0;\n        max-width: none\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .release__content {\n        grid-column: 5/span 8\n    }\n}\n\n@media screen and (max-width:767px) {\n    .release__warning {\n        margin-top: -2rem\n    }\n}\n\n.release__section.styled-text {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem\n}\n\n@media screen and (max-width:639px) {\n    .release__section.styled-text {\n        padding-left: 1.25rem;\n        padding-right: 1.25rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .release__section.styled-text {\n        padding-left: 1.1875rem;\n        padding-right: 1.1875rem\n    }\n}\n\n.release__section.styled-text:not(:last-child) {\n    margin-bottom: 4rem\n}\n\n.release__section.styled-text:not(:first-of-type) h4 {\n    margin-bottom: 1rem\n}\n\n.release__section.styled-text h4 {\n    color: #212123;\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: -.5px;\n    line-height: 2rem;\n    margin-bottom: 2rem;\n    margin-top: 0\n}\n\n.release__section.styled-text h4:not(:first-of-type) {\n    margin-top: 4rem\n}\n\n.release__section.styled-text ol,\n.release__section.styled-text ul {\n    padding-left: 0\n}\n\n.release__section.styled-text li {\n    list-style-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='12' width='12' xmlns='http://www.w3.org/2000/svg' color='%23ff7843'%3E%3Ccircle cx='6' cy='6' fill='none' r='2.5' stroke='currentColor'/%3E%3C/svg%3E\");\n    padding-left: .1875rem;\n    transform: translateX(-.1875rem)\n}\n\n.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets),\n.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets),\n.release__section:first-of-type ol:not(.custom-bullets),\n.release__section:first-of-type ul:not(.custom-bullets) {\n    list-style: none\n}\n\n.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets) li,\n.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets) li,\n.release__section:first-of-type ol:not(.custom-bullets) li,\n.release__section:first-of-type ul:not(.custom-bullets) li {\n    list-style-image: none\n}\n\n.release__section--whats-new:is(.release__section--whats-new) ol:not(.custom-bullets) li:not(:last-child),\n.release__section--whats-new:is(.release__section--whats-new) ul:not(.custom-bullets) li:not(:last-child),\n.release__section:first-of-type ol:not(.custom-bullets) li:not(:last-child),\n.release__section:first-of-type ul:not(.custom-bullets) li:not(:last-child) {\n    margin-bottom: 2rem\n}\n\n.update-highlight {\n    align-items: center;\n    color: #212123;\n    display: flex;\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.5rem;\n    margin-bottom: .5rem;\n    transform: translateX(-1.875rem)\n}\n\n@media screen and (min-width:1024px) {\n    .update-highlight {\n        transform: translateX(-2rem)\n    }\n}\n\n.update-highlight:before {\n    content: \"\";\n    display: block;\n    flex-shrink: 0;\n    height: 1.5rem;\n    margin-right: .375rem;\n    transform: translateY(-.0625rem);\n    width: 1.5rem\n}\n\n@media screen and (min-width:1024px) {\n    .update-highlight:before {\n        margin-right: .5rem\n    }\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: -100vw 0\n    }\n\n    to {\n        background-position: 100vw 0\n    }\n}\n\n.ribbon {\n    bottom: 0;\n    color: #000;\n    position: fixed;\n    width: 100%;\n    z-index: 101\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon {\n        bottom: auto;\n        height: 2.5625rem;\n        position: relative\n    }\n}\n\n.ribbon--alt {\n    bottom: 0;\n    position: fixed\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon--alt {\n        bottom: auto;\n        top: 0;\n        transform: translateY(-2.5625rem);\n        transition: transform .25s ease\n    }\n\n    .ribbon--alt.is-visible {\n        transform: translateY(0)\n    }\n}\n\n.ribbon--alt~.ribbon {\n    display: none\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon--alt~.ribbon {\n        display: block\n    }\n}\n\n.ribbon:hover .ribbon__message {\n    text-decoration: none\n}\n\n.ribbon__wrapper {\n    animation: shimmer 4s infinite;\n    background-clip: padding-box;\n    background-color: #fff;\n    background-image: linear-gradient(270deg, #fff0 0, #fffc 25%, #fff 75%, #fff0);\n    background-repeat: no-repeat;\n    padding: .5rem .5rem .5rem 1rem\n}\n\n.page--inverted .ribbon__wrapper {\n    background-color: #000;\n    background-image: linear-gradient(270deg, #0000 0, #000c 25%, #000 75%, #0000)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .ribbon__wrapper {\n        animation: none\n    }\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .ribbon__wrapper {\n        -webkit-backdrop-filter: blur(40px);\n        backdrop-filter: blur(40px);\n        background-color: #fffc\n    }\n\n    .page--inverted .ribbon__wrapper {\n        background-color: #000c\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .ribbon__wrapper {\n        border-top: 1px solid #0000001a;\n        padding-bottom: calc(env(safe-area-inset-bottom) + .5rem)\n    }\n\n    .page--inverted .ribbon__wrapper {\n        border-top-color: #ffffff14\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon__wrapper {\n        border-bottom: 1px solid #0000001a\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .ribbon__wrapper {\n            background-color: #ffffff7a;\n            background-image: linear-gradient(270deg, #fff0 0, #ffffff7a 25%, #fffc 75%, #fff0)\n        }\n    }\n\n    .page--inverted .ribbon__wrapper {\n        border-bottom-color: #ffffff14\n    }\n\n    @supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n        .page--inverted .ribbon__wrapper {\n            background-color: #0000007a;\n            background-image: linear-gradient(270deg, #0000 0, #0000007a 25%, #000c 75%, #0000)\n        }\n    }\n}\n\n.ribbon__content {\n    align-items: center;\n    display: flex;\n    justify-content: center\n}\n\n.ribbon__message {\n    font-size: .875rem;\n    font-weight: 300;\n    font-weight: 500;\n    line-height: 1.3125rem\n}\n\n.page--inverted .ribbon__message {\n    color: #fff\n}\n\n.ribbon--truncated .ribbon__message {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.ribbon__arrow,\n.ribbon__icon {\n    content: \"\";\n    display: inline-block;\n    flex: none;\n    height: 1.5rem;\n    vertical-align: middle;\n    width: 1.5rem\n}\n\n.page--inverted .ribbon__arrow,\n.page--inverted .ribbon__icon {\n    color: #fff\n}\n\n.ribbon__icon {\n    margin-right: .375rem\n}\n\n@media screen and (max-width:389px) {\n    .ribbon__icon {\n        display: none\n    }\n}\n\n.ribbon__arrow {\n    margin-left: .25rem;\n    opacity: .32\n}\n\n.media-player {\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.media-player.media-player--has-lightbox.is-active {\n    z-index: 1000\n}\n\n.media-player.cursor-hidden {\n    cursor: none\n}\n\n.media-player__wrapper {\n    z-index: 9\n}\n\n.media-player--has-lightbox .media-player__wrapper {\n    position: relative\n}\n\n@media screen and (min-width:1024px) {\n    .media-player--has-lightbox .media-player__wrapper {\n        transition: transform .4s cubic-bezier(.19, 1, .22, 1)\n    }\n}\n\n@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {\n    .media-player--has-lightbox .media-player__wrapper {\n        transition: none\n    }\n}\n\n.media-player--has-lightbox.is-active .media-player__wrapper {\n    transform: translateX(-2rem);\n    width: 100vw;\n    z-index: 1000\n}\n\n@media screen and (min-width:768px) {\n    .media-player--has-lightbox.is-active .media-player__wrapper {\n        transform: translateX(-3rem)\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .media-player--has-lightbox.is-active .media-player__wrapper {\n        transform: translateX(var(--active-video-offset-x));\n        width: auto\n    }\n}\n\n.media-player__video-wrapper {\n    -webkit-tap-highlight-color: transparent;\n    background-color: initial;\n    border-radius: 12px;\n    box-shadow: 0 0 4px #00000014, 0 4px 8px #00000005, 0 1px 2px #00000014;\n    flex: 1;\n    overflow: hidden;\n    position: relative;\n    transform: translateZ(0);\n    width: 100%;\n    z-index: 1000\n}\n\n.media-player__video-wrapper:before {\n    background-image: linear-gradient(180deg, #0000, #0000003d 63%, #0000008f);\n    content: \"\";\n    height: 100%;\n    left: 0;\n    opacity: .65;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 1\n}\n\n.media-player:not(.is-stopped) .media-player__video-wrapper:before {\n    display: none\n}\n\n.media-player__video {\n    display: block;\n    height: auto;\n    position: relative;\n    width: 100%\n}\n\n.media-player__subtitles-wrapper {\n    bottom: 5rem;\n    opacity: 0;\n    padding: 0 2rem;\n    pointer-events: none;\n    position: absolute;\n    text-align: center;\n    transform: translateY(.5rem);\n    transition: opacity 125ms ease-out, transform .4s cubic-bezier(.19, 1, .22, 1);\n    -webkit-user-select: none;\n    user-select: none;\n    width: 100%;\n    z-index: 1000\n}\n\n@media screen and (min-width:768px) {\n    .media-player__subtitles-wrapper {\n        bottom: 3.5rem\n    }\n}\n\n.media-player.is-subtitles-on .media-player__subtitles-wrapper {\n    opacity: 1;\n    transform: translateY(0)\n}\n\n.media-player.controls-hidden .media-player__subtitles-wrapper {\n    transform: translateY(4rem)\n}\n\n@media screen and (min-width:768px) {\n    .media-player.controls-hidden .media-player__subtitles-wrapper {\n        transform: translateY(2rem)\n    }\n}\n\n.media-player.controls-hidden.is-subtitles-off .media-player__subtitles-wrapper {\n    transform: translateY(4.5rem)\n}\n\n@media screen and (min-width:768px) {\n    .media-player.controls-hidden.is-subtitles-off .media-player__subtitles-wrapper {\n        transform: translateY(2.5rem)\n    }\n}\n\n.media-player__subtitles {\n    text-wrap: balance;\n    background-color: #ffffffb3;\n    border-radius: 18px;\n    color: #000000d9;\n    display: inline-block;\n    font-size: .6875rem;\n    font-weight: 600;\n    line-height: .875rem;\n    opacity: 0;\n    padding: 8px 16px;\n    transition: opacity 125ms ease-out\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .media-player__subtitles {\n        -webkit-backdrop-filter: blur(20px);\n        backdrop-filter: blur(20px)\n    }\n}\n\n@media screen and (min-width:768px) {\n    .media-player__subtitles {\n        font-size: .9375rem;\n        line-height: 1.25rem\n    }\n}\n\n.media-player:not(.is-stopped) .media-player__subtitles.is-visible {\n    opacity: 1\n}\n\n.media-player__progress-bar {\n    cursor: pointer;\n    overflow: hidden;\n    padding-bottom: .5rem;\n    padding-top: .5rem;\n    position: relative;\n    width: 100%;\n    z-index: 1\n}\n\n.media-player:not(.is-stopped) .media-player__progress-bar {\n    pointer-events: all\n}\n\n.media-player__progress-bar:before {\n    background-color: #ffffff73;\n    border-radius: 12px;\n    content: \"\";\n    display: block;\n    height: .3125rem;\n    left: 0;\n    position: absolute;\n    top: .5rem;\n    width: 100%\n}\n\n@media (hover:hover) {\n    .media-player__progress-bar:hover .media-player__progress-bar-fill:after {\n        opacity: 1;\n        transform: scale(1)\n    }\n}\n\n.media-player__progress-bar-fill {\n    background-color: #fff;\n    border-radius: 12px;\n    height: .3125rem;\n    position: relative;\n    transition: width var(--progress-bar-transition-duration) ease-out;\n    width: 0\n}\n\n.media-player__progress-bar-fill:after {\n    background-color: #fff;\n    border-radius: 9999px;\n    content: \"\";\n    display: block;\n    height: .8125rem;\n    opacity: 0;\n    position: absolute;\n    right: -.25rem;\n    top: -.25rem;\n    transform: scale(.4);\n    transition: transform 60ms ease-out;\n    width: .8125rem\n}\n\n.media-player__time {\n    color: #fff;\n    font-size: .6875rem;\n    line-height: 1rem;\n    padding: .5rem 0\n}\n\n@media screen and (min-width:768px) {\n    .media-player__time {\n        font-size: .875rem\n    }\n}\n\n.media-player__replay {\n    align-items: center;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    background-color: #ffffff1a;\n    border: 0;\n    border-radius: 0;\n    border-radius: 8px;\n    color: #fff;\n    display: flex;\n    font-size: 1.0625rem;\n    font-weight: 300;\n    font-weight: 400;\n    left: calc(50% - 3.5625rem);\n    line-height: normal;\n    line-height: 1.5rem;\n    margin: 0;\n    opacity: 0;\n    padding: .75rem 1.25rem .75rem 1rem;\n    pointer-events: none;\n    position: absolute;\n    top: calc(50% - 1.5rem);\n    transition: opacity .4s cubic-bezier(.165, .84, .44, 1);\n    z-index: 1000\n}\n\n.media-player.has-ended .media-player__replay {\n    opacity: 1;\n    pointer-events: all\n}\n\n.media-player__replay:focus,\n.media-player__replay:hover {\n    background-color: #212123\n}\n\n.media-player__replay:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg' color='%23FFF'%3E%3Cg fill='none' fill-rule='evenodd' stroke='currentColor' stroke-linecap='round' stroke-width='1.5'%3E%3Cpath d='M2.5 8.169c0 1.208.22 2.127.634 2.901a4.316 4.316 0 0 0 1.796 1.796c.774.414 1.693.634 2.901.634h.338c1.208 0 2.127-.22 2.901-.634a4.316 4.316 0 0 0 1.796-1.796c.414-.774.634-1.693.634-2.901V7.83c0-1.208-.22-2.127-.634-2.901a4.316 4.316 0 0 0-1.796-1.796C10.296 2.72 9.377 2.5 8.169 2.5H7.83c-1.208 0-2.127.22-2.901.634A4.316 4.316 0 0 0 3.134 4.93'/%3E%3Cpath d='M6.5 5.25H3v-3.5' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 1rem;\n    content: \"\";\n    display: block;\n    height: 1rem;\n    margin-right: .5rem;\n    width: 1rem\n}\n\n.media-player__controls {\n    bottom: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    left: 0;\n    padding: 1.5rem 1rem 1rem;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    transition: opacity .25s ease-out;\n    -webkit-user-select: none;\n    user-select: none;\n    z-index: 1000\n}\n\n.media-player.controls-hidden .media-player__controls,\n.media-player.is-stopped .media-player__controls {\n    opacity: 0\n}\n\n.media-player__controls:before {\n    background-image: linear-gradient(0deg, #0000008f, #0000002b 53%, #0000);\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 150%;\n    left: 0;\n    position: absolute;\n    width: 100%\n}\n\n@media screen and (min-width:1024px) {\n    .media-player__controls:before {\n        height: 230%\n    }\n}\n\n.media-player__controls__group {\n    color: #fff;\n    display: flex;\n    position: relative;\n    z-index: 1\n}\n\n.media-player:not(.is-stopped) .media-player__controls__group {\n    pointer-events: all\n}\n\n.media-player__controls__group>:not(:first-child) {\n    margin-left: .25rem\n}\n\n.media-player__controls__group>:not(:last-child) {\n    margin-right: .25rem\n}\n\n.media-player__controls__group--expanded {\n    color: #fff;\n    display: flex;\n    position: relative;\n    z-index: 1\n}\n\n.media-player__controls__group--expanded>:not(:first-child) {\n    margin-left: .5rem\n}\n\n.media-player__controls__group--expanded>:not(:last-child) {\n    margin-right: .5rem\n}\n\n.media-player__control {\n    align-items: center;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    height: 2rem;\n    justify-content: center;\n    position: relative;\n    transition: background-color .4s cubic-bezier(.19, 1, .22, 1);\n    width: 2.5rem\n}\n\n.media-player.no-touch .media-player__control:hover {\n    background-color: #0000001a\n}\n\n.media-player.is-fullscreen .media-player__control--fullscreen,\n.media-player.is-muted .media-player__control--volume,\n.media-player.is-subtitles-on .media-player__control--subtitles,\n.media-player__control.is-active,\n.media-player__control:active {\n    background-color: #0000004d\n}\n\n.media-player.has-no-sound .media-player__control--volume {\n    display: none\n}\n\n.media-player__control:after {\n    background-color: initial;\n    border-radius: 8px;\n    color: #fff;\n    font-size: .625rem;\n    left: 50%;\n    line-height: 1rem;\n    opacity: 0;\n    padding: .5rem .75rem;\n    pointer-events: none;\n    position: absolute;\n    top: -2.5rem;\n    transform: translate(-50%, .25rem);\n    transition: opacity 125ms ease-out, transform .4s cubic-bezier(.19, 1, .22, 1);\n    transition-delay: 0, 0;\n    z-index: 1000\n}\n\n@media screen and (min-width:768px) {\n    .media-player__control:after {\n        font-size: .75rem\n    }\n}\n\n.media-player.no-touch .media-player__control:hover:after {\n    opacity: 1;\n    transform: translate(-50%);\n    transition-delay: .4s, .4s\n}\n\n.media-player__control--play-pause:after {\n    content: attr(data-label-pause);\n    left: 0;\n    transform: translateY(.25rem)\n}\n\n.media-player.is-paused .media-player__control--play-pause:after {\n    content: attr(data-label-play)\n}\n\n.media-player.no-touch .media-player__control--play-pause:hover:after {\n    transform: translate(0)\n}\n\n.media-player__control--subtitles:after {\n    content: attr(data-label-off);\n    white-space: nowrap\n}\n\n.media-player.is-subtitles-on .media-player__control--subtitles:after {\n    content: attr(data-label-on)\n}\n\n.media-player__control--fullscreen:after {\n    content: attr(data-label-on);\n    white-space: nowrap\n}\n\n.media-player.is-fullscreen .media-player__control--fullscreen:after {\n    content: attr(data-label-off)\n}\n\n.media-player__control--volume:after {\n    content: attr(data-label-on);\n    left: auto;\n    right: 0;\n    transform: translateY(.25rem);\n    white-space: nowrap\n}\n\n.media-player.is-muted .media-player__control--volume:after {\n    content: attr(data-label-off)\n}\n\n.media-player.no-touch .media-player__control--volume:hover:after {\n    transform: translate(0)\n}\n\n.media-player__play {\n    display: none\n}\n\n.media-player.is-paused .media-player__play,\n.media-player__pause {\n    display: block\n}\n\n.media-player.is-paused .media-player__pause {\n    display: none\n}\n\n.media-player__volume-on {\n    display: block\n}\n\n.media-player.is-muted .media-player__volume-on,\n.media-player__volume-off {\n    display: none\n}\n\n.media-player.is-muted .media-player__volume-off {\n    display: block\n}\n\n.media-player__large-play {\n    background-clip: padding-box;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z' fill-opacity='.15' fill-rule='evenodd' fill='currentColor' stroke='currentColor' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E\");\n    background-position: calc(50% + 1px) 50%;\n    background-repeat: no-repeat;\n    border: 1px solid #0000001a;\n    border-radius: 9999px;\n    box-shadow: 0 1px 2px #0000001a;\n    color: #fff;\n    cursor: pointer;\n    height: 2.75rem;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    transition: opacity 125ms ease-out;\n    -webkit-user-select: none;\n    user-select: none;\n    width: 2.75rem;\n    z-index: 1000\n}\n\n.media-player--has-lightbox .media-player__large-play {\n    display: none\n}\n\n@media screen and (min-width:768px) {\n    .media-player__large-play {\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='32' width='32' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='m10.223 24.208 13.638-7.327a1 1 0 0 0 0-1.762L10.223 7.792a1 1 0 0 0-1.473.88v14.655a1 1 0 0 0 1.473.881z' fill-opacity='.15' stroke='%23000' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E\");\n        height: 4.5rem;\n        width: 4.5rem\n    }\n}\n\n.media-player__large-play .media-player__large-play__icon {\n    display: none\n}\n\n.media-player__large-play__icon {\n    height: 3rem;\n    width: 3rem\n}\n\n@media screen and (min-width:768px) {\n    .media-player__large-play__icon {\n        height: 6rem;\n        width: 6rem\n    }\n}\n\n.media-player__large-play.is-hidden {\n    opacity: 0;\n    pointer-events: none\n}\n\n.media-player {\n    --active-video-offset-x: 0vw;\n    --progress-bar-transition-duration: 250ms\n}\n\n.media-player__lightbox {\n    background-color: #ffffff5c;\n    height: 100vh;\n    left: 0;\n    opacity: 0;\n    pointer-events: none;\n    position: fixed;\n    top: 0;\n    transition: opacity .4s cubic-bezier(.19, 1, .22, 1);\n    width: 100vw;\n    will-change: opacity;\n    z-index: 1000\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .media-player__lightbox {\n        transition: none\n    }\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .media-player__lightbox {\n        -webkit-backdrop-filter: blur(20px);\n        backdrop-filter: blur(20px)\n    }\n}\n\n@supports not ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .media-player__lightbox {\n        background-color: #fffc\n    }\n}\n\n.media-player--has-lightbox.is-active .media-player__lightbox {\n    opacity: 1;\n    pointer-events: all\n}\n\n.media-player__close {\n    align-items: center;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    background-color: #000;\n    border: 0;\n    border-radius: 0;\n    border-radius: 9999px;\n    box-shadow: 0 1px 2px #0000001a;\n    display: flex;\n    height: 2.5rem;\n    justify-content: center;\n    line-height: normal;\n    margin: 0;\n    opacity: 0;\n    padding: 0;\n    pointer-events: none;\n    position: fixed;\n    right: 1.5rem;\n    top: 1.5rem;\n    transition: opacity .25s cubic-bezier(.19, 1, .22, 1);\n    width: 2.5rem;\n    z-index: 1001\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .media-player__close {\n        transition: none\n    }\n}\n\n.media-player__close:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' color='%23FFF'%3E%3Cg stroke='currentColor'%3E%3Cpath d='m6 6 12 12M18 6 6 18'/%3E%3C/g%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 1.5rem;\n    content: \"\";\n    height: 1.5rem;\n    position: absolute;\n    width: 1.5rem\n}\n\n.media-player--has-lightbox.is-active .media-player__close {\n    opacity: 1;\n    pointer-events: all\n}\n\n.media-player--has-lightbox.is-active .media-player__close:focus,\n.media-player--has-lightbox.is-active .media-player__close:hover {\n    background-color: #000000d9\n}\n\n.media-player__custom-play {\n    align-items: center;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: initial;\n    border: 0;\n    border-radius: 0;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    line-height: normal;\n    margin: 0;\n    padding: 1rem;\n    position: absolute;\n    top: 0;\n    transition: opacity .4s cubic-bezier(.19, 1, .22, 1), transform .4s cubic-bezier(.19, 1, .22, 1);\n    width: 100%;\n    z-index: 1000\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .media-player__custom-play {\n        transition: none\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .media-player__custom-play {\n        align-items: flex-start;\n        height: 45rem;\n        justify-content: flex-start;\n        width: 80rem\n    }\n\n    .media-player__custom-play:active,\n    .media-player__custom-play:focus,\n    .media-player__custom-play:hover {\n        transform: translateX(-1rem);\n        transition: transform .4s cubic-bezier(.19, 1, .22, 1)\n    }\n}\n\n@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {\n\n    .media-player__custom-play:active,\n    .media-player__custom-play:focus,\n    .media-player__custom-play:hover {\n        transform: translateX(0)\n    }\n}\n\n@media screen and (min-width:1024px) {\n\n    .media-player__custom-play:active~.media-player__image-composition,\n    .media-player__custom-play:focus~.media-player__image-composition,\n    .media-player__custom-play:hover~.media-player__image-composition {\n        transform: translateX(-1rem);\n        transition: transform .4s cubic-bezier(.19, 1, .22, 1)\n    }\n}\n\n@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {\n\n    .media-player__custom-play:active~.media-player__image-composition,\n    .media-player__custom-play:focus~.media-player__image-composition,\n    .media-player__custom-play:hover~.media-player__image-composition {\n        transform: translateX(0)\n    }\n}\n\n.media-player__custom-play:focus .media-player__custom-play-label,\n.media-player__custom-play:hover .media-player__custom-play-label {\n    background-color: #000000d9\n}\n\n.media-player.is-active .media-player__custom-play {\n    opacity: 0;\n    pointer-events: none\n}\n\n@media screen and (min-width:1024px) {\n    .media-player--reverse .media-player__custom-play {\n        justify-content: flex-end;\n        left: auto;\n        right: 0\n    }\n\n    .media-player--reverse .media-player__custom-play:hover {\n        transform: translateX(1rem)\n    }\n}\n\n@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {\n    .media-player--reverse .media-player__custom-play:hover {\n        transform: translateX(0)\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .media-player--reverse .media-player__custom-play:hover~.media-player__image-composition {\n        transform: translateX(1rem)\n    }\n}\n\n@media screen and (min-width:1024px) and (prefers-reduced-motion:reduce) {\n    .media-player--reverse .media-player__custom-play:hover~.media-player__image-composition {\n        transform: translateX(0)\n    }\n}\n\n.media-player__custom-play-label {\n    align-items: center;\n    background-color: #000;\n    border-radius: 9999px;\n    color: #fff;\n    display: flex;\n    font-size: .875rem;\n    font-weight: 300;\n    font-weight: 600;\n    line-height: 1.3125rem;\n    padding: .5rem 1rem\n}\n\n@media screen and (max-width:1023px) {\n    .media-player__custom-play-label {\n        color: #0000;\n        height: 2.75rem;\n        padding: 0;\n        pointer-events: none;\n        position: relative;\n        text-indent: -100vw;\n        width: 2.75rem\n    }\n}\n\n.media-player__custom-play-label:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg' color='%23FFF'%3E%3Cpath d='m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z' fill-opacity='.15' fill-rule='evenodd' fill='currentColor' stroke='currentColor' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E\");\n    background-position: calc(50% + 1px) 50%;\n    background-repeat: no-repeat;\n    background-size: 1.5rem;\n    content: \"\";\n    height: 1.5rem;\n    margin-right: .5rem;\n    width: 1.5rem\n}\n\n@media screen and (max-width:1023px) {\n    .media-player__custom-play-label:before {\n        height: 100%;\n        margin-right: 0;\n        position: absolute;\n        width: 100%\n    }\n}\n\n.media-player__image-composition {\n    align-items: flex-start;\n    background-clip: padding-box;\n    background-color: #fffc;\n    border: 1px solid #0000001a;\n    border-radius: 8px;\n    box-shadow: 0 8px 16px #0000001a;\n    display: flex;\n    height: 100%;\n    pointer-events: none;\n    width: 100%\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .media-player__image-composition {\n        -webkit-backdrop-filter: blur(32px);\n        backdrop-filter: blur(32px);\n        background-color: #f9f9f95c\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .media-player__image-composition {\n        align-items: flex-end;\n        height: 45rem;\n        width: 80rem\n    }\n}\n\n.media-player--has-lightbox .media-player__image-composition {\n    position: absolute;\n    transition: opacity .4s cubic-bezier(.19, 1, .22, 1), transform .4s cubic-bezier(.19, 1, .22, 1);\n    z-index: 10\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .media-player--has-lightbox .media-player__image-composition {\n        transition: none\n    }\n}\n\n.media-player--has-lightbox.is-active .media-player__image-composition {\n    opacity: 0;\n    pointer-events: none;\n    -webkit-user-select: none;\n    user-select: none\n}\n\n.media-player--reverse .media-player__image-composition {\n    right: 0\n}\n\n.media-player__image-composition-mask {\n    align-items: flex-start;\n    border-radius: 8px;\n    display: flex;\n    height: 100%;\n    justify-content: space-between;\n    overflow: hidden;\n    width: 100%\n}\n\n@media screen and (min-width:1024px) {\n    .media-player__image-composition-mask {\n        align-items: flex-end\n    }\n}\n\n.media-player--has-lightbox:not(.is-active) .media-player__controls,\n.media-player--has-lightbox:not(.is-active) .media-player__progress-bar,\n.media-player--has-lightbox:not(.is-active) .media-player__video-wrapper {\n    opacity: 0;\n    pointer-events: none;\n    -webkit-user-select: none;\n    user-select: none\n}\n\n.media-player--has-lightbox .media-player__video-wrapper {\n    transition: opacity .4s cubic-bezier(.19, 1, .22, 1);\n    z-index: 1\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .media-player--has-lightbox .media-player__video-wrapper {\n        transition: none\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .media-player--has-lightbox .media-player__video-wrapper {\n        min-width: 85vw\n    }\n}\n\n@media screen and (min-width:1024px) and (min-aspect-ratio:16/9) {\n    .media-player--has-lightbox .media-player__video-wrapper {\n        height: 85vh;\n        min-width: auto;\n        width: 151vh\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .media-player--has-lightbox.is-active .media-player__video-wrapper {\n        border-radius: 0\n    }\n}\n\n.media-player.is-fullscreen .media-player__video {\n    height: 100vh;\n    width: 100vw\n}\n\n.ribbon-large {\n    background-color: #212123;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    z-index: 101\n}\n\n.ribbon-large ::selection {\n    background: #fff;\n    color: #212123\n}\n\n@media screen and (max-width:1023px) {\n    .ribbon-large .pad-viewport {\n        padding-left: 0;\n        padding-right: 0\n    }\n}\n\n@media screen and (min-width:1024px) and (max-width:1219px) {\n    .ribbon-large .pad-viewport {\n        padding-right: 0\n    }\n}\n\n.ribbon-large.hide {\n    height: 0;\n    pointer-events: none;\n    -webkit-user-select: none;\n    user-select: none\n}\n\n.ribbon-large~.main-nav:not(.is-active) {\n    box-shadow: 0 -1px 0 0 #00000014\n}\n\n.ribbon-large~.main-nav:not(.is-active):not(.is-sticky) {\n    -webkit-backdrop-filter: unset;\n    backdrop-filter: unset\n}\n\n@media screen and (prefers-color-scheme:dark) and (max-width:1023px) {\n    .ribbon-large~.main-nav:not(.is-active):not(.main-nav--blurred) {\n        box-shadow: 0 -1px 0 0 #fff3, 0 1px 0 0 #000\n    }\n}\n\n.ribbon-large__wrapper {\n    align-items: center;\n    display: flex;\n    gap: 3.625rem;\n    height: 5rem;\n    justify-content: space-between\n}\n\n.ribbon-large__message-container {\n    display: flex;\n    gap: .75rem;\n    justify-content: center;\n    min-width: 38.75rem\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon-large__message-container {\n        justify-content: flex-start\n    }\n}\n\n.ribbon-large__message {\n    color: #fafafa;\n    font-size: 1.0625rem;\n    font-weight: 300;\n    line-height: 1.5rem\n}\n\n.ribbon-large__message a,\n.ribbon-large__message span {\n    color: #212123;\n    color: #fff;\n    font-weight: 500;\n    text-decoration-color: #0003;\n    text-decoration-color: #fff3;\n    text-decoration-line: underline;\n    text-decoration-thickness: 1.5px;\n    text-underline-offset: 4px;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .ribbon-large__message a,\n    .ribbon-large__message span {\n        transition-duration: 1ms\n    }\n}\n\n.ribbon-large__message a:active,\n.ribbon-large__message a:hover,\n.ribbon-large__message span:active,\n.ribbon-large__message span:hover {\n    color: #0000007a;\n    color: #ffffff7a\n}\n\n@media screen and (min-width:1024px) {\n\n    .ribbon-large__message a,\n    .ribbon-large__message span {\n        margin-left: 1rem\n    }\n}\n\n.ribbon-large__message strong {\n    font-weight: 600\n}\n\n.ribbon-large__video-container {\n    height: 100%;\n    width: 100%\n}\n\n@media screen and (min-width:1220px) {\n    .ribbon-large__video-container {\n        max-width: 30.375rem\n    }\n}\n\n.ribbon-large__video-container .video {\n    display: flex;\n    height: 100%\n}\n\n.ribbon-large__video-container .video:hover .media-player__large-play {\n    transform: scale(1.1)\n}\n\n@media screen and (min-width:1024px) {\n    .ribbon-large__video-container .video:hover .media-player__large-play {\n        transform: translate(-50%, -50%) scale(1.1)\n    }\n}\n\n.ribbon-large__video-container .video:not(.mave-pop) .media-player__video-wrapper:before {\n    content: unset\n}\n\n.ribbon-large__video-container .video:not(.mave-pop) .media-player__large-play {\n    display: none\n}\n\n.ribbon-large__video-container .video:not(.mave-pop) .ribbon-large__message {\n    text-align: center\n}\n\n.ribbon-large__video-container .media-player__video-wrapper {\n    border-radius: 0;\n    display: flex\n}\n\n.ribbon-large__video-container .media-player__video-wrapper:before {\n    background-color: #0000007a;\n    background-image: none;\n    opacity: 1\n}\n\n@media screen and (max-width:1023px) {\n    .ribbon-large__video-container .media-player__video-wrapper:before {\n        background-color: unset\n    }\n}\n\n.ribbon-large__video-container .video__preview {\n    object-fit: cover;\n    width: 100%\n}\n\n.ribbon-large__video-overlay {\n    align-items: center;\n    display: flex;\n    gap: 1.5rem;\n    inset: 0 0 0 0;\n    justify-content: center;\n    padding: 1rem;\n    position: absolute\n}\n\n@media screen and (max-width:1023px) {\n    .ribbon-large__video-overlay {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        background-color: #000000a3\n    }\n}\n\n.ribbon-large__video-overlay .media-player__large-play {\n    background-color: #f26725;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg' color='%23FFF'%3E%3Cpath d='m8.231 18.187 9.672-5.31a1 1 0 0 0 0-1.754l-9.672-5.31a1 1 0 0 0-1.481.877v10.62a1 1 0 0 0 1.481.877z' fill-rule='evenodd' fill='currentColor' stroke='currentColor' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E\");\n    flex: 0 0 auto;\n    height: 2.75rem;\n    transition: transform .25s ease-in-out;\n    width: 2.75rem\n}\n\n@media screen and (max-width:1023px) {\n    .ribbon-large__video-overlay .media-player__large-play {\n        position: static;\n        transform: none\n    }\n}\n\n.secondary-nav {\n    background-color: #fff;\n    box-shadow: 0 0 0 1px #0000001a;\n    color: #212123;\n    overflow: visible;\n    position: sticky;\n    top: 0;\n    z-index: 100\n}\n\n@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))) {\n    .secondary-nav {\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        background-color: #fffc\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .secondary-nav {\n        top: 4rem\n    }\n}\n\n.secondary-nav.has-focused-search {\n    z-index: 999\n}\n\n.secondary-nav--static {\n    position: static\n}\n\n.secondary-nav--transparent {\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    background-color: initial;\n    box-shadow: none\n}\n\n.secondary-nav__content {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    min-height: 4rem;\n    padding: .375rem 0\n}\n\n.secondary-nav__nav-items {\n    display: flex;\n    line-height: 1.5rem;\n    list-style-type: none;\n    margin: 0 1.5rem 0 0;\n    overflow: auto;\n    padding: 0 2rem 0 0;\n    transition: width .25s cubic-bezier(.25, .46, .45, .94), opacity .25s cubic-bezier(.25, .46, .45, .94);\n    white-space: nowrap;\n    width: calc(100% - 2rem)\n}\n\n.secondary-nav__nav-items::-webkit-scrollbar {\n    display: none\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .secondary-nav__nav-items {\n        transition-duration: 1ms\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .secondary-nav__nav-items {\n        padding-right: 4rem\n    }\n}\n\n@-moz-document url-prefix() {\n    .secondary-nav__nav-items {\n        scrollbar-width: none\n    }\n}\n\n.secondary-nav.has-focused-search .secondary-nav__nav-items {\n    margin-right: 0;\n    opacity: 0;\n    padding-right: 0;\n    width: 0\n}\n\n.secondary-nav__nav-item {\n    color: #000;\n    display: inline-block;\n    font-weight: 500;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .secondary-nav__nav-item {\n        transition-duration: 1ms\n    }\n}\n\n.secondary-nav__nav-item:active,\n.secondary-nav__nav-item:hover {\n    color: #0000007a\n}\n\n.secondary-nav__nav-item+.secondary-nav__nav-item:before {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' stroke='rgba(33, 33, 35, 0.7)'%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.32' stroke-width='1.5' d='m6.5 12 4-4-4-4'/%3E%3C/svg%3E\");\n    content: \"\";\n    display: inline-block;\n    height: 1rem;\n    margin-left: .25rem;\n    margin-right: .25rem;\n    vertical-align: middle;\n    width: 1rem\n}\n\n.secondary-nav__nav-item__chevron-left {\n    display: inline-block;\n    vertical-align: center\n}\n\n.secondary-nav__nav-item__chevron-left [stroke] {\n    stroke: currentColor\n}\n\n.secondary-nav__search {\n    text-align: center;\n    transition: width .25s cubic-bezier(.19, 1, .22, 1);\n    width: 20rem\n}\n\n.secondary-nav.has-focused-search .secondary-nav__search {\n    width: 100%\n}\n\n@media screen and (max-width:639px) {\n    .secondary-nav__search {\n        width: 1.5rem\n    }\n}\n\n.secondary-nav__search .algolia-autocomplete {\n    max-width: 20rem;\n    transition: max-width .25s cubic-bezier(.19, 1, .22, 1);\n    width: 100%\n}\n\n.secondary-nav__search.is-above-overlay .algolia-autocomplete {\n    max-width: 36.75rem\n}\n\n.secondary-nav__search__input {\n    cursor: pointer;\n    line-height: 1rem;\n    width: 100%\n}\n\n.secondary-nav__search__input:enabled {\n    background-color: #fff\n}\n\n.secondary-nav:not(.has-focused-search) .secondary-nav__search__input {\n    font-size: 1rem;\n    min-height: 2.25rem;\n    padding-bottom: .25rem;\n    padding-top: .25rem\n}\n\n@media screen and (max-width:639px) {\n    .secondary-nav:not(.has-focused-search) .secondary-nav__search__input:enabled {\n        background-color: initial;\n        background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cg fill='none' fill-rule='evenodd' stroke-width='1.5' stroke='currentcolor'%3E%3Ccircle cx='11' cy='11' r='5.25'/%3E%3Cpath d='M18.25 18.25 15 15' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E\");\n        background-position-x: 0;\n        background-size: contain;\n        border: 0;\n        box-shadow: none;\n        padding-left: 0\n    }\n\n    .secondary-nav:not(.has-focused-search) .secondary-nav__search__input:enabled::placeholder {\n        opacity: 0\n    }\n}\n\n.snackbar {\n    align-items: center;\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #ffffff1a;\n    border-radius: 12px;\n    bottom: 1.5rem;\n    box-shadow: 0 4px 8px 0 #0000001a;\n    color: #212123;\n    display: flex;\n    font-size: .875rem;\n    font-weight: 300;\n    left: 50%;\n    line-height: 1.3125rem;\n    line-height: 1rem;\n    max-width: 27.5rem;\n    padding: 1rem 1.25rem;\n    position: fixed;\n    transform: translate(-50%, 200%);\n    transition: transform .25s cubic-bezier(.19, 1, .22, 1);\n    width: calc(100% - 3.5rem);\n    z-index: 1000\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .snackbar {\n        transition-duration: 1ms\n    }\n}\n\n.snackbar.is-visible {\n    transform: translate(-50%);\n    transition: transform .25s cubic-bezier(.19, 1, .22, 1)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .snackbar.is-visible {\n        transition-duration: 1ms\n    }\n}\n\n.snackbar__body {\n    font-weight: 600\n}\n\n.snackbar__body a {\n    color: inherit;\n    font-weight: inherit;\n    text-decoration: none;\n    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .snackbar__body a {\n        transition-duration: 1ms\n    }\n}\n\n.snackbar__body a:focus,\n.snackbar__body a:hover {\n    opacity: .65\n}\n\n.snackbar__body em {\n    font-style: italic\n}\n\n.snackbar__body strong {\n    font-weight: 700\n}\n\n.snackbar__close {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg' color='%23212123'%3E%3Cg stroke='currentcolor' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m4 4 8 8M12 4l-8 8'/%3E%3C/g%3E%3C/svg%3E\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    height: 1rem;\n    margin-left: auto;\n    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955);\n    width: 1rem\n}\n\n@media percy,\nscreen and (prefers-reduced-motion:reduce) {\n    .snackbar__close {\n        transition-duration: 1ms\n    }\n}\n\n.snackbar__close:hover {\n    opacity: 1\n}\n\n.snackbar--error {\n    background-color: #c00;\n    color: #fff\n}\n\n.snackbar--error .snackbar__close {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg' color='%23FFF'%3E%3Cg stroke='currentcolor' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m4 4 8 8M12 4l-8 8'/%3E%3C/g%3E%3C/svg%3E\")\n}\n\n.snackbar--warning {\n    background-color: #e6ac00;\n    color: #212123\n}\n\n.snackbar--warning .snackbar__close {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg height='16' width='16' xmlns='http://www.w3.org/2000/svg' color='%23212123'%3E%3Cg stroke='currentcolor' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m4 4 8 8M12 4l-8 8'/%3E%3C/g%3E%3C/svg%3E\")\n}\n\n.snackbar--success {\n    background-color: #13bf3e;\n    color: #fff\n}\n\n.snackbar--top {\n    bottom: auto;\n    top: 4.5rem;\n    transform: translate(-50%, -300%)\n}\n\n.snackbar--no-max-width {\n    width: calc(100% - 2rem)\n}\n\n@media screen and (min-width:768px) {\n    .snackbar--no-max-width {\n        max-width: none;\n        width: auto\n    }\n}\n\n.snackbar--no-max-width .snackbar__close {\n    margin-left: 1rem\n}\n\n.support__contact .wrapper {\n    border-top: 1px solid #e6e6e6;\n    padding: 4rem 0\n}\n\n@media screen and (min-width:768px) {\n    .support__contact .wrapper {\n        padding: 6rem 0\n    }\n}\n\n.support__contact__title {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -.03125rem;\n    line-height: 2.25rem;\n    margin-bottom: 1rem\n}\n\n@media screen and (max-width:767px) {\n    .support__contact__title {\n        font-size: 1.625rem;\n        line-height: 2rem\n    }\n}\n\n.support__contact__lead {\n    font-size: 1.0625rem;\n    font-weight: 300;\n    line-height: 1.5rem\n}\n\n.support__contact__lead,\n.support__contact__title {\n    color: #212123\n}\n\n.support__contact__actions {\n    margin-top: 1.5rem\n}\n\n.support__features__list {\n    grid-gap: 3rem;\n    display: grid;\n    grid-template-columns: 1fr;\n    margin: 0 auto\n}\n\n@media screen and (min-width:640px) {\n    .support__features__list {\n        grid-gap: 3rem 1.5rem;\n        grid-template-columns: repeat(2, 1fr)\n    }\n}\n\n.support__feature__title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    font-weight: 600;\n    line-height: 2rem;\n    margin-bottom: .25rem\n}\n\n@media screen and (max-width:767px) {\n    .support__feature__title {\n        font-size: 1.25rem;\n        font-weight: 700;\n        line-height: 1.75rem\n    }\n}\n\n@media screen and (min-width:768px) {\n    .support__feature__title {\n        margin-bottom: .5rem\n    }\n}\n\n.support__feature__lead {\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n    margin-bottom: 1.25rem\n}\n\n.support__feature__action {\n    color: #212123;\n    font-size: 1rem;\n    font-weight: 300;\n    font-weight: 600;\n    line-height: 1.5rem\n}\n\n.support__feature__action:after {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' color='%23000'%3E%3Cpath d='m13 8 4 4-4 4m2.5-4h-9' stroke='currentcolor' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-size: contain;\n    content: \"\";\n    display: inline-block;\n    height: 1.5rem;\n    opacity: .32;\n    vertical-align: -.4375em;\n    width: 1.5rem\n}\n\n.support__feature__action:hover {\n    text-decoration: none\n}\n\n.support__feature__image {\n    border-radius: 6px;\n    display: block;\n    margin-bottom: 1.5rem;\n    max-width: 100%;\n    overflow: hidden\n}\n\n.text-callout {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005;\n    color: #212123;\n    display: flex;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    margin-bottom: 1.5rem;\n    padding: 1.25rem;\n    position: relative\n}\n\n.text-callout strong {\n    font-weight: 500\n}\n\n.text-callout__icon {\n    display: block;\n    flex: 0 0 auto;\n    height: 1.25rem;\n    margin-right: .75rem;\n    margin-top: .125rem;\n    width: 1.25rem\n}\n\n.text-callout--red {\n    background-color: #f267251a\n}\n\n.text-callout--red .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--red .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #c00\n}\n\n.text-callout--red .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--red .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #c00\n}\n\n.styled-text .text-callout--red a,\n.text-callout--red .text-callout__icon [color],\n.text-callout--red .text-callout__icon[color] {\n    color: #c00\n}\n\n.text-callout--beige {\n    background-color: #fbf3da\n}\n\n.text-callout--beige .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--beige .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #f5a925\n}\n\n.text-callout--beige .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--beige .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #f5a925\n}\n\n.styled-text .text-callout--beige a,\n.text-callout--beige .text-callout__icon [color],\n.text-callout--beige .text-callout__icon[color] {\n    color: #f5a925\n}\n\n.text-callout--teal {\n    background-color: #83d7cf1a\n}\n\n.text-callout--teal .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--teal .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #3fb2a5\n}\n\n.text-callout--teal .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--teal .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #3fb2a5\n}\n\n.styled-text .text-callout--teal a,\n.text-callout--teal .text-callout__icon [color],\n.text-callout--teal .text-callout__icon[color] {\n    color: #3fb2a5\n}\n\n.text-callout--purple {\n    background-color: #d097db1a\n}\n\n.text-callout--purple .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--purple .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #a060ae\n}\n\n.text-callout--purple .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--purple .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #a060ae\n}\n\n.styled-text .text-callout--purple a,\n.text-callout--purple .text-callout__icon [color],\n.text-callout--purple .text-callout__icon[color] {\n    color: #a060ae\n}\n\n.text-callout--green {\n    background-color: #bbd9751a\n}\n\n.text-callout--green .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--green .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #85b532\n}\n\n.text-callout--green .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--green .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #85b532\n}\n\n.styled-text .text-callout--green a,\n.text-callout--green .text-callout__icon [color],\n.text-callout--green .text-callout__icon[color] {\n    color: #85b532\n}\n\n.text-callout--coal {\n    background-color: #fafafa\n}\n\n.text-callout--coal .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--coal .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #212123\n}\n\n.text-callout--coal .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--coal .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #212123\n}\n\n.styled-text .text-callout--coal a,\n.text-callout--coal .text-callout__icon [color],\n.text-callout--coal .text-callout__icon[color] {\n    color: #212123\n}\n\n.text-callout--white {\n    background-color: #fff\n}\n\n.text-callout--white .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--white .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #212123\n}\n\n.text-callout--white .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--white .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #212123\n}\n\n.styled-text .text-callout--white a,\n.text-callout--white .text-callout__icon [color],\n.text-callout--white .text-callout__icon[color] {\n    color: #212123\n}\n\n.text-callout--gray {\n    background-color: #0000000a\n}\n\n.text-callout--gray .text-callout__icon [stroke]:not([stroke=none]):not([stroke=currentcolor]),\n.text-callout--gray .text-callout__icon[stroke]:not([stroke=none]):not([stroke=currentcolor]) {\n    stroke: #212123\n}\n\n.text-callout--gray .text-callout__icon [fill]:not([fill=none]):not([fill=currentcolor]),\n.text-callout--gray .text-callout__icon[fill]:not([fill=none]):not([fill=currentcolor]) {\n    fill: #212123\n}\n\n.styled-text .text-callout--gray a,\n.text-callout--gray .text-callout__icon [color],\n.text-callout--gray .text-callout__icon[color] {\n    color: #212123\n}\n\n.user-profile {\n    height: 2.5rem\n}\n\n@media screen and (max-width:1023px) {\n    .user-profile {\n        background: #0000;\n        border: none;\n        box-shadow: none;\n        padding: 0\n    }\n}\n\n.user-profile__label {\n    display: none\n}\n\n@media screen and (min-width:1024px) {\n    .user-profile__label {\n        display: block\n    }\n}\n\n.user-profile__avatar {\n    border-radius: 9999px;\n    display: block;\n    height: 1.5rem;\n    margin-right: .5rem;\n    object-fit: cover;\n    object-position: center;\n    position: relative;\n    width: 1.5rem\n}\n\n.artboard {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    will-change: transform\n}\n\n@media screen and (min-width:1024px) {\n    .artboard--fixed {\n        position: absolute\n    }\n}\n\n.artboard--symbol .artboard__name {\n    color: #b620e0\n}\n\n.artboard__name {\n    align-items: center;\n    color: #858585;\n    cursor: default;\n    display: flex;\n    font-size: .75rem;\n    gap: .25rem;\n    letter-spacing: -.4px;\n    line-height: 1rem;\n    margin-bottom: .25rem;\n    margin-left: .25rem\n}\n\n.artboard:not(.artboard--selected) .artboard__name:hover+.artboard__body {\n    position: relative\n}\n\n.artboard:not(.artboard--selected) .artboard__name:hover+.artboard__body:before {\n    background-color: initial;\n    border: 2px solid #f26725;\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%\n}\n\n.artboard__body {\n    background-color: #fff;\n    box-shadow: 0 0 2px #0000001a, 0 2px 4px #0000001a\n}\n\n.artboard--selected,\n.artboard__body {\n    position: relative\n}\n\n.artboard--selected .artboard__body {\n    border: .5px solid #f26725\n}\n\n.artboard--selected .artboard__body:after,\n.artboard--selected .artboard__body:before {\n    background-color: #fff;\n    border: .5px solid #00000040;\n    box-shadow: 0 1px 2px #0003;\n    content: \"\";\n    display: block;\n    height: .5rem;\n    position: absolute;\n    width: .5rem\n}\n\n.artboard--selected .artboard__body:before {\n    left: -.25rem;\n    top: -.25rem\n}\n\n.artboard--selected .artboard__body:after {\n    right: -.25rem;\n    top: -.25rem\n}\n\n@media screen and (min-width:1024px) {\n    .artboard--selected .artboard__body {\n        border: 0;\n        outline: .5px solid #f26725\n    }\n}\n\n.artboard--selected:after,\n.artboard--selected:before {\n    background-color: #fff;\n    border: .5px solid #00000040;\n    box-shadow: 0 1px 2px #0003;\n    content: \"\";\n    display: block;\n    height: .5rem;\n    position: absolute;\n    width: .5rem;\n    z-index: 10\n}\n\n.artboard--selected:before {\n    bottom: -.25rem;\n    left: -.25rem\n}\n\n.artboard--selected:after {\n    bottom: -.25rem;\n    right: -.25rem\n}\n\n.artboard--moving .artboard__body:after,\n.artboard--moving .artboard__body:before,\n.artboard--moving:after,\n.artboard--moving:before {\n    display: none\n}\n\n.artboard__asset {\n    display: block\n}\n\n@media screen and (max-width:1023px) {\n    .artboard__asset {\n        max-width: 100%\n    }\n}\n\n.artboard--full-width .artboard__body {\n    width: 100%\n}\n\n@font-face {\n    font-family: swiper-icons;\n    font-style: normal;\n    font-weight: 400;\n    src: url(\"data:application/font-woff;charset=utf-8;base64, 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\") format(\"woff\");\n}\n\n:root {\n    --swiper-theme-color: #007aff\n}\n\n.swiper {\n    list-style: none;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    padding: 0;\n    position: relative;\n    z-index: 1\n}\n\n.swiper-vertical>.swiper-wrapper {\n    flex-direction: column\n}\n\n.swiper-wrapper {\n    box-sizing: initial;\n    display: flex;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n    width: 100%;\n    z-index: 1\n}\n\n.swiper-android .swiper-slide,\n.swiper-wrapper {\n    transform: translateZ(0)\n}\n\n.swiper-pointer-events {\n    touch-action: pan-y\n}\n\n.swiper-pointer-events.swiper-vertical {\n    touch-action: pan-x\n}\n\n.swiper-slide {\n    flex-shrink: 0;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n    width: 100%\n}\n\n.swiper-slide-invisible-blank {\n    visibility: hidden\n}\n\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n    height: auto\n}\n\n.swiper-autoheight .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height\n}\n\n.swiper-backface-hidden .swiper-slide {\n    backface-visibility: hidden;\n    transform: translateZ(0)\n}\n\n.swiper-3d,\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n    perspective: 1200px\n}\n\n.swiper-3d .swiper-cube-shadow,\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-wrapper {\n    transform-style: preserve-3d\n}\n\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top {\n    height: 100%;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 10\n}\n\n.swiper-3d .swiper-slide-shadow {\n    background: #00000026\n}\n\n.swiper-3d .swiper-slide-shadow-left {\n    background-image: linear-gradient(270deg, #00000080, #0000)\n}\n\n.swiper-3d .swiper-slide-shadow-right {\n    background-image: linear-gradient(90deg, #00000080, #0000)\n}\n\n.swiper-3d .swiper-slide-shadow-top {\n    background-image: linear-gradient(0deg, #00000080, #0000)\n}\n\n.swiper-3d .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(180deg, #00000080, #0000)\n}\n\n.swiper-css-mode>.swiper-wrapper {\n    -ms-overflow-style: none;\n    overflow: auto;\n    scrollbar-width: none\n}\n\n.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar {\n    display: none\n}\n\n.swiper-css-mode>.swiper-wrapper>.swiper-slide {\n    scroll-snap-align: start start\n}\n\n.swiper-horizontal.swiper-css-mode>.swiper-wrapper {\n    scroll-snap-type: x mandatory\n}\n\n.swiper-vertical.swiper-css-mode>.swiper-wrapper {\n    scroll-snap-type: y mandatory\n}\n\n.swiper-centered>.swiper-wrapper:before {\n    content: \"\";\n    flex-shrink: 0;\n    order: 9999\n}\n\n.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child {\n    margin-inline-start: var(--swiper-centered-offset-before)\n}\n\n.swiper-centered.swiper-horizontal>.swiper-wrapper:before {\n    height: 100%;\n    width: var(--swiper-centered-offset-after)\n}\n\n.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child {\n    margin-block-start: var(--swiper-centered-offset-before)\n}\n\n.swiper-centered.swiper-vertical>.swiper-wrapper:before {\n    height: var(--swiper-centered-offset-after);\n    width: 100%\n}\n\n.swiper-centered>.swiper-wrapper>.swiper-slide {\n    scroll-snap-align: center center;\n    scroll-snap-stop: always\n}\n\n.swiper-pagination {\n    position: absolute;\n    text-align: center;\n    transform: translateZ(0);\n    transition: opacity .3s;\n    z-index: 10\n}\n\n.swiper-pagination.swiper-pagination-hidden {\n    opacity: 0\n}\n\n.swiper-pagination-disabled>.swiper-pagination,\n.swiper-pagination.swiper-pagination-disabled {\n    display: none !important\n}\n\n.swiper-horizontal>.swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal,\n.swiper-pagination-custom,\n.swiper-pagination-fraction {\n    bottom: 10px;\n    left: 0;\n    width: 100%\n}\n\n.swiper-pagination-bullets-dynamic {\n    font-size: 0;\n    overflow: hidden\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    position: relative;\n    transform: scale(.33)\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n    transform: scale(1)\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n    transform: scale(.66)\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(.33)\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n    transform: scale(.66)\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n    transform: scale(.33)\n}\n\n.swiper-pagination-bullet {\n    background: var(--swiper-pagination-bullet-inactive-color, #000);\n    border-radius: 50%;\n    display: inline-block;\n    height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n    opacity: var(--swiper-pagination-bullet-inactive-opacity, .2);\n    width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px))\n}\n\nbutton.swiper-pagination-bullet {\n    -webkit-appearance: none;\n    appearance: none;\n    border: none;\n    box-shadow: none;\n    margin: 0;\n    padding: 0\n}\n\n.swiper-pagination-clickable .swiper-pagination-bullet {\n    cursor: pointer\n}\n\n.swiper-pagination-bullet:only-child {\n    display: none !important\n}\n\n.swiper-pagination-bullet-active {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    opacity: var(--swiper-pagination-bullet-opacity, 1)\n}\n\n.swiper-pagination-vertical.swiper-pagination-bullets,\n.swiper-vertical>.swiper-pagination-bullets {\n    right: 10px;\n    top: 50%;\n    transform: translate3d(0, -50%, 0)\n}\n\n.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {\n    display: block;\n    margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0\n}\n\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px\n}\n\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    display: inline-block;\n    transition: transform .2s, top .2s\n}\n\n.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px)\n}\n\n.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap\n}\n\n.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: transform .2s, left .2s\n}\n\n.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: transform .2s, right .2s\n}\n\n.swiper-pagination-progressbar {\n    background: #00000040;\n    position: absolute\n}\n\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: scale(0);\n    transform-origin: left top;\n    width: 100%\n}\n\n.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    transform-origin: right top\n}\n\n.swiper-horizontal>.swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-horizontal,\n.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,\n.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    height: 4px;\n    left: 0;\n    top: 0;\n    width: 100%\n}\n\n.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-vertical,\n.swiper-vertical>.swiper-pagination-progressbar {\n    height: 100%;\n    left: 0;\n    top: 0;\n    width: 4px\n}\n\n.swiper-pagination-lock {\n    display: none\n}\n\n.swiper-fade.swiper-free-mode .swiper-slide {\n    transition-timing-function: ease-out\n}\n\n.swiper-fade .swiper-slide {\n    pointer-events: none;\n    transition-property: opacity\n}\n\n.swiper-fade .swiper-slide .swiper-slide {\n    pointer-events: none\n}\n\n.swiper-fade .swiper-slide-active,\n.swiper-fade .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto\n}\n\n.customer-stories .artboard__body {\n    box-shadow: 0 2px 4px #0000001a, 0 0 2px #0000001a;\n    max-width: 100%\n}\n\n.customer-stories__story {\n    display: flex;\n    flex-wrap: wrap;\n    height: auto;\n    padding: 2rem 1.75rem 0\n}\n\n@media screen and (min-width:768px) {\n    .customer-stories__story {\n        padding: 3.5rem 3.5rem 0\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__story {\n        align-items: stretch;\n        flex-wrap: nowrap;\n        padding: 4.75rem 2rem 0 3.25rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .customer-stories__story {\n        padding-left: 4.375rem\n    }\n}\n\n.customer-stories__content {\n    min-height: 25.25rem;\n    opacity: 0;\n    position: relative;\n    transition: opacity .25s ease-in-out, transform .4s ease-in-out\n}\n\n.customer-stories__content:before {\n    content: \"“\";\n    font-size: 3.625rem;\n    font-weight: 500;\n    left: 0;\n    line-height: 2rem;\n    position: absolute;\n    top: 1.125rem\n}\n\n@media screen and (min-width:768px) {\n    .customer-stories__content:before {\n        left: -2.125rem;\n        top: .875rem\n    }\n}\n\n@media screen and (max-width:767px) {\n    .customer-stories__content {\n        padding: 2.25rem 0\n    }\n}\n\n@media screen and (min-width:768px) {\n    .customer-stories__content {\n        min-height: 14.75rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__content {\n        margin-right: auto;\n        max-width: 29.75rem;\n        min-height: 16.75rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .customer-stories__content {\n        margin-right: auto;\n        max-width: 36.75rem;\n        min-height: 14.75rem\n    }\n}\n\n.swiper--move-all-to-the-left .customer-stories__content {\n    transform: translateX(1.25rem)\n}\n\n.swiper--move-all-to-the-left .customer-stories__content.do-not-return-to-starting-position,\n.swiper--move-all-to-the-right .customer-stories__content {\n    transform: translateX(-1.25rem)\n}\n\n.swiper--move-all-to-the-right .customer-stories__content.do-not-return-to-starting-position {\n    transform: translateX(1.25rem)\n}\n\n.swiper-slide-active .customer-stories__content {\n    opacity: 1;\n    transform: translateX(0)\n}\n\n.customer-stories__company-info {\n    background-color: #fff;\n    border-top: 1px solid #00000014;\n    padding-top: 2.25rem;\n    width: 100%;\n    z-index: 1\n}\n\n@media screen and (min-width:768px) and (max-width:1023px) {\n    .customer-stories__company-info {\n        margin-top: 2.25rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info {\n        align-items: center;\n        border-left: 1px solid #00000014;\n        border-top: none;\n        display: flex;\n        max-width: 16.8125rem;\n        padding-left: 2rem;\n        padding-top: 0\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .customer-stories__company-info {\n        max-width: 21.5rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info__image-link {\n        margin: 0 auto\n    }\n}\n\n.customer-stories__company-info__inner {\n    align-items: center;\n    display: flex;\n    opacity: 0;\n    transform: scale(.95) translateY(.625rem);\n    transition: opacity .25s ease-in-out, transform .4s ease-in-out\n}\n\n@media screen and (min-width:768px) and (max-width:1023px) {\n    .customer-stories__company-info__inner {\n        max-width: 27.5rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info__inner {\n        flex-wrap: wrap\n    }\n}\n\n.customer-stories__company-info__title {\n    display: none;\n    font-size: 1.0625rem;\n    font-weight: 300;\n    line-height: 1.5rem\n}\n\n@media screen and (max-width:1023px) {\n    .customer-stories__company-info--no-link .customer-stories__company-info__title {\n        display: block;\n        font-size: 1rem;\n        font-weight: 300;\n        line-height: 1.5rem;\n        margin: 0 0 0 1rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info__title {\n        display: block;\n        min-width: 14.8125rem;\n        text-align: center\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .customer-stories__company-info__title {\n        min-width: 19.5rem\n    }\n}\n\n.customer-stories__company-info__link {\n    margin: 0 auto;\n    width: -moz-fit-content;\n    width: fit-content\n}\n\n.customer-stories__company-info__link svg {\n    color: #00000052;\n    vertical-align: top\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info__link {\n        display: block;\n        margin-top: 1.25rem;\n        order: 1\n    }\n}\n\n.customer-stories__company-info__link--mobile {\n    color: #212123;\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n    margin-left: 1rem\n}\n\n@media screen and (min-width:768px) {\n    .customer-stories__company-info__link--mobile {\n        margin-left: 1.25rem;\n        margin-top: 0\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-info__link--mobile {\n        display: none\n    }\n}\n\n.swiper-slide-active .customer-stories__company-info__inner {\n    opacity: 1;\n    transform: scale(1)\n}\n\n.customer-stories__company-logo {\n    border-radius: 6px;\n    height: 4rem;\n    width: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__company-logo {\n        display: block;\n        height: 4.5rem;\n        margin: 0 auto 1.25rem;\n        width: 4.5rem\n    }\n}\n\n.customer-stories__quote {\n    font-size: 1.25rem;\n    letter-spacing: -.03125rem;\n    line-height: 1.75rem\n}\n\n@media screen and (min-width:768px) {\n    .customer-stories__quote {\n        font-size: 1.5rem;\n        line-height: 2rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories__quote {\n        min-width: 29.75rem\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .customer-stories__quote {\n        min-width: 36.75rem\n    }\n}\n\n.customer-stories__author {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 2rem\n}\n\n.customer-stories__author__name {\n    display: block;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5rem;\n    width: 100%\n}\n\n.customer-stories__author__date,\n.customer-stories__author__position {\n    font-size: .875rem;\n    font-weight: 300;\n    line-height: 1.25rem\n}\n\n.customer-stories__author__date {\n    opacity: .64\n}\n\n.customer-stories__author__avatar {\n    border: 2px solid #83d7cf;\n    border-radius: 9999px;\n    height: 3rem;\n    margin-right: 1rem;\n    padding: .125rem;\n    width: 3rem\n}\n\n.customer-stories .swiper-pagination {\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    margin-top: 2.25rem;\n    padding-bottom: 1.5rem;\n    position: relative\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories .swiper-pagination {\n        margin-top: 1.5rem\n    }\n}\n\n@keyframes customer-stories-fill-circle {\n    0% {\n        stroke-dashoffset: 114\n    }\n\n    to {\n        stroke-dashoffset: 0\n    }\n}\n\n.customer-stories__paginator-item {\n    cursor: pointer;\n    opacity: .48;\n    padding: .5rem;\n    position: relative\n}\n\n@media screen and (max-width:1023px) {\n    .customer-stories__paginator-item:not(:last-child) {\n        margin-right: .5rem\n    }\n}\n\n.customer-stories__paginator-item .customer-stories__paginator-circle {\n    display: none\n}\n\n.customer-stories__paginator-item--active {\n    opacity: 1\n}\n\n.customer-stories__paginator-item--active .customer-stories__paginator-circle {\n    display: block\n}\n\n.customer-stories__paginator-item--active .customer-stories__paginator-circle--progress {\n    stroke-dasharray: 114;\n    animation: customer-stories-fill-circle var(--animation-time) linear forwards\n}\n\n.customer-stories__paginator-item svg {\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: rotate(-90deg)\n}\n\n.customer-stories__paginator-item img {\n    border-radius: 9999px;\n    height: 1.5rem;\n    width: 1.5rem\n}\n\n.customer-stories-section {\n    background-color: #fafafa;\n    padding-bottom: 4rem;\n    padding-top: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories-section {\n        padding-bottom: 6rem;\n        padding-top: 6rem\n    }\n}\n\n.customer-stories-section__title {\n    font-size: 2rem;\n    font-weight: 600;\n    letter-spacing: -.5px;\n    line-height: 2.5rem;\n    margin-bottom: 2.75rem;\n    text-align: center\n}\n\n@media screen and (max-width:767px) {\n    .customer-stories-section__title {\n        font-size: 1.75rem;\n        line-height: 2rem\n    }\n}\n\n.customer-stories-section__inner {\n    position: relative\n}\n\n@media screen and (min-width:1024px) {\n    .customer-stories-section .wrapper {\n        padding-left: 1.25rem;\n        padding-right: 1.25rem\n    }\n}\n\n@media screen and (min-width:1024px) and (min-width:1024px) {\n    .customer-stories-section .wrapper {\n        padding-left: 2rem;\n        padding-right: 2rem\n    }\n}\n\n.customer-stories-section--with-borders {\n    border-bottom: 1px solid #00000014;\n    border-top: 1px solid #00000014\n}\n\n.get-started-sticker {\n    margin-bottom: 4rem;\n    margin-top: 4rem\n}\n\n@media screen and (min-width:1024px) {\n    .get-started-sticker {\n        margin-bottom: 6rem;\n        margin-top: 6rem\n    }\n}\n\n.get-started-sticker--no-margins {\n    margin-bottom: 0;\n    margin-top: 0\n}\n\n.get-started-sticker--with-divider .wrapper {\n    padding-top: 4rem;\n    position: relative\n}\n\n.get-started-sticker--with-divider .wrapper:before {\n    border-top: 1px solid #00000014;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0\n}\n\n@media screen and (min-width:1024px) {\n    .get-started-sticker--with-divider .wrapper {\n        padding-top: 6rem\n    }\n}\n\n.get-started-sticker__sticker {\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    display: block;\n    height: 7.75rem;\n    margin: 0 auto 1.5rem;\n    -webkit-mask-image: -webkit-radial-gradient(#fff, #000);\n    width: 7.75rem\n}\n\n.get-started-sticker__heading {\n    font-size: 1.75rem;\n    font-weight: 700;\n    letter-spacing: -.5px;\n    line-height: 2.75rem;\n    margin: 0 auto 2rem;\n    max-width: 20.5rem;\n    text-align: center\n}\n\n@media screen and (min-width:768px) {\n    .get-started-sticker__heading {\n        font-size: 2.75rem;\n        letter-spacing: -1px;\n        line-height: 3.5rem;\n        margin-bottom: 2.25rem;\n        max-width: 32.5rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .get-started-sticker__heading {\n        max-width: 36.75rem\n    }\n}\n\n.get-started-sticker__heading em {\n    color: #f26725;\n    display: block;\n    font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;\n    font-size: 2.75rem;\n    font-weight: 700;\n    line-height: 2rem\n}\n\n@media screen and (min-width:768px) {\n    .get-started-sticker__heading em {\n        font-size: 3.5rem;\n        letter-spacing: -1px;\n        margin-top: .5rem\n    }\n}\n\n.get-started-sticker__blurb {\n    font-size: 1.0625rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n    margin: 0 auto 1.5rem;\n    max-width: 18rem;\n    text-align: center\n}\n\n@media screen and (min-width:1024px) {\n    .get-started-sticker__blurb {\n        font-size: 1.25rem;\n        line-height: 1.75rem\n    }\n}\n\n@media screen and (min-width:768px) {\n    .get-started-sticker__blurb {\n        max-width: 29.5rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .get-started-sticker__blurb {\n        margin: 0 auto 1.5rem;\n        max-width: 32.5rem;\n        max-width: 36.75rem\n    }\n}\n\n.get-started-sticker__actions {\n    text-align: center\n}\n\n.artboard.pitch .artboard__body {\n    padding: 2rem 1.25rem\n}\n\n@media screen and (min-width:768px) {\n    .artboard.pitch .artboard__body {\n        padding: 3.5rem\n    }\n}\n\n.event-dialog {\n    align-items: center;\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #00000014;\n    border-radius: 12px;\n    box-shadow: 0 4px 8px #00000014;\n    color: #212123;\n    display: flex;\n    flex-direction: column;\n    max-width: 29.6875rem;\n    overflow: hidden;\n    padding: 1.5rem;\n    width: 100%\n}\n\n@media screen and (min-width:1024px) {\n    .event-dialog {\n        max-width: 36.75rem\n    }\n}\n\n.event-dialog__header {\n    width: 100%\n}\n\n.event-dialog__asset {\n    aspect-ratio: auto;\n    border-radius: 0;\n    height: 9.25rem;\n    margin: -1.5rem -1.5rem 1.5rem;\n    object-fit: cover;\n    object-position: center;\n    overflow: visible;\n    width: calc(100% + 3rem)\n}\n\n.event-dialog__title {\n    color: #212123;\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: -.5px;\n    line-height: 2rem;\n    margin-bottom: .5rem\n}\n\n.event-dialog__content {\n    color: #212123;\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n    width: 100%\n}\n\n.event-dialog__content strong {\n    font-weight: 600\n}\n\n.event-dialog__content em {\n    font-style: italic\n}\n\n.event-dialog__content p {\n    margin-bottom: 1rem\n}\n\n.event-dialog__content p:last-of-type {\n    margin-bottom: 0\n}\n\n.event-dialog__content a:not(.button) {\n    color: #212123;\n    font-weight: 500;\n    text-decoration-color: #0003;\n    text-decoration-line: underline;\n    text-decoration-thickness: 1.5px;\n    text-underline-offset: 4px;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .event-dialog__content a:not(.button) {\n        transition-duration: 1ms\n    }\n}\n\n.event-dialog__content a:not(.button):active,\n.event-dialog__content a:not(.button):hover {\n    color: #0000007a\n}\n\n.event-dialog__actions {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    gap: .5rem;\n    margin-top: 1.5rem;\n    width: 100%\n}\n\n.event-dialog__action,\n.event-dialog__button {\n    width: 100%\n}\n\n.event-dialog__footer {\n    margin-top: 1rem;\n    opacity: .64\n}\n\n.event-dialog__footer p {\n    font-size: .875rem\n}\n\n.input-group {\n    align-items: stretch;\n    display: flex;\n    width: 100%\n}\n\n.input-group--gap {\n    gap: .5rem\n}\n\n.overflow-blur {\n    -webkit-mask-image: linear-gradient(90deg, #000 90%, #0000);\n    mask-image: linear-gradient(90deg, #000 90%, #0000);\n    position: relative\n}\n\n.overflow-blur--scrolled {\n    -webkit-mask-image: linear-gradient(90deg, #0000 0, #000 10%, #000 90%, #0000);\n    mask-image: linear-gradient(90deg, #0000 0, #000 10%, #000 90%, #0000)\n}\n\n.aspect-ratio {\n    display: block;\n    padding: 0;\n    position: relative\n}\n\n.aspect-ratio[data-aspect-ratio-ratio-value=\"16:9\"]:before {\n    padding-top: 56.25%\n}\n\n.aspect-ratio[data-aspect-ratio-ratio-value=\"16:10\"]:before {\n    padding-top: 62.5%\n}\n\n.aspect-ratio[data-aspect-ratio-ratio-value=\"1:1\"]:before {\n    padding-top: 100%\n}\n\n.aspect-ratio:before {\n    content: \"\";\n    display: block;\n    float: left;\n    height: 0;\n    margin-left: -1px;\n    width: 1px\n}\n\n.aspect-ratio:after {\n    clear: both;\n    content: \"\";\n    display: table\n}\n\n.aspect-ratio__fill {\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%\n}\n\n.hidden,\n.is-hidden,\n.js-hidden {\n    display: none\n}\n\n.opacity-0 {\n    opacity: 0\n}\n\n.hide {\n    display: none !important\n}\n\n.block {\n    display: block\n}\n\n.inline {\n    display: inline\n}\n\n.inline-block {\n    display: inline-block\n}\n\n.visuallyhidden {\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    overflow: hidden;\n    position: absolute !important;\n    white-space: nowrap;\n    width: 1px\n}\n\n@media only percy {\n    .hidden-in-percy {\n        visibility: hidden\n    }\n}\n\n.overflow-hidden {\n    overflow: hidden\n}\n\n.overflow-x-hidden {\n    overflow-x: hidden\n}\n\n.overflow-y-hidden {\n    overflow-y: hidden\n}\n\n.relative {\n    position: relative\n}\n\n@media screen and (max-width:359px) {\n    .below-viewport-2xs-block {\n        display: block\n    }\n\n    .below-viewport-2xs-flex {\n        display: flex\n    }\n\n    .below-viewport-2xs-grid {\n        display: grid\n    }\n\n    .below-viewport-2xs-inline {\n        display: inline\n    }\n\n    .below-viewport-2xs-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-2xs-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:360px) {\n    .above-viewport-2xs-block {\n        display: block\n    }\n\n    .above-viewport-2xs-flex {\n        display: flex\n    }\n\n    .above-viewport-2xs-grid {\n        display: grid\n    }\n\n    .above-viewport-2xs-inline {\n        display: inline\n    }\n\n    .above-viewport-2xs-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-2xs-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:389px) {\n    .below-viewport-xs-block {\n        display: block\n    }\n\n    .below-viewport-xs-flex {\n        display: flex\n    }\n\n    .below-viewport-xs-grid {\n        display: grid\n    }\n\n    .below-viewport-xs-inline {\n        display: inline\n    }\n\n    .below-viewport-xs-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-xs-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:390px) {\n    .above-viewport-xs-block {\n        display: block\n    }\n\n    .above-viewport-xs-flex {\n        display: flex\n    }\n\n    .above-viewport-xs-grid {\n        display: grid\n    }\n\n    .above-viewport-xs-inline {\n        display: inline\n    }\n\n    .above-viewport-xs-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-xs-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:639px) {\n    .below-viewport-s-block {\n        display: block\n    }\n\n    .below-viewport-s-flex {\n        display: flex\n    }\n\n    .below-viewport-s-grid {\n        display: grid\n    }\n\n    .below-viewport-s-inline {\n        display: inline\n    }\n\n    .below-viewport-s-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-s-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:640px) {\n    .above-viewport-s-block {\n        display: block\n    }\n\n    .above-viewport-s-flex {\n        display: flex\n    }\n\n    .above-viewport-s-grid {\n        display: grid\n    }\n\n    .above-viewport-s-inline {\n        display: inline\n    }\n\n    .above-viewport-s-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-s-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:767px) {\n    .below-viewport-m-block {\n        display: block\n    }\n\n    .below-viewport-m-flex {\n        display: flex\n    }\n\n    .below-viewport-m-grid {\n        display: grid\n    }\n\n    .below-viewport-m-inline {\n        display: inline\n    }\n\n    .below-viewport-m-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-m-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:768px) {\n    .above-viewport-m-block {\n        display: block\n    }\n\n    .above-viewport-m-flex {\n        display: flex\n    }\n\n    .above-viewport-m-grid {\n        display: grid\n    }\n\n    .above-viewport-m-inline {\n        display: inline\n    }\n\n    .above-viewport-m-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-m-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:1023px) {\n    .below-viewport-l-block {\n        display: block\n    }\n\n    .below-viewport-l-flex {\n        display: flex\n    }\n\n    .below-viewport-l-grid {\n        display: grid\n    }\n\n    .below-viewport-l-inline {\n        display: inline\n    }\n\n    .below-viewport-l-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-l-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .above-viewport-l-block {\n        display: block\n    }\n\n    .above-viewport-l-flex {\n        display: flex\n    }\n\n    .above-viewport-l-grid {\n        display: grid\n    }\n\n    .above-viewport-l-inline {\n        display: inline\n    }\n\n    .above-viewport-l-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-l-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:1219px) {\n    .below-viewport-xl-block {\n        display: block\n    }\n\n    .below-viewport-xl-flex {\n        display: flex\n    }\n\n    .below-viewport-xl-grid {\n        display: grid\n    }\n\n    .below-viewport-xl-inline {\n        display: inline\n    }\n\n    .below-viewport-xl-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-xl-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:1220px) {\n    .above-viewport-xl-block {\n        display: block\n    }\n\n    .above-viewport-xl-flex {\n        display: flex\n    }\n\n    .above-viewport-xl-grid {\n        display: grid\n    }\n\n    .above-viewport-xl-inline {\n        display: inline\n    }\n\n    .above-viewport-xl-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-xl-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:1439px) {\n    .below-viewport-2xl-block {\n        display: block\n    }\n\n    .below-viewport-2xl-flex {\n        display: flex\n    }\n\n    .below-viewport-2xl-grid {\n        display: grid\n    }\n\n    .below-viewport-2xl-inline {\n        display: inline\n    }\n\n    .below-viewport-2xl-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-2xl-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:1440px) {\n    .above-viewport-2xl-block {\n        display: block\n    }\n\n    .above-viewport-2xl-flex {\n        display: flex\n    }\n\n    .above-viewport-2xl-grid {\n        display: grid\n    }\n\n    .above-viewport-2xl-inline {\n        display: inline\n    }\n\n    .above-viewport-2xl-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-2xl-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:1599px) {\n    .below-viewport-3xl-block {\n        display: block\n    }\n\n    .below-viewport-3xl-flex {\n        display: flex\n    }\n\n    .below-viewport-3xl-grid {\n        display: grid\n    }\n\n    .below-viewport-3xl-inline {\n        display: inline\n    }\n\n    .below-viewport-3xl-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-3xl-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:1600px) {\n    .above-viewport-3xl-block {\n        display: block\n    }\n\n    .above-viewport-3xl-flex {\n        display: flex\n    }\n\n    .above-viewport-3xl-grid {\n        display: grid\n    }\n\n    .above-viewport-3xl-inline {\n        display: inline\n    }\n\n    .above-viewport-3xl-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-3xl-none {\n        display: none\n    }\n}\n\n@media screen and (max-width:1919px) {\n    .below-viewport-4xl-block {\n        display: block\n    }\n\n    .below-viewport-4xl-flex {\n        display: flex\n    }\n\n    .below-viewport-4xl-grid {\n        display: grid\n    }\n\n    .below-viewport-4xl-inline {\n        display: inline\n    }\n\n    .below-viewport-4xl-inline-block {\n        display: inline-block\n    }\n\n    .below-viewport-4xl-none {\n        display: none\n    }\n}\n\n@media screen and (min-width:1920px) {\n    .above-viewport-4xl-block {\n        display: block\n    }\n\n    .above-viewport-4xl-flex {\n        display: flex\n    }\n\n    .above-viewport-4xl-grid {\n        display: grid\n    }\n\n    .above-viewport-4xl-inline {\n        display: inline\n    }\n\n    .above-viewport-4xl-inline-block {\n        display: inline-block\n    }\n\n    .above-viewport-4xl-none {\n        display: none\n    }\n}\n\n.max-w-col-10,\n.max-w-col-4,\n.max-w-col-6,\n.max-w-col-8 {\n    width: 100%\n}\n\n.max-w-col-4 {\n    max-width: 24rem\n}\n\n.max-w-col-6 {\n    max-width: 36.75rem\n}\n\n.max-w-col-8 {\n    max-width: 49.5rem\n}\n\n.max-w-col-10 {\n    max-width: 62.25rem\n}\n\n.prevent-scroll {\n    overflow: hidden\n}\n\n.styled-text-minimal em {\n    font-style: italic\n}\n\n.styled-text-minimal strong {\n    font-weight: 600\n}\n\n.styled-text-minimal a {\n    color: inherit;\n    text-decoration: none;\n    transition: opacity 125ms cubic-bezier(.455, .03, .515, .955)\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .styled-text-minimal a {\n        transition-duration: 1ms\n    }\n}\n\n.styled-text-minimal a:focus,\n.styled-text-minimal a:hover {\n    opacity: .65\n}\n\n.styled-text {\n    color: #212123;\n    font-size: 1.0625rem;\n    font-weight: 300;\n    line-height: 1.5rem\n}\n\n.styled-text h1 {\n    font-size: 2.25rem;\n    font-weight: 900;\n    line-height: 2.5rem;\n    margin-bottom: 1.5rem;\n    margin-top: 3rem\n}\n\n@media screen and (min-width:390px) {\n    .styled-text h1 {\n        font-size: 2.5rem;\n        line-height: 2.75rem\n    }\n}\n\n@media screen and (min-width:768px) {\n    .styled-text h1 {\n        font-size: 3rem;\n        line-height: 3rem;\n        margin-bottom: 2rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .styled-text h1 {\n        font-size: 4.75rem;\n        line-height: 4.75rem;\n        margin-bottom: 2rem\n    }\n}\n\n.styled-text h2 {\n    font-size: 2rem;\n    font-weight: 900;\n    line-height: 2.25rem;\n    margin-bottom: 1.5rem;\n    margin-top: 3rem\n}\n\n@media screen and (min-width:768px) {\n    .styled-text h2 {\n        font-size: 2.5rem;\n        line-height: 3rem;\n        margin-bottom: 2rem\n    }\n}\n\n@media screen and (min-width:1024px) {\n    .styled-text h2 {\n        font-size: 3.5rem;\n        line-height: 3.75rem;\n        margin-bottom: 2rem\n    }\n}\n\n.styled-text h3 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -.03125rem;\n    line-height: 2.25rem;\n    margin-bottom: 1rem;\n    margin-top: 4rem\n}\n\n@media screen and (max-width:767px) {\n    .styled-text h3 {\n        font-size: 1.625rem;\n        line-height: 2rem;\n        margin-top: 3rem\n    }\n}\n\n.styled-text h4 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    line-height: 1.5rem;\n    margin-bottom: 1rem;\n    margin-top: 1.5rem\n}\n\n@media screen and (min-width:768px) {\n    .styled-text h4 {\n        margin-top: 2.5rem\n    }\n}\n\n.styled-text h5 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.5rem;\n    margin-bottom: .75rem;\n    margin-top: 1rem\n}\n\n@media screen and (min-width:768px) {\n    .styled-text h5 {\n        margin-top: 2rem\n    }\n}\n\n.styled-text ol,\n.styled-text ul {\n    list-style-position: outside;\n    padding-left: 1.2em\n}\n\n.styled-text ul {\n    list-style-type: disc\n}\n\n.styled-text ol {\n    list-style-type: decimal\n}\n\n.styled-text li:not(:last-child),\n.styled-text ol:not(:last-child),\n.styled-text p:not(:last-child),\n.styled-text ul:not(:last-child) {\n    margin-bottom: 1rem\n}\n\n.styled-text li ol,\n.styled-text li ul {\n    margin-top: .5em\n}\n\n.styled-text blockquote {\n    border-left: .12em solid #0000001a;\n    font-family: Marfa, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;\n    font-size: 1.125em;\n    margin-bottom: 1.5em;\n    margin-top: 1.5em;\n    padding-left: 1em\n}\n\n@media screen and (min-width:768px) {\n    .styled-text blockquote {\n        font-size: 1.333333333em;\n        line-height: 1.4\n    }\n}\n\n.styled-text blockquote>p:last-of-type {\n    margin-bottom: 0\n}\n\n.styled-text blockquote>footer {\n    color: #212123b3;\n    font-size: .8888888889em;\n    margin-top: 1em\n}\n\n@media screen and (min-width:768px) {\n    .styled-text blockquote>footer {\n        font-size: .7500000002em\n    }\n}\n\n.styled-text details[open] summary {\n    margin-bottom: 1em\n}\n\n.styled-text figcaption {\n    color: #212123b3;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    margin-bottom: 1.5rem;\n    margin-top: .5rem\n}\n\n.styled-text b,\n.styled-text strong {\n    font-weight: 600\n}\n\n.styled-text b a:not(.button),\n.styled-text strong a:not(.button) {\n    font-weight: inherit\n}\n\n.styled-text em {\n    font-style: italic\n}\n\n.styled-text a:not(.button) {\n    color: #212123;\n    font-weight: 500;\n    text-decoration-color: #0003;\n    text-decoration-line: underline;\n    text-decoration-thickness: 1.5px;\n    text-underline-offset: 4px;\n    transition: color 125ms ease-out\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .styled-text a:not(.button) {\n        transition-duration: 1ms\n    }\n}\n\n.styled-text a:not(.button):active,\n.styled-text a:not(.button):hover {\n    color: #0000007a\n}\n\n.styled-text figcaption a {\n    color: inherit;\n    font-weight: inherit;\n    text-decoration: none\n}\n\n.styled-text h1 a,\n.styled-text h1 strong,\n.styled-text h2 a,\n.styled-text h2 strong,\n.styled-text h3 a,\n.styled-text h3 strong,\n.styled-text h4 a,\n.styled-text h4 strong,\n.styled-text h5 a,\n.styled-text h5 strong,\n.styled-text h6 a,\n.styled-text h6 strong {\n    font-weight: inherit\n}\n\n.styled-text code,\n.styled-text pre {\n    font-family: Marfa Mono, SF Mono, Source Code Pro, Consolas, Menlo, monospace\n}\n\n.styled-text :not(pre)>code {\n    background-color: #0000000a;\n    line-height: 1.75rem\n}\n\n.styled-text :not(pre)>code,\n.styled-text kbd {\n    border-radius: 6px;\n    font-size: .875em;\n    overflow-wrap: break-word;\n    overflow-x: hidden;\n    padding: .2em .4em\n}\n\n.styled-text kbd {\n    background-color: #ffffffb3;\n    box-shadow: inset 0 0 0 1px #0000001a, inset 0 -2px 0 #0000001a;\n    color: #212123;\n    font-family: inherit;\n    font-weight: 500;\n    margin: 0 .2em;\n    min-width: 1.625rem\n}\n\n.styled-text pre:not(.highlight)>code {\n    background-color: #454545;\n    border-radius: 6px;\n    display: block;\n    overflow-wrap: break-word;\n    padding: 1.1428571429em\n}\n\n.styled-text hr {\n    border: 0;\n    display: block;\n    font-weight: 300;\n    height: auto;\n    margin: 1.5em 0;\n    text-align: center\n}\n\n.styled-text hr:after {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg' color='%23f26725' fill='none'%3E%3Cmask id='a' fill='%23fff'%3E%3Cpath d='m7.677 1.646-4.963 6.09a.417.417 0 0 0 0 .527l4.963 6.09a.417.417 0 0 0 .646 0l4.963-6.09a.417.417 0 0 0 0-.526l-4.963-6.09a.417.417 0 0 0-.646 0Z'/%3E%3C/mask%3E%3Cpath stroke='currentColor' stroke-width='1.5' stroke-linejoin='round' d='m7.677 1.646-4.963 6.09a.417.417 0 0 0 0 .527l4.963 6.09a.417.417 0 0 0 .646 0l4.963-6.09a.417.417 0 0 0 0-.526l-4.963-6.09a.417.417 0 0 0-.646 0Z'/%3E%3Cpath fill-opacity='.15' fill='currentColor' mask='url(%23a)' d='M8 1.333h5.833v13.333H8z'/%3E%3C/svg%3E\");\n    content: \"\";\n    display: inline-block;\n    height: 1rem;\n    width: 1rem\n}\n\n.styled-text img:not([class]),\n.styled-text img[data-controller=lazyload][class=is-loaded] {\n    display: block;\n    max-width: 100%\n}\n\n.styled-text img:not([class]):not([height]),\n.styled-text img[data-controller=lazyload][class=is-loaded]:not([height]) {\n    height: auto\n}\n\n.styled-text figure iframe,\n.styled-text figure:not([class]) img,\n.styled-text video {\n    border-radius: 12px;\n    box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005, 0 0 4px #00000014;\n    display: block;\n    overflow: hidden\n}\n\n.styled-text figure.embed,\n.styled-text figure:not([class]) img,\n.styled-text video {\n    margin-top: 1em;\n    width: 100%\n}\n\n.styled-text figure+ol,\n.styled-text figure+p,\n.styled-text figure+ul {\n    margin-top: 2em\n}\n\n.styled-text li figure:last-child {\n    margin-bottom: 2rem\n}\n\n.styled-text figure+.text-callout {\n    margin-top: 1.5rem\n}\n\n.styled-text .docs-tabs+.text-callout {\n    margin-top: 1rem\n}\n\n.styled-text--secondary {\n    color: #212123b3\n}\n\n.styled-text--secondary b,\n.styled-text--secondary strong {\n    color: #212123\n}\n\n@media screen and (min-width:768px) {\n    .styled-text--font-bump {\n        font-size: 1.125rem\n    }\n}\n\n.styled-text--alt-headings h2 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -.03125rem;\n    line-height: 2.25rem;\n    margin-bottom: 1rem;\n    margin-top: 4rem\n}\n\n@media screen and (max-width:767px) {\n    .styled-text--alt-headings h2 {\n        font-size: 1.625rem;\n        line-height: 2rem;\n        margin-top: 3rem\n    }\n}\n\n.styled-text--alt-headings h3 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 2rem;\n    margin-bottom: .5rem;\n    margin-top: 2.5rem\n}\n\n@media screen and (max-width:767px) {\n    .styled-text--alt-headings h3 {\n        font-size: 1.25rem;\n        font-weight: 700;\n        line-height: 1.75rem;\n        margin-bottom: .25rem;\n        margin-top: 1.5rem\n    }\n}\n\n.styled-text--alt-headings h4 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.5rem;\n    margin-bottom: .75rem;\n    margin-top: 1rem\n}\n\n@media screen and (min-width:768px) {\n    .styled-text--alt-headings h4 {\n        margin-top: 2rem\n    }\n}\n\n.styled-text #markdown-toc {\n    margin-bottom: 2rem;\n    margin-top: 2rem\n}\n\n.styled-text #markdown-toc ol,\n.styled-text #markdown-toc ul {\n    margin-top: .5rem\n}\n\n.styled-text #markdown-toc a {\n    font-weight: 600\n}\n\n.styled-text .apple-symbol {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif\n}\n\n.styled-text .footnotes {\n    color: #212123b3;\n    font-size: 81.25%\n}\n\n.ui-icon {\n    vertical-align: middle\n}\n\n.styled-table {\n    background: none;\n    border: 1px solid #00000014;\n    border-radius: 12px;\n    margin: 1rem auto;\n    overflow: auto;\n    padding: 0;\n    width: 100%\n}\n\n.styled-table table {\n    font-size: .875rem;\n    min-width: 40rem\n}\n\n.styled-table td,\n.styled-table th {\n    padding: 1.25rem 1.5rem 1.25rem 1.25rem\n}\n\n.styled-table th {\n    font-size: .875rem;\n    font-weight: 600;\n    text-align: left;\n    text-transform: uppercase;\n    white-space: nowrap\n}\n\n.styled-table td {\n    color: #212123;\n    font-weight: 300;\n    line-height: 1.25rem\n}\n\n.styled-table td>strong {\n    font-weight: 600\n}\n\n.styled-table td sup>a {\n    color: #ff7843\n}\n\n.styled-table tbody tr:nth-child(odd) {\n    background-color: #f5f5f5\n}\n\n.styled-table--full table {\n    width: 100%\n}\n\n.styled-table--first td:first-child {\n    font-weight: 600\n}\n\n@media screen and (max-width:767px) {\n    .styled-table--first td:first-child {\n        max-width: 50vw\n    }\n}\n\n.shortcuts-table {\n    margin-bottom: 1rem\n}\n\n.shortcuts-table table {\n    border: 1px solid #0000001a;\n    border-collapse: initial;\n    border-radius: 6px\n}\n\n.shortcuts-table tr:nth-child(odd) {\n    background: #00000005\n}\n\n.shortcuts-table td {\n    padding: .75rem;\n    vertical-align: middle\n}\n\n.shortcuts-table td:first-child {\n    padding-bottom: .625rem;\n    padding-top: .625rem\n}\n\n.shortcuts-table td:last-child {\n    border-left: 1px solid #0000000f;\n    padding-right: 1em\n}\n\n.shortcuts-table tr:not(:last-child) td {\n    border-bottom: 1px solid #f0f0f0\n}\n\n.shortcuts-table td:first-child em {\n    font-style: normal;\n    vertical-align: middle\n}\n\n.shortcuts-table td:first-child kbd+em {\n    margin-left: .25em\n}\n\n.shortcuts-table td:first-child kbd+em:not(:last-child) {\n    margin-right: .25em\n}\n\n.highlighter-rouge {\n    margin-bottom: 1rem\n}\n\n.highlight code {\n    background-color: #00000014;\n    border-radius: 6px;\n    display: block;\n    font-size: .9375rem;\n    overflow-x: hidden;\n    padding: 1rem 1.25rem\n}\n\n@media screen and (min-width:640px) {\n    .highlight code {\n        overflow-x: hidden;\n        white-space: pre-wrap\n    }\n}\n\n.highlight .o,\n.highlight .p {\n    color: #000000a3\n}\n\n.highlight .err {\n    color: #000c\n}\n\n.highlight .n {\n    color: #62266e\n}\n\n.highlight .na {\n    color: #1a5e54\n}\n\n.highlight .nb,\n.highlight .nc,\n.highlight .nd,\n.highlight .ne,\n.highlight .nf,\n.highlight .ni,\n.highlight .nl,\n.highlight .nn,\n.highlight .no {\n    color: #62266e\n}\n\n.highlight .nx {\n    color: #000c\n}\n\n.highlight .bp,\n.highlight .nt,\n.highlight .nv,\n.highlight .py,\n.highlight .vc,\n.highlight .vg,\n.highlight .vi {\n    color: #62266e\n}\n\n.highlight .c,\n.highlight .c1,\n.highlight .cm {\n    color: #0000007a\n}\n\n.highlight .k {\n    color: #1a5e54\n}\n\n.highlight .kc,\n.highlight .kd,\n.highlight .kn,\n.highlight .kp,\n.highlight .kr,\n.highlight .kt {\n    color: #8d5f10\n}\n\n.highlight .l,\n.highlight .ld,\n.highlight .m,\n.highlight .mf,\n.highlight .mh {\n    color: #482000\n}\n\n.highlight .mi {\n    color: #1a5e54\n}\n\n.highlight .il,\n.highlight .mo,\n.highlight .s,\n.highlight .s1,\n.highlight .s2,\n.highlight .sb,\n.highlight .sc,\n.highlight .sd,\n.highlight .se,\n.highlight .sh,\n.highlight .si,\n.highlight .sr,\n.highlight .ss,\n.highlight .sx {\n    color: #482000\n}\n\n.highlight .gi {\n    color: #000c\n}\n\n.is-referral-iphone {\n    padding-bottom: 4rem\n}\n\n.is-referral-iphone .get-started,\n.is-referral-iphone .get-started-sticker,\n.is-referral-iphone .main-footer,\n.is-referral-iphone .main-nav,\n.is-referral-iphone .ribbon,\n.is-referral-iphone a[href^=\"/signup\"] {\n    visibility: hidden\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
